import { sanitizeHtml } from '../utils/sanitizeHtml';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import BBALoader from '../components/BBALoader';
import ReactDOM from 'react-dom';
import { useParams, useNavigate, Navigate, Link } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Edit2, X, Building2, Trash2, Edit, Globe, Copy, ChevronDown, CheckCircle, Clock, Play, Lock, ChevronLeft, ChevronRight, Plus, FileText, RefreshCw, CreditCard, Calendar, CalendarClock, Pin, ArrowLeftRight, Send, Search, LogIn, Eye, History } from 'lucide-react';
import AccountAlaCarteBidsTab from '../components/crm/AccountAlaCarteBidsTab';
import AccountDocumentsTab from '../components/crm/AccountDocumentsTab';
import ClientDebrief from '../components/crm/ClientDebrief';
import ClientProgressTab from '../components/crm/ClientProgressTab';
import AccountTaskTimeTab from '../components/crm/AccountTaskTimeTab';
import ClientBillingSummary from '../components/crm/ClientBillingSummary';
import ContactEmailAliases from '../components/crm/ContactEmailAliases';
import { accountAliasEmails } from '../utils/contactEmailAliases';
import NextPeriodDeliverablesModal from '../components/crm/NextPeriodDeliverablesModal';
import { appendDeliverableChangeLog, buildChangeLogEntry } from '../services/scheduledDeliverableChangesService';
import { getAccountById, updateAccount as writeAccount, updateAccountDeliverableSlice, updateAccountDeliverableQuantity, updateAccountDeliverableQuantityOverride, addAccountPeriodDeliverable, removeAccountPeriodDeliverable, deleteAccount, getAccountPayments, getAccountUsage, getCrmContactDisplayPhotoUrl, getCrmCompanyLogoDisplayUrl, getCrmTeamMemberDisplayPhotoUrl } from '../services/firestoreService';
import { CRM_OWNER_EXECUTIVE_ROLES } from '../services/accessControlService';
import {
  getAccountExpenses,
  addAccountExpense,
  updateAccountExpense,
  deleteAccountExpense,
  parseExpenseDate,
} from '../services/accountExpensesService';
import { getPartners } from '../services/partnersService';
import { getPillarEmoji } from '../utils/portalEmojis';
import { useAuth } from '../contexts/AuthContext';
import {
  PROGRAM_TIERS,
  STORABLE_CLIENT_LIFECYCLES,
  END_REASONS,
  getProgramTier,
  resolveClientLifecycle,
  describeClientLifecycle,
  applyClientLifecycleTransition,
  pendingDerivedCancelPatch,
  hasLeadHistory,
  programMapWith,
} from '../utils/accountLifecycle';
import BackButton from '../components/BackButton';
import PortalBackground from '../components/PortalBackground';
import { storage } from '../firebase';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { createPortalInvite, buildInviteSignupUrl } from '../services/portalInviteService';
import { collection, query, where, getDocs, doc, getDoc, setDoc, updateDoc, deleteDoc, Timestamp, deleteField, onSnapshot, limit } from 'firebase/firestore';
import { getUserByEmail, updateUserActiveStatus } from '../services/firebase/community';
import { db } from '../firebase';
import {
  eventHasFathomSummary,
  loadMeetingSummariesForContext,
  matchEventToMeetingSummary,
} from '../utils/meetingSummaryLookup';
import MeetingSummaryModal from '../components/MeetingSummaryModal';
import { getAllInternalUsers } from '../services/internalUserService';
import { fetchGoogleCalendarEvents } from '../services/googleCalendarService';
import { fetchGmailMessagesForEmailWithStatus } from '../services/gmailService';
import { markUserIntegrationNeedsReauth } from '../services/userIntegrationService';
import GmailConnectionNotice from '../components/GmailConnectionNotice';
import EmailThreadList from '../components/crm/EmailThreadList';
import { PDFService } from '../services/pdfService';
import { getSharedNdaTemplate } from '../services/firebase/ndaTemplateService';
import { getSharedContractTemplate } from '../services/firebase/contractTemplateService';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';
import clientRoadmapService from '../services/clientRoadmapService';
import { fetchClientEventRosterMembers } from '../services/accountTeamMembersService';
import { fetchPortalActivity } from '../services/portalActivityLog';
import MemberEngagementPanel from '../components/crm/MemberEngagementPanel';
import { formatIpLocation } from '../services/ipLocation';
import { logAccountView } from '../services/staffActivityLog';
import { getAccountIntegrationsStatus } from '../services/integrationService';
import { computeCurrentYearRevenue, computeTrailingTwelveMonthRevenue, getQuickBooksRevenueHistory, getQuickBooksYtdRevenue } from '../services/quickbooksService';
import { syncCalendlyMeetings } from '../services/calendlySyncService';
import { PORTAL_PAGE_MAPPING } from '../services/portalAccessService';
import portalAccessEventService from '../services/portalAccessEventService';
import {
  fetchProgramDeliverablesBundle,
  resolveDeliverableProgress,
  getClientActualStartDate,
  getTermEndDateFromAccount,
  resolveAccountLifecycle,
  parseFlexibleAccountDate,
  getCurrentPeriod,
  getAccountStrategyCallPeriod,
  getCurrentDeliverablePeriodKey,
  isMonthlyDeliverablePeriod,
  formatAccountLogDisplayDate,
  groupDeliverableLogsByBillingPeriod,
  getRenewsOnDateFromAccount,
  isOneTimeStylePeriod,
  filterLogsForCurrentPeriod,
  MINIMUM_TERM_OPTIONS,
  getMinimumTermOption,
} from '../utils/accountProgramDeliverables';
import { computeCustomProgramMonthlyBaseFromAccount, isStrategyCallDeliverableName } from '../utils/programPricing';
const GOOGLE_EVENT_PREFIX_CONST = 'google_';

// Portal pages that have access toggles in ClientOverview; all other mapped pages are always full access
const PORTAL_PAGE_TOGGLE_KEYS = [
  'courses', 'calendar', 'community', 'sales', 'operations', 'technology',
  'finance', 'marketing', 'hr', 'tasks', 'events', 'roadmap', 'collection', 'conference'
];

/** For matching Google invites: attendee list may omit organizer; Gmail +tags / dots should still match roster. */
function canonicalCalendarEmailKey(email) {
  const raw = String(email || '').trim().toLowerCase();
  if (!raw) return '';
  const at = raw.lastIndexOf('@');
  if (at < 1) return raw;
  const local = raw.slice(0, at);
  const domain = raw.slice(at + 1);
  if (domain === 'gmail.com' || domain === 'googlemail.com') {
    const baseLocal = local.split('+')[0]?.replace(/\./g, '') || '';
    return `${baseLocal}@${domain}`;
  }
  return raw;
}

/** Normalize invitee display strings for comparisons when Calendar omits attendee emails. */
function calendarParticipantDisplayNormalized(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

function calendarNamesLikelyMatch(rosterName, calendarName) {
  const a = calendarParticipantDisplayNormalized(rosterName);
  const b = calendarParticipantDisplayNormalized(calendarName);
  if (!a || !b) return false;
  if (a === b) return true;
  const aParts = a.split(' ').filter(Boolean);
  const bParts = b.split(' ').filter(Boolean);
  if (aParts.length >= 2 && bParts.length >= 2) {
    return aParts[0] === bParts[0] && aParts[aParts.length - 1] === bParts[bParts.length - 1];
  }
  return a.includes(b) || b.includes(a);
}

/**
 * Most saves on this page send the page's whole copy of the account, which can be minutes old.
 * Writing its `billing` map back reverted Stripe syncs and Billing-tab values saved since the page
 * loaded (manual monthly expenses kept "not saving"), so whole-account saves leave `billing` out —
 * billing changes go through dotted 'billing.<field>' paths instead.
 */
function updateAccount(accountId, data) {
  const { billing, ...rest } = data || {};
  return writeAccount(accountId, rest);
}

/** 1–5 for CRM check-in cards; aligns with numeric rating or legacy overallStatus. */
function getCheckInCardStarCount(checkIn) {
  const raw = checkIn.overallSatisfaction ?? checkIn.rating;
  if (raw != null && raw !== '') {
    const n = Number(raw);
    if (!Number.isNaN(n) && n > 0 && n <= 5) {
      return Math.min(5, Math.max(1, Math.round(n)));
    }
  }
  if (checkIn.overallStatus === 'Good') return 5;
  if (checkIn.overallStatus === 'Okay') return 3;
  if (checkIn.overallStatus === 'Not Good') return 1;
  return null;
}

/** "0.5" for halves, "2" for whole numbers — used for hour-based completion amounts. */
const formatDeliverableQty = (v) => (Number.isInteger(v) ? String(v) : v.toFixed(1));

/**
 * One circle in a deliverable's progress row. Fill is threshold-based so
 * hour-pool items (Implementation Hours) logged in 0.5 steps render a
 * half-filled circle; `booked` extends the fill in blue past the completed
 * portion (Calendly-booked but not yet held).
 */
const DeliverableProgressCircle = ({ n, completed = 0, booked = 0, title }) => {
  const bookedThrough = completed + booked;
  const fullGreen = completed >= n;
  const fullBlue = !fullGreen && bookedThrough >= n;
  const halfGreen = !fullGreen && completed >= n - 0.5;
  const halfBlue = !fullGreen && !fullBlue && !halfGreen && bookedThrough >= n - 0.5;
  const baseClass = fullGreen
    ? 'bg-green-500 text-white'
    : fullBlue
      ? 'bg-blue-400 text-white'
      : 'bg-gray-300 dark:bg-gray-600 text-gray-600 dark:text-gray-400';
  const halfOverlay = halfGreen ? 'bg-green-500' : halfBlue ? 'bg-blue-400' : null;
  return (
    <div
      title={title}
      className={`relative overflow-hidden w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold ${baseClass}`}
    >
      {halfOverlay && <span className={`absolute inset-y-0 left-0 w-1/2 ${halfOverlay}`} aria-hidden="true" />}
      <span className="relative">{n}</span>
    </div>
  );
};

function isCheckInCardAwaitingCompletion(checkIn) {
  const sat = checkIn.overallSatisfaction ?? checkIn.rating;
  return checkIn.status === 'pending' || ((!sat || sat === '') && !checkIn.overallStatus);
}

const normCheckInEmail = (e) => String(e || '').trim().toLowerCase();

function mapCheckInFirestoreDoc(docSnap) {
  const data = docSnap.data();
  return {
    id: docSnap.id,
    ...data,
    submittedAt: data.submittedAt?.toDate?.() || (data.submittedAt ? new Date(data.submittedAt) : null),
    scheduledDate: data.scheduledDate?.toDate?.() || (data.scheduledDate ? new Date(data.scheduledDate) : null),
    createdAt: data.createdAt?.toDate?.() || (data.createdAt ? new Date(data.createdAt) : null),
  };
}

function monthLabelFromCheckInDate(value) {
  const d = value?.toDate?.() || (value ? new Date(value) : null);
  if (!d || Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
}

function sortCheckInsForDisplay(list) {
  return [...list].sort((a, b) => {
    const aPending = isCheckInCardAwaitingCompletion(a);
    const bPending = isCheckInCardAwaitingCompletion(b);
    if (aPending !== bPending) return aPending ? -1 : 1;
    const dateA = a.submittedAt || a.scheduledDate || a.sentAt || a.createdAt || new Date(0);
    const dateB = b.submittedAt || b.scheduledDate || b.sentAt || b.createdAt || new Date(0);
    return dateB - dateA;
  });
}

function isCustomProgramContractContext(contractData, account) {
  const p = contractData?.program || account?.program?.status || account?.program?.name || '';
  const tier = contractData?.tier || account?.signedContract?.tier || '';
  const status = account?.program?.status || '';
  return (
    tier === 'Custom' ||
    status === 'Custom' ||
    p === 'Custom' ||
    p === 'Custom Program' ||
    /custom\s*program/i.test(String(p))
  );
}

const CLIENT_OVERVIEW_PINNED_CONTACT_STORAGE_PREFIX = 'clientOverview:pinnedContactKey:';

function sortSidebarContactsWithPinnedFirst(contacts, pinnedKey) {
  if (!contacts?.length) return [];
  const list = [...contacts];
  if (!pinnedKey) return list;
  const idx = list.findIndex((c) => c.key === pinnedKey);
  if (idx <= 0) return list;
  const [pinned] = list.splice(idx, 1);
  return [pinned, ...list];
}

const ClientOverview = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const currentUser = auth?.currentUser;
  const [account, setAccount] = useState(null);
  const [originalEmail, setOriginalEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('summary');
  const [editingField, setEditingField] = useState(null);
  const [editValue, setEditValue] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false);
  const [editingPaymentId, setEditingPaymentId] = useState(null);
  const [newPayment, setNewPayment] = useState({
    amount: '',
    dueDate: '',
    status: 'processing'
  });
  /** Billing tab expenses (accounts/{id}/expenses subcollection) */
  const [accountExpenses, setAccountExpenses] = useState([]);
  const [partnerOptions, setPartnerOptions] = useState([]);
  const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
  const [editingExpenseId, setEditingExpenseId] = useState(null);
  const [expenseSaving, setExpenseSaving] = useState(false);
  const [newExpense, setNewExpense] = useState({
    amount: '',
    date: '',
    status: 'paid',
    subcontractorId: '',
    subcontractorName: ''
  });
  const [showACHModal, setShowACHModal] = useState(false);
  const [showACHUploadModal, setShowACHUploadModal] = useState(false);
  const [showSensitiveData, setShowSensitiveData] = useState(false);
  const [showNDAModal, setShowNDAModal] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);
  const [signedNDA, setSignedNDA] = useState(null);
  const [contractData, setContractData] = useState(null);
  const [programPriceData, setProgramPriceData] = useState(null);
  const [loadedProgramPrice, setLoadedProgramPrice] = useState(null);
  const [stripePayments, setStripePayments] = useState([]);
  const [stripeUsage, setStripeUsage] = useState(null);
  const [syncBillingLoading, setSyncBillingLoading] = useState(false);
  /** Billing tab: free-form internal note stored on account.billing.note */
  const [billingNoteDraft, setBillingNoteDraft] = useState('');
  const [billingNoteSaving, setBillingNoteSaving] = useState(false);
  const [editingBillingNote, setEditingBillingNote] = useState(false);
  const [availableItems, setAvailableItems] = useState([]);
  /** Access tab: manual Stripe customer / subscription ids when webhooks or checkout linked wrong */
  const [stripeBillingLinkDraft, setStripeBillingLinkDraft] = useState({ customerId: '', subscriptionId: '' });
  const [stripeBillingLinkSaving, setStripeBillingLinkSaving] = useState(false);
  /** Access tab: "Match to Stripe customer" picker — search Stripe by name/email and link the right record */
  const [showStripeMatchModal, setShowStripeMatchModal] = useState(false);
  const [stripeMatchQuery, setStripeMatchQuery] = useState('');
  const [stripeMatchResults, setStripeMatchResults] = useState([]);
  const [stripeMatchLoading, setStripeMatchLoading] = useState(false);
  const [stripeMatchError, setStripeMatchError] = useState('');
  const [stripeMatchSearched, setStripeMatchSearched] = useState(false);
  /** Set after a picked match is saved to Firestore — drives the green "matched & saved" banner */
  const [stripeMatchSaved, setStripeMatchSaved] = useState(null);
  /** clientId we already auto-synced billing from Stripe for (avoids re-syncing every Billing tab visit) */
  const stripeAutoSyncedRef = useRef(null);

  const isDevelopment = process.env.NODE_ENV === 'development';

  const clientActualStartDate = useMemo(
    () => getClientActualStartDate(account, contractData),
    [account, contractData]
  );

  const lifecycle = useMemo(
    () => resolveAccountLifecycle(account, contractData),
    [account, contractData]
  );

  // Active / Canceling / Canceled / Lost / Archived — the one lifecycle rule (accountLifecycle.js).
  const clientLifecycle = useMemo(() => resolveClientLifecycle(account), [account]);

  // Load program price when contract modal opens
  useEffect(() => {
    const loadProgramPrice = async () => {
      if (!showContractModal) {
        setLoadedProgramPrice(null);
        return;
      }

      const contract = contractData || account?.signedContract || account?.contractData;
      const programName = contract?.program || account?.program?.status || account?.program?.name;
      const billingCycle = contract?.billingCycle || account?.billingCycle || account?.program?.billingCycle || 'monthly';
      const bc = String(billingCycle).toLowerCase();

      const applyCycle = (basePrice) => {
        if (!basePrice || basePrice <= 0) return null;
        if (bc === 'quarterly' || bc === 'quarter') return Math.round(basePrice * 3 * 0.9);
        if (bc === 'annual' || bc === 'year') return Math.round(basePrice * 12 * 0.8);
        return basePrice;
      };

      // Custom deliverables: sum matches Checkout / contract variable display
      if (
        isCustomProgramContractContext(contract, account) &&
        account?.customProgramDeliverables?.length > 0 &&
        availableItems?.length > 0
      ) {
        const baseCustom = computeCustomProgramMonthlyBaseFromAccount(account, availableItems, billingCycle);
        const cycled = applyCycle(baseCustom);
        if (cycled != null) {
          setLoadedProgramPrice(cycled);
          return;
        }
      }

      if (programName) {
        try {
          let programDoc = null;
          const tryIds = [programName];
          if (programName === 'Custom Program' || /custom/i.test(String(programName))) {
            tryIds.push('Custom');
          }
          for (const pid of tryIds) {
            try {
              const d = await getDoc(doc(db, 'programs', pid));
              if (d.exists()) {
                programDoc = d;
                break;
              }
            } catch (e) {
              /* try next */
            }
          }
          if (!programDoc || !programDoc.exists()) {
            const programsSnapshot = await getDocs(collection(db, 'programs'));
            programsSnapshot.forEach((d) => {
              if (!programDoc && d.data().name === programName) {
                programDoc = d;
              }
            });
          }

          if (programDoc && programDoc.exists()) {
            const pdata = programDoc.data();
            const basePrice = pdata.pricePerMonth || pdata.monthlyPrice || pdata.price;
            const calculatedPrice = applyCycle(basePrice);
            if (calculatedPrice != null) {
              setLoadedProgramPrice(calculatedPrice);
              return;
            }
          }
        } catch (error) {
          console.error('Error loading program price:', error);
        }
      }
      setLoadedProgramPrice(null);
    };

    loadProgramPrice();
  }, [showContractModal, contractData, account, availableItems]);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [uploadingCompanyLogo, setUploadingCompanyLogo] = useState(false);
  const [companyLogoDragOver, setCompanyLogoDragOver] = useState(false);
  const companyLogoDropDepthRef = useRef(0);
  const [communityStatus, setCommunityStatus] = useState('Inactive');
  const [showPromoteModal, setShowPromoteModal] = useState(false);
  const [hasPortalAccount, setHasPortalAccount] = useState(false);
  const [isInvitingToPortal, setIsInvitingToPortal] = useState(false);
  const [showInviteLinkModal, setShowInviteLinkModal] = useState(false);
  const [generatedInviteLink, setGeneratedInviteLink] = useState('');
  const [inviteModalRecipient, setInviteModalRecipient] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamMembersLoading, setTeamMembersLoading] = useState(false);
  /** Bump to re-pull the roster (e.g. after a new invite is generated) */
  const [teamMembersRefreshKey, setTeamMembersRefreshKey] = useState(0);
  const [showAddTeamMemberModal, setShowAddTeamMemberModal] = useState(false);
  const [newTeamMemberForm, setNewTeamMemberForm] = useState({ firstName: '', lastName: '', email: '' });
  const [isAddingTeamMember, setIsAddingTeamMember] = useState(false);
  /** Roster id of the member whose invite link was just copied (for button feedback) */
  const [copiedInviteMemberId, setCopiedInviteMemberId] = useState(null);
  /** Roster id (invite:<docId>) of a pending invite currently being deleted */
  const [deletingInviteId, setDeletingInviteId] = useState(null);
  /** Firestore users doc id while a team member headshot is uploading */
  const [uploadingTeamMemberPhotoId, setUploadingTeamMemberPhotoId] = useState(null);
  /** Access tab: merged logins + page views for the client and their team members */
  const [portalActivityRows, setPortalActivityRows] = useState([]);
  const [portalActivityLoading, setPortalActivityLoading] = useState(false);
  /** How many activity rows are shown before "Show more" */
  const [portalActivityVisibleCount, setPortalActivityVisibleCount] = useState(15);
  /** Drag-over highlight for contact / team photo drop targets (e.g. sidebar-primary, sidebar-portal:uid, access:uid) */
  const [photoDropHighlightKey, setPhotoDropHighlightKey] = useState(null);
  const [pinnedSidebarContactKey, setPinnedSidebarContactKey] = useState(null);
  const [sidebarLeadContactIndex, setSidebarLeadContactIndex] = useState(0);
  const [achFormData, setAchFormData] = useState({
    accountType: '',
    bankName: '',
    routingNumber: '',
    accountNumber: '',
    nameOnAccount: ''
  });
  const [achFormErrors, setAchFormErrors] = useState({});
  const [programItems, setProgramItems] = useState([]);
  const [showDeliverableModal, setShowDeliverableModal] = useState(false);
  const [selectedDeliverable, setSelectedDeliverable] = useState(null);
  const [deliverableUpdate, setDeliverableUpdate] = useState({
    completed: 0,
    date: '',
    period: '',
    completedWith: ''
  });
  const [deliverableLogs, setDeliverableLogs] = useState([]);
  const [deliverableLogPeriodIndex, setDeliverableLogPeriodIndex] = useState(0);
  const [activeDeliverableTab, setActiveDeliverableTab] = useState('update');
  const [showCompletedWithDropdown, setShowCompletedWithDropdown] = useState(false);
  const [showAddDeliverablePicker, setShowAddDeliverablePicker] = useState(false);
  // Next-period modal: stage deliverable changes that apply on the reset date + view the change log.
  const [showNextPeriodModal, setShowNextPeriodModal] = useState(false);
  // "This period only" mode for the Add-deliverable picker: adds a one-off deliverable pinned to
  // the client's current billing period instead of a recurring one.
  const [addPeriodOnly, setAddPeriodOnly] = useState(false);
  const [addPeriodOnlyQty, setAddPeriodOnlyQty] = useState(1);
  const [deliverableQuantityEditing, setDeliverableQuantityEditing] = useState(false);
  const [deliverableEditQuantity, setDeliverableEditQuantity] = useState(1);
  const [clientEvents, setClientEvents] = useState([]);
  const [accountMeetingSummaries, setAccountMeetingSummaries] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(false);
  const [eventsFilter, setEventsFilter] = useState('all');
  const [eventsCurrentPage, setEventsCurrentPage] = useState(1);
  const eventsPerPage = 6;
  const [clientEmails, setClientEmails] = useState([]);
  // Internal users whose Gmail is disconnected / needs reconnecting, so the Emails
  // tab can say so instead of silently showing "No emails found"
  const [gmailDisconnectedUsers, setGmailDisconnectedUsers] = useState([]);
  const [emailsLoading, setEmailsLoading] = useState(false);
  const [emailsFilter, setEmailsFilter] = useState('all');
  const [showMeetingSummaryModal, setShowMeetingSummaryModal] = useState(false);
  const [selectedEventForSummary, setSelectedEventForSummary] = useState(null);
  const [meetingSummary, setMeetingSummary] = useState(null);
  const [meetingSummaryLoading, setMeetingSummaryLoading] = useState(false);
  const [internalUsers, setInternalUsers] = useState([]);
  const [showSuccessManagerPopup, setShowSuccessManagerPopup] = useState(false);
  const [showLockModal, setShowLockModal] = useState(false);
  const [isLocking, setIsLocking] = useState(false);
  const [clientIntegrations, setClientIntegrations] = useState({ jobtread: false, quickbooks: false });
  const [clientIntegrationsLoading, setClientIntegrationsLoading] = useState(false);
  const [qbCurrentRevenue, setQbCurrentRevenue] = useState(null);
  const [qbRevenueLoading, setQbRevenueLoading] = useState(false);
  const [showOnKanban, setShowOnKanban] = useState(true);
  const [lostReason, setLostReason] = useState(null);
  const [checkIns, setCheckIns] = useState([]);
  const [checkInsLoading, setCheckInsLoading] = useState(false);
  const [selectedCheckIn, setSelectedCheckIn] = useState(null);
  const [showCheckInDetailsModal, setShowCheckInDetailsModal] = useState(false);
  const [sendingCheckInManual, setSendingCheckInManual] = useState(false);
  /** Bumps on every loadProgramData start; ignore async completions from other runs (prevents flicker / reset). */
  const loadProgramDataGenerationRef = useRef(0);
  const [roadmapTemplates, setRoadmapTemplates] = useState([]);
  const [roadmapLoading, setRoadmapLoading] = useState(false);
  const [roadmapCurrentPage, setRoadmapCurrentPage] = useState(1);
  const roadmapPerPage = 12;
  const [internalCrmRole, setInternalCrmRole] = useState(null);
  const [internalCrmTeam, setInternalCrmTeam] = useState(null);
  const [currentUserCalendlyConnected, setCurrentUserCalendlyConnected] = useState(false);
  const [calendlySyncing, setCalendlySyncing] = useState(false);

  useEffect(() => {
    if (!isEditMode) {
      companyLogoDropDepthRef.current = 0;
      setCompanyLogoDragOver(false);
    }
  }, [isEditMode]);

  const handleEditPayment = (payment) => {
    setNewPayment({
      amount: payment.amount,
      dueDate: payment.dueDate,
      status: payment.status
    });
    setEditingPaymentId(payment.id);
    setShowAddPaymentModal(true);
  };

  // Load internal users
  const loadInternalUsers = async () => {
    try {
      const users = await getAllInternalUsers();
      const formattedUsers = users.map(user => ({
        id: user.id,
        name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.displayName || 'Unknown User',
        initials: `${user.firstName?.[0] || ''}${user.lastName?.[0] || ''}`.toUpperCase() || user.displayName?.[0] || 'U',
        profileImage: user.profileImage || user.photoURL || user.profilePicture || null,
        email: user.email,
        role: user.role || 'Member'
      }));
      setInternalUsers(formattedUsers);
    } catch (error) {
      console.error('Error loading internal users:', error);
    }
  };

  const initialsFromGoogleAttendeeDisplayName = (displayName, fallbackEmail = '') => {
    const trimmed = String(displayName || '').trim();
    const parts = trimmed.split(/\s+/).filter(Boolean);
    let initials = 'U';
    if (parts.length >= 2) {
      initials = `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    } else if (parts.length === 1 && parts[0].length >= 2) {
      initials = parts[0].substring(0, 2).toUpperCase();
    } else if (fallbackEmail) {
      const local = fallbackEmail.split('@')[0]?.replace(/\./g, ' ') || '';
      const lp = local.split(/\s+/).filter(Boolean);
      initials =
        lp.length >= 2
          ? `${lp[0][0]}${lp[lp.length - 1][0]}`.toUpperCase()
          : (local[0] || 'U').toUpperCase();
    }
    return initials;
  };

  /** Merge attendees + organizer/creator rows (Calendar often drops organizer from attendees[]). Matches roster via canonical Gmail keys (+aliases, dots). */
  const buildClientInviteesForCalendarEvent = (
    event,
    hostInfo,
    clientRosterKeys,
    teamByCanonicalEmail,
    internalCanonicalKeys,
    rosterTeamMembers
  ) => {
    const mergedRows = [];
    const mergeKeys = new Set();
    const appendRow = (email, displayName) => {
      const k = canonicalCalendarEmailKey(email);
      if (!k || mergeKeys.has(k)) return;
      mergeKeys.add(k);
      mergedRows.push({
        email: String(email || '').trim(),
        displayName: String(displayName || '').trim(),
      });
    };

    for (const a of event.attendees || []) appendRow(a.email, a.displayName);
    appendRow(event.organizer?.email, event.organizer?.displayName);
    appendRow(event.creator?.email, event.creator?.displayName);

    // Guest privacy / stray resource emails — map display names (and mismatched mails) onto roster inbox
    const primaryLeadDn = calendarParticipantDisplayNormalized(
      [account.contact?.firstName, account.contact?.lastName].filter(Boolean).join(' ')
    );
    for (const a of event.attendees || []) {
      const keyFromEmail = canonicalCalendarEmailKey(a.email);
      if (keyFromEmail && clientRosterKeys.has(keyFromEmail)) continue;

      const dn = calendarParticipantDisplayNormalized(a.displayName);
      if (!dn) continue;
      if (primaryLeadDn && dn === primaryLeadDn) {
        appendRow(account?.contact?.email || account?.email || '', a.displayName);
        continue;
      }
      for (const tm of rosterTeamMembers || []) {
        if (calendarNamesLikelyMatch(tm.name, dn) && tm.email) {
          appendRow(tm.email, a.displayName || tm.name);
          break;
        }
      }
    }

    for (const member of rosterTeamMembers || []) {
      if (!member?.email || member.isPrimary) continue;
      const memberKey = canonicalCalendarEmailKey(member.email);
      if (!memberKey || !clientRosterKeys.has(memberKey)) continue;

      const attendeeMatchesMember = (a) => {
        const attendeeKey = canonicalCalendarEmailKey(a?.email);
        if (attendeeKey && attendeeKey === memberKey) return true;
        return calendarNamesLikelyMatch(member.name, a?.displayName);
      };

      const onInvite =
        (event.attendees || []).some(attendeeMatchesMember) ||
        calendarNamesLikelyMatch(member.name, event.organizer?.displayName) ||
        calendarNamesLikelyMatch(member.name, event.creator?.displayName);

      if (onInvite) {
        appendRow(member.email, member.name);
      }
    }

    const hostCanonKey = canonicalCalendarEmailKey(hostInfo?.email);
    const primaryEmailKey = canonicalCalendarEmailKey(account?.contact?.email || account?.email);

    const list = [];
    const seenOutKeys = new Set();

    for (const att of mergedRows) {
      const key = canonicalCalendarEmailKey(att.email);
      if (!key || !clientRosterKeys.has(key)) continue;
      if (internalCanonicalKeys.has(key)) continue;
      if (hostCanonKey && key === hostCanonKey) continue;
      if (seenOutKeys.has(key)) continue;
      seenOutKeys.add(key);

      const member = teamByCanonicalEmail.get(key);
      const displayFromApi = String(att.displayName || '').trim();
      const isPrimaryInvitee =
        !!member?.isPrimary || !!(primaryEmailKey && key === primaryEmailKey);
      if (member) {
        const initials =
          `${member.firstName?.[0] || ''}${member.lastName?.[0] || ''}`.toUpperCase() ||
          initialsFromGoogleAttendeeDisplayName(displayFromApi, member.email);
        list.push({
          id: member.id,
          kind: isPrimaryInvitee ? 'primary' : 'team',
          name: member.name,
          initials,
          profileImage:
            getCrmTeamMemberDisplayPhotoUrl(account, member.id) || member.profileImage || null,
          email: member.email || att.email,
        });
      } else {
        const rosterMember = (rosterTeamMembers || []).find(
          (m) => canonicalCalendarEmailKey(m.email) === key
        );
        const isPrimaryInvitee =
          !!rosterMember?.isPrimary || !!(primaryEmailKey && key === primaryEmailKey);
        const nameCandidate =
          displayFromApi ||
          rosterMember?.name ||
          [account.contact?.firstName, account.contact?.lastName].filter(Boolean).join(' ') ||
          att.email ||
          'Guest';
        list.push({
          id: rosterMember?.id || `client-email:${key}`,
          kind: isPrimaryInvitee ? 'primary' : 'team',
          name: nameCandidate,
          initials: initialsFromGoogleAttendeeDisplayName(nameCandidate, att.email || key),
          profileImage:
            (rosterMember && getCrmTeamMemberDisplayPhotoUrl(account, rosterMember.id)) ||
            rosterMember?.profileImage ||
            getCrmContactDisplayPhotoUrl(account) ||
            null,
          email: att.email,
        });
      }
    }

    return list;
  };

  // Fetch Google Calendar events for the client
  const fetchClientEvents = async (rosterTeamMembers = teamMembers) => {
    const DEV_EVENTS = process.env.NODE_ENV === 'development';
    const clientRosterKeys = new Set();
    /** Lowercase trimmed emails — used for attendee matching and description/title hints */
    const rosterRawLowerEmails = new Set();

    const addRosterEmail = (email) => {
      const t = String(email || '').trim();
      if (!t) return;
      rosterRawLowerEmails.add(t.toLowerCase());
      const key = canonicalCalendarEmailKey(t);
      if (key) clientRosterKeys.add(key);
    };

    addRosterEmail(account?.contact?.email);
    addRosterEmail(account?.email);
    addRosterEmail(account?.discovery?.email);
    accountAliasEmails(account).forEach(addRosterEmail);
    for (const m of rosterTeamMembers || []) {
      addRosterEmail(m.email);
      for (const alt of m.alternateEmails || []) addRosterEmail(alt);
    }

    if (DEV_EVENTS) {
      console.log('[Events] fetchClientEvents roster built', {
        rosterKeys: [...clientRosterKeys],
        rosterEmails: [...rosterRawLowerEmails],
        teamMemberCount: (rosterTeamMembers || []).length,
        internalUserCount: internalUsers.length,
        accountId: account?.id,
      });
    }

    const primaryLeadDn = calendarParticipantDisplayNormalized(
      [account.contact?.firstName, account.contact?.lastName].filter(Boolean).join(' ')
    );

    if (!account || !internalUsers.length) {
      if (DEV_EVENTS) console.log('[Events] Bailing: no account or no internal users');
      setClientEvents([]);
      return;
    }

    if (clientRosterKeys.size === 0) {
      if (DEV_EVENTS) console.log('[Events] WARNING: clientRosterKeys empty — no client emails found. Events will not match unless description blob contains email text.');
    }

    const teamByCanonicalEmail = new Map();
    for (const m of rosterTeamMembers || []) {
      const keys = [
        canonicalCalendarEmailKey(m.email),
        ...(m.alternateEmails || []).map(canonicalCalendarEmailKey),
      ].filter(Boolean);
      for (const ck of keys) {
        if (ck && !teamByCanonicalEmail.has(ck)) teamByCanonicalEmail.set(ck, m);
      }
    }

    const internalCanonicalKeys = new Set(
      internalUsers.map((u) => canonicalCalendarEmailKey(u.email)).filter(Boolean)
    );

    /** Returns a string describing the first match reason, or null if no match. */
    const eventMatchReason = (event) => {
      const touchesEmailField = (em) => {
        const k = canonicalCalendarEmailKey(em);
        return !!(k && clientRosterKeys.has(k));
      };

      const attendeeMatchReason = (a) => {
        if (touchesEmailField(a?.email)) return `attendee email "${a.email}"`;
        const dn = calendarParticipantDisplayNormalized(a?.displayName);
        if (!dn) return null;
        if (primaryLeadDn && dn === primaryLeadDn) return `attendee display name matches primary contact "${dn}"`;
        for (const m of rosterTeamMembers || []) {
          if (calendarNamesLikelyMatch(m.name, dn)) return `attendee name "${dn}" matches roster member "${m.name}"`;
        }
        return null;
      };

      for (const a of event.attendees || []) {
        const r = attendeeMatchReason(a);
        if (r) return r;
      }
      if (touchesEmailField(event.organizer?.email)) return `organizer email "${event.organizer?.email}"`;
      if (touchesEmailField(event.creator?.email)) return `creator email "${event.creator?.email}"`;

      const blob = [
        event.title,
        event.summary,
        event.description,
        event.location,
      ]
        .filter(Boolean)
        .join('\n')
        .toLowerCase();
      for (const em of rosterRawLowerEmails) {
        if (em.length >= 5 && blob.includes(em)) return `email "${em}" in event text`;
      }

      return null;
    };

    const eventTouchesClientRoster = (event) => {
      return eventMatchReason(event) !== null;
    };

    try {
      setEventsLoading(true);

      // Get date range (past 6 months to future 6 months)
      const now = new Date();
      const startDate = new Date();
      startDate.setMonth(startDate.getMonth() - 6);
      const endDate = new Date();
      endDate.setMonth(endDate.getMonth() + 6);

      // Fetch events from all internal users who have Google Calendar connected
      const eventMap = new Map(); // Use Map to deduplicate by event ID

      for (const user of internalUsers) {
        try {
          const events = await fetchGoogleCalendarEvents(user.id, startDate, endDate);

          if (DEV_EVENTS) {
            console.log(`[Events] user "${user.name}" (${user.id}): fetched ${events.length} events`);
            let passCount = 0;
            let failReasons = {};
            for (const ev of events) {
              const reason = eventMatchReason(ev);
              if (reason) {
                passCount++;
              } else {
                // Summarise why it was dropped
                const hasAttendees = (ev.attendees || []).length > 0;
                const bucket = hasAttendees ? 'has-attendees-no-match' : 'no-attendees';
                failReasons[bucket] = (failReasons[bucket] || 0) + 1;
              }
            }
            console.log(`[Events]   → ${passCount} passed, ${events.length - passCount} filtered`, failReasons);
          }

          const relevantEvents = events.filter(eventTouchesClientRoster);

          for (const event of relevantEvents) {
            if (DEV_EVENTS) {
              console.log(`[Events]   ✓ "${event.title || event.summary}" matched: ${eventMatchReason(event)}`);
            }

            // Use googleEventId if id looks like a prefixed wrapper; prefer the raw Google ID for deduplication
            const rawGoogleId = event.googleEventId || null;
            const prefixedId = event.id || null;
            // Dedupe by the most stable key: raw Google ID stripped of prefix, falling back to prefixed
            const dedupeKey = rawGoogleId || (prefixedId ? prefixedId.replace(/^google_/, '') : null) || prefixedId;

            const rawOrgEmail = event.organizer?.email || event.creator?.email;
            const gcs = event.googleCalendarId;
            const calendarEmailHint =
              typeof gcs === 'string' && gcs.includes('@') ? gcs : '';
            const organizerForLookup =
              rawOrgEmail && String(rawOrgEmail).trim().toLowerCase() !== 'primary'
                ? rawOrgEmail
                : calendarEmailHint;

            let host = organizerForLookup
              ? internalUsers.find(
                  (u) =>
                    canonicalCalendarEmailKey(u.email) ===
                    canonicalCalendarEmailKey(organizerForLookup)
                )
              : null;

            if (!host) {
              host = user;
            }

            const hostInfo = host
              ? {
                  id: host.id,
                  name: host.name,
                  profileImage: host.profileImage,
                  initials: host.initials,
                  email: host.email,
                }
              : {
                  id: null,
                  name:
                    event.organizer?.displayName ||
                    event.creator?.displayName ||
                    event.organizer?.email ||
                    event.creator?.email ||
                    'Unknown',
                  profileImage: null,
                  initials: (
                    event.organizer?.displayName ||
                    event.creator?.displayName ||
                    event.organizer?.email ||
                    event.creator?.email ||
                    'U'
                  )
                    .substring(0, 2)
                    .toUpperCase(),
                  email: event.organizer?.email || event.creator?.email,
                };

            const hostCanonKey = canonicalCalendarEmailKey(hostInfo.email);

            // Check if we already have this event (deduped by stable Google event ID)
            if (dedupeKey && eventMap.has(dedupeKey)) {
              const existingEvent = eventMap.get(dedupeKey);

              // Merge internal attendees
              const isAlreadyAdded = existingEvent.internalAttendees.some((a) => a.id === user.id);
              if (!isAlreadyAdded && user.id !== existingEvent.host.id) {
                existingEvent.internalAttendees.push({
                  id: user.id,
                  name: user.name,
                  profileImage: user.profileImage,
                  initials: user.initials,
                  email: user.email,
                });
              }

              // Merge client invitees from this copy of the event
              const moreInvitees = buildClientInviteesForCalendarEvent(
                event,
                existingEvent.host,
                clientRosterKeys,
                teamByCanonicalEmail,
                internalCanonicalKeys,
                rosterTeamMembers
              );
              const byCanonInvitee = new Map(
                (existingEvent.clientInvitees || []).map((inv) => [
                  canonicalCalendarEmailKey(inv.email) || inv.id,
                  inv,
                ])
              );
              for (const inv of moreInvitees) {
                const ck = canonicalCalendarEmailKey(inv.email) || inv.id;
                if (ck && !byCanonInvitee.has(ck)) byCanonInvitee.set(ck, inv);
              }
              existingEvent.clientInvitees = Array.from(byCanonInvitee.values());

              // Preserve the most complete set of attendees
              if ((event.attendees || []).length > (existingEvent.attendees || []).length) {
                existingEvent.attendees = event.attendees;
              }
            } else {
              // Add new event with host and internal attendees
              const internalAttendees = [];

              // Find other internal users who are attendees (excluding host)
              const attendees = event.attendees || [];
              for (const attendee of attendees) {
                const attendeeKey = canonicalCalendarEmailKey(attendee.email);
                const internalUser = internalUsers.find(
                  (u) =>
                    canonicalCalendarEmailKey(u.email) === attendeeKey &&
                    attendeeKey !== hostCanonKey &&
                    u.id !== hostInfo.id
                );
                if (internalUser && !internalAttendees.some((a) => a.id === internalUser.id)) {
                  internalAttendees.push({
                    id: internalUser.id,
                    name: internalUser.name,
                    profileImage: internalUser.profileImage,
                    initials: internalUser.initials,
                    email: internalUser.email,
                  });
                }
              }

              const clientInvitees = buildClientInviteesForCalendarEvent(
                event,
                hostInfo,
                clientRosterKeys,
                teamByCanonicalEmail,
                internalCanonicalKeys,
                rosterTeamMembers
              );

              // Store under the stable dedupeKey, but keep original event.id for rendering
              const mapKey = dedupeKey || `nokey_${event.title}_${event.start}`;
              eventMap.set(mapKey, {
                ...event,
                // Normalise id fields so summary matching has both forms available
                id: prefixedId || (rawGoogleId ? `${GOOGLE_EVENT_PREFIX_CONST}${rawGoogleId}` : mapKey),
                googleEventId: rawGoogleId || prefixedId,
                host: hostInfo,
                internalAttendees,
                clientInvitees,
              });
            }
          }
        } catch (error) {
          console.error(`Error fetching events for user ${user.id}:`, error);
          // Continue with other users even if one fails
        }
      }

      // Convert map to array and sort events by start date (newest first)
      const allEvents = Array.from(eventMap.values());
      allEvents.sort((a, b) => {
        const aDate = new Date(a.start || a.startTime);
        const bDate = new Date(b.start || b.startTime);
        return bDate - aDate; // Reverse order: newest first
      });

      if (process.env.NODE_ENV === 'development') {
        console.log(`[Events] fetchClientEvents complete: ${allEvents.length} total events`);
      }

      setClientEvents(allEvents);
    } catch (error) {
      console.error('Error fetching client events:', error);
      setClientEvents([]);
    } finally {
      setEventsLoading(false);
    }
  };

  const handleUpdatePayment = async (paymentId, updatedPayment) => {
    try {
      const updatedPayments = account.billing?.payments?.map(p => 
        p.id === paymentId ? { ...p, ...updatedPayment } : p
      ) || [];
      
      // Update the account state immediately
      const updatedAccount = {
        ...account,
        billing: {
          ...account.billing,
          payments: updatedPayments
        }
      };
      setAccount(updatedAccount);

      // Save to database
      await writeAccount(clientId, { 'billing.payments': updatedPayments });
    } catch (error) {
      console.error('Error updating payment:', error);
      alert('Failed to update payment. Please try again.');
    }
  };

  const handleDeletePayment = async (paymentId) => {
    try {
      const updatedPayments = account.billing?.payments?.filter(p => p.id !== paymentId) || [];
      
      // Update the account state immediately
      const updatedAccount = {
        ...account,
        billing: {
          ...account.billing,
          payments: updatedPayments
        }
      };
      setAccount(updatedAccount);

      // Save to database
      await writeAccount(clientId, { 'billing.payments': updatedPayments });
    } catch (error) {
      console.error('Error deleting payment:', error);
      alert('Failed to delete payment. Please try again.');
    }
  };

  const handleSaveBillingNote = async () => {
    if (!clientId) return;
    try {
      setBillingNoteSaving(true);
      const noteFields = {
        note: billingNoteDraft,
        noteUpdatedAt: new Date().toISOString(),
        noteAuthorId: currentUser?.uid || null,
        noteAuthorName: currentUser?.displayName || currentUser?.email || 'Unknown User',
      };
      setAccount((prev) => ({ ...prev, billing: { ...(prev?.billing || {}), ...noteFields } }));
      await writeAccount(
        clientId,
        Object.fromEntries(Object.entries(noteFields).map(([key, value]) => [`billing.${key}`, value]))
      );
      setEditingBillingNote(false);
    } catch (error) {
      console.error('Error saving billing note:', error);
      alert('Failed to save billing note. Please try again.');
    } finally {
      setBillingNoteSaving(false);
    }
  };

  const handleImageUpload = async (fileOrEvent) => {
    const file = fileOrEvent?.target?.files?.[0] ?? fileOrEvent;
    if (fileOrEvent?.target) fileOrEvent.target.value = '';
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert('Please select a valid image file.');
      return;
    }

    // Validate file size (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Image size must be less than 5MB.');
      return;
    }

    try {
      setUploadingImage(true);
      
      // Create a unique filename for the client
      const timestamp = Date.now();
      const fileName = `client-${clientId}-${timestamp}`;
      const storageRef = ref(storage, `client-photos/${fileName}`);
      
      // CRM-only contact photo: never write contact.photoURL or portalPhotoURL from here
      if (account.contact?.crmPhotoURL) {
        try {
          const oldImageRef = ref(storage, account.contact.crmPhotoURL);
          await deleteObject(oldImageRef);
        } catch (error) {
          console.log('No previous CRM contact photo to delete or error deleting:', error);
        }
      }

      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);

      const updatedAccount = {
        ...account,
        contact: {
          ...account.contact,
          crmPhotoURL: downloadURL
        }
      };
      
      // Save to database
      await updateAccount(clientId, updatedAccount);
      setAccount(updatedAccount);
      
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('Failed to upload image. Please try again.');
    } finally {
      setUploadingImage(false);
    }
  };

  const resetCompanyLogoDragVisual = () => {
    companyLogoDropDepthRef.current = 0;
    setCompanyLogoDragOver(false);
  };

  const handleCompanyLogoUpload = async (fileOrEvent) => {
    let file;
    if (fileOrEvent?.target?.files) {
      file = fileOrEvent.target.files[0];
      fileOrEvent.target.value = '';
    } else if (fileOrEvent?.dataTransfer?.files) {
      file = fileOrEvent.dataTransfer.files[0];
    } else if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    }
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      alert('Please select a valid image file.');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert('Image size must be less than 5MB.');
      return;
    }

    try {
      setUploadingCompanyLogo(true);

      const timestamp = Date.now();
      const storageRef = ref(storage, `client-company-logos/${clientId}-${timestamp}`);

      if (account.crmCompanyLogo) {
        try {
          const oldRef = ref(storage, account.crmCompanyLogo);
          await deleteObject(oldRef);
        } catch (err) {
          console.log('No previous CRM company logo to delete or error deleting:', err);
        }
      }

      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);

      const updatedAccount = {
        ...account,
        crmCompanyLogo: downloadURL
      };

      await updateAccount(clientId, updatedAccount);
      setAccount(updatedAccount);
    } catch (error) {
      console.error('Error uploading company logo:', error);
      alert('Failed to upload company logo. Please try again.');
    } finally {
      setUploadingCompanyLogo(false);
    }
  };

  const onCompanyLogoDragEnter = (e) => {
    if (!isEditMode || uploadingCompanyLogo) return;
    e.preventDefault();
    e.stopPropagation();
    companyLogoDropDepthRef.current += 1;
    setCompanyLogoDragOver(true);
  };

  const onCompanyLogoDragLeave = (e) => {
    if (!isEditMode || uploadingCompanyLogo) return;
    e.preventDefault();
    e.stopPropagation();
    companyLogoDropDepthRef.current -= 1;
    if (companyLogoDropDepthRef.current <= 0) {
      companyLogoDropDepthRef.current = 0;
      setCompanyLogoDragOver(false);
    }
  };

  const onCompanyLogoDragOver = (e) => {
    if (!isEditMode || uploadingCompanyLogo) return;
    e.preventDefault();
    e.stopPropagation();
  };

  const onCompanyLogoDrop = (e) => {
    if (!isEditMode || uploadingCompanyLogo) return;
    e.preventDefault();
    e.stopPropagation();
    resetCompanyLogoDragVisual();
    handleCompanyLogoUpload(e);
  };

  const teamMemberDisplayPhotoUrl = (member) =>
    getCrmTeamMemberDisplayPhotoUrl(account, member.id) || member.profileImage || '';

  const handleTeamMemberPhotoUpload = async (memberId, fileOrEvent) => {
    const file = fileOrEvent?.target?.files?.[0] ?? fileOrEvent;
    if (fileOrEvent?.target) fileOrEvent.target.value = '';
    if (!file || !account) return;

    if (!file.type.startsWith('image/')) {
      alert('Please select a valid image file.');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('Image size must be less than 5MB.');
      return;
    }

    try {
      setUploadingTeamMemberPhotoId(memberId);
      const prev = account.crmTeamMemberPhotos?.[memberId];
      if (prev) {
        try {
          await deleteObject(ref(storage, prev));
        } catch (err) {
          console.log('No previous CRM team photo to delete or error deleting:', err);
        }
      }

      const timestamp = Date.now();
      const storageRef = ref(storage, `client-photos/${clientId}-team-${memberId}-${timestamp}`);
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);

      const updatedAccount = {
        ...account,
        crmTeamMemberPhotos: {
          ...(account.crmTeamMemberPhotos || {}),
          [memberId]: downloadURL
        }
      };
      await updateAccount(clientId, updatedAccount);
      setAccount(updatedAccount);
    } catch (error) {
      console.error('Error uploading team member photo:', error);
      alert('Failed to upload photo. Please try again.');
    } finally {
      setUploadingTeamMemberPhotoId(null);
    }
  };

  const handleRemoveTeamMemberCrmPhoto = async (memberId) => {
    if (!account) return;
    const prev = account.crmTeamMemberPhotos?.[memberId];
    if (!prev) return;
    try {
      setUploadingTeamMemberPhotoId(memberId);
      try {
        await deleteObject(ref(storage, prev));
      } catch (err) {
        console.log('Error deleting CRM team member photo from storage:', err);
      }
      const nextMap = { ...(account.crmTeamMemberPhotos || {}) };
      delete nextMap[memberId];
      const updatedAccount = { ...account, crmTeamMemberPhotos: nextMap };
      await updateAccount(clientId, updatedAccount);
      setAccount(updatedAccount);
    } catch (error) {
      console.error('Error removing CRM team member photo:', error);
      alert('Failed to remove photo. Please try again.');
    } finally {
      setUploadingTeamMemberPhotoId(null);
    }
  };

  const handleAccessTeamPhotoDragOver = (memberId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isEditMode || uploadingTeamMemberPhotoId) return;
    setPhotoDropHighlightKey(`access:${memberId}`);
  };

  const handleAccessTeamPhotoDragLeave = (memberId) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const rel = e.relatedTarget;
    if (rel && e.currentTarget.contains(rel)) return;
    setPhotoDropHighlightKey((cur) => (cur === `access:${memberId}` ? null : cur));
  };

  const handleAccessTeamPhotoDrop = (memberId) => async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setPhotoDropHighlightKey(null);
    if (!isEditMode) return;
    const f = e.dataTransfer.files?.[0];
    if (f) await handleTeamMemberPhotoUpload(memberId, f);
  };

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const data = await getAccountById(clientId);
        if (data.type !== 'Clients') {
          throw new Error('This is not a client');
        }
        setAccount(data);
        setOriginalEmail(data.contact?.email || null); // Store original email
        
        // Log staff account view
        if (currentUser) {
          logAccountView(
            { uid: currentUser.uid, email: currentUser.email, name: currentUser.displayName },
            clientId,
            'client',
            data.company
          );
        }
        setCommunityStatus(data.communityStatus || 'Inactive');
        setShowOnKanban(data.showOnKanban !== undefined ? data.showOnKanban : true);
        setLostReason(data.resultReason || null);

        // Lazy apply: a scheduled cancel date that has passed (or a Stripe subscription that
        // ended) makes the client Canceled without anyone having to mark them Lost.
        try {
          const derived = pendingDerivedCancelPatch(data, { by: 'System (cancel date passed)' });
          if (derived) {
            await updateAccount(clientId, derived);
            setAccount(derived);
          }
        } catch (e) {
          console.error('ClientOverview: could not persist derived Canceled state', e);
        }
        setSignedNDA(data.signedNDA || null);
        setContractData(data.signedContract || data.contractData || null);
        
        // Check if client has portal account and sync ACH data
        if (data.contact?.email) {
          const hasAccount = await checkPortalUserExists(data.contact.email);
          setHasPortalAccount(hasAccount);
          
          // If client has portal account, sync ACH data
          if (hasAccount) {
            await syncACHDataWithPortalUser(data);
          }
        }
      } catch (error) {
        console.error('Error fetching client:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchClient();
    loadInternalUsers();
  }, [clientId]);

  useEffect(() => {
    if (!account) return;
    setStripeBillingLinkDraft({
      customerId: account.stripeCustomerId || '',
      subscriptionId: account.billing?.stripeSubscriptionId || '',
    });
  }, [account?.id, account?.stripeCustomerId, account?.billing?.stripeSubscriptionId]);

  useEffect(() => {
    if (!account) return;
    setBillingNoteDraft(account.billing?.note || '');
  }, [account?.id, account?.billing?.note]);

  // Load Stripe payments and usage when Billing tab is active
  useEffect(() => {
    if (!clientId || activeTab !== 'billing') return;
    const load = async () => {
      let payments = await getAccountPayments(clientId);
      let billing = account?.billing;
      // Linked to Stripe but no invoices imported yet — pull them once automatically so
      // the Billing tab reflects Stripe without a manual "Sync billing / lifetime" click.
      if (
        account?.stripeCustomerId &&
        !payments.some((p) => p.stripeInvoiceId) &&
        stripeAutoSyncedRef.current !== clientId
      ) {
        stripeAutoSyncedRef.current = clientId;
        try {
          setSyncBillingLoading(true);
          const syncStripeBillingFn = httpsCallable(functions, 'syncStripeBilling');
          await syncStripeBillingFn({ accountId: clientId });
          const acc = await getAccountById(clientId);
          setAccount(acc);
          billing = acc?.billing;
          payments = await getAccountPayments(clientId);
        } catch (e) {
          console.error('Auto sync Stripe billing:', e);
        } finally {
          setSyncBillingLoading(false);
        }
      }
      setStripePayments(payments);
      const periodStart = billing?.currentPeriodStart;
      if (periodStart) {
        const periodKey = new Date(periodStart).toISOString().split('T')[0];
        const usage = await getAccountUsage(clientId, periodKey);
        setStripeUsage(usage);
      } else {
        setStripeUsage(null);
      }
    };
    load();
  }, [clientId, activeTab, account?.billing?.currentPeriodStart, account?.stripeCustomerId]);

  // Load expenses + the partners list (subcontractor picker) when the Billing tab is active
  useEffect(() => {
    if (!clientId || activeTab !== 'billing') return;
    let cancelled = false;
    const load = async () => {
      const [expenses, partners] = await Promise.all([
        getAccountExpenses(clientId),
        getPartners().catch((e) => {
          console.error('Error loading partners for expenses:', e);
          return [];
        }),
      ]);
      if (cancelled) return;
      setAccountExpenses(expenses);
      setPartnerOptions(partners);
    };
    load();
    return () => { cancelled = true; };
  }, [clientId, activeTab]);

  const handleEditExpense = (expense) => {
    setEditingExpenseId(expense.id);
    setNewExpense({
      amount: expense.amount ?? '',
      date: expense.date || '',
      status: expense.status || 'paid',
      subcontractorId: expense.subcontractorId || '',
      subcontractorName: expense.subcontractorName || '',
    });
    setShowAddExpenseModal(true);
  };

  const closeExpenseModal = () => {
    setShowAddExpenseModal(false);
    setEditingExpenseId(null);
    setNewExpense({ amount: '', date: '', status: 'paid', subcontractorId: '', subcontractorName: '' });
  };

  const handleSaveExpense = async () => {
    if (!clientId || !newExpense.amount) return;
    try {
      setExpenseSaving(true);
      if (editingExpenseId) {
        await updateAccountExpense(clientId, editingExpenseId, newExpense);
      } else {
        await addAccountExpense(clientId, newExpense);
      }
      setAccountExpenses(await getAccountExpenses(clientId));
      closeExpenseModal();
    } catch (error) {
      console.error('Error saving expense:', error);
      alert('Failed to save expense. Please try again.');
    } finally {
      setExpenseSaving(false);
    }
  };

  const handleDeleteExpense = async (expenseId) => {
    if (!clientId || !expenseId) return;
    try {
      setExpenseSaving(true);
      await deleteAccountExpense(clientId, expenseId);
      setAccountExpenses(await getAccountExpenses(clientId));
      closeExpenseModal();
    } catch (error) {
      console.error('Error deleting expense:', error);
      alert('Failed to delete expense. Please try again.');
    } finally {
      setExpenseSaving(false);
    }
  };

  // Load roadmap templates for Summary (next-up preview) and legacy roadmap tab
  useEffect(() => {
    const loadRoadmapTemplates = async () => {
      if ((activeTab !== 'roadmap' && activeTab !== 'summary') || !clientId) {
        return;
      }

      try {
        setRoadmapLoading(true);
        const clientRoadmap = await clientRoadmapService.getClientRoadmap(clientId);
        const visible = (clientRoadmap || []).filter((t) => (t.status || '') !== 'hidden');
        const sortedRoadmap = [...visible].sort((a, b) => {
          const orderA = a.order || a.allOrder || 0;
          const orderB = b.order || b.allOrder || 0;
          return orderA - orderB;
        });
        setRoadmapTemplates(sortedRoadmap);
        setRoadmapCurrentPage(1); // Reset to first page when loading
      } catch (error) {
        console.error('Error loading client roadmap:', error);
        setRoadmapTemplates([]);
      } finally {
        setRoadmapLoading(false);
      }
    };

    loadRoadmapTemplates();
  }, [activeTab, clientId]);

  /** Next 6 roadmap cards: current in-progress first, then the following items in order */
  const summaryNextRoadmapCards = useMemo(() => {
    const sorted = roadmapTemplates;
    if (!sorted?.length) return [];
    const isInProgress = (t) => {
      const s = (t.status || '').toLowerCase();
      return s === 'in-progress' || s === 'in_progress' || s === 'active';
    };
    const isCompleted = (t) => {
      const s = (t.status || '').toLowerCase();
      return s === 'completed' || s === 'done';
    };
    const ipIdx = sorted.findIndex(isInProgress);
    if (ipIdx >= 0) {
      return sorted.slice(ipIdx, ipIdx + 6);
    }
    const firstNonCompleted = sorted.findIndex((t) => !isCompleted(t));
    if (firstNonCompleted >= 0) {
      return sorted.slice(firstNonCompleted, firstNonCompleted + 6);
    }
    return sorted.slice(Math.max(0, sorted.length - 6));
  }, [roadmapTemplates]);

  const canSeePrivilegedClientTabs =
    internalCrmRole != null && CRM_OWNER_EXECUTIVE_ROLES.includes(internalCrmRole);

  const tabs = useMemo(() => {
    const t = ['Summary', 'Progress', 'Program', 'Bids', 'Task Time'];
    if (canSeePrivilegedClientTabs) t.push('Billing');
    t.push('Events', 'Emails');
    if (canSeePrivilegedClientTabs) t.push('Check In');
    t.push('Documents');
    if (canSeePrivilegedClientTabs) t.push('Access');
    return t;
  }, [canSeePrivilegedClientTabs]);

  useEffect(() => {
    if (!currentUser?.uid) {
      setInternalCrmRole(null);
      setInternalCrmTeam(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'internal_users', currentUser.uid));
        if (!cancelled) {
          const data = snap.exists() ? snap.data() : null;
          setInternalCrmRole(data?.role ?? null);
          setInternalCrmTeam(data?.team ?? null);
          setCurrentUserCalendlyConnected(data?.integrations?.calendly?.connected === true);
        }
      } catch (e) {
        console.error('ClientOverview: internal role', e);
        if (!cancelled) {
          setInternalCrmRole(null);
          setInternalCrmTeam(null);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [currentUser?.uid]);

  useEffect(() => {
    if (!['billing', 'check in', 'access'].includes(activeTab)) return;
    if (!canSeePrivilegedClientTabs) {
      setActiveTab('summary');
    }
  }, [activeTab, canSeePrivilegedClientTabs]);

  // Load program data when account changes
  useEffect(() => {
    if (account) {
      loadProgramData();
    }
  }, [account]);

  // Load portal-linked team members for Events roster, sidebar contacts, and Access tab
  useEffect(() => {
    const loadTeamMembers = async () => {
      if (!account?.id) {
        setTeamMembers([]);
        setTeamMembersLoading(false);
        return;
      }
      setTeamMembersLoading(true);
      try {
        const members = await fetchClientEventRosterMembers(account);
        setTeamMembers(members);
      } catch (err) {
        console.warn('Could not load team members:', err);
        setTeamMembers([]);
      } finally {
        setTeamMembersLoading(false);
      }
    };
    loadTeamMembers();
  }, [account?.id, account?.crmTeamMemberPhotos, account?.crmTeamMemberPhones, teamMembersRefreshKey]);

  // Access tab → Portal Activity: merge logins (users/{uid}.loginHistory) with
  // page views (users/{uid}/portalActivity) for every real portal member
  useEffect(() => {
    if (activeTab !== 'access' || teamMembersLoading) return;
    const members = (teamMembers || []).filter((m) => !m.isPendingInvite && m.id);
    if (!members.length) {
      setPortalActivityRows([]);
      return;
    }
    let cancelled = false;
    setPortalActivityLoading(true);
    (async () => {
      try {
        const perMember = await Promise.all(
          members.map(async (member) => {
            const rows = [];
            const memberName = member.name || member.email || 'Member';

            // Logins from the portal user doc (written by LoginPage on every sign-in)
            try {
              const snap = await getDoc(doc(db, 'users', member.id));
              if (snap.exists()) {
                const data = snap.data();
                const logins = (Array.isArray(data.loginHistory) ? data.loginHistory : [])
                  .map((entry) => {
                    const raw = entry?.timestamp || entry;
                    const d = typeof raw?.toDate === 'function' ? raw.toDate() : new Date(raw);
                    return Number.isNaN(d?.getTime?.()) ? null : { at: d, location: entry?.location || null };
                  })
                  .filter(Boolean);
                // First-ever login sets lastLogin without a history entry — keep it
                // unless it duplicates a history row within a couple of minutes.
                const lastLogin = data.lastLogin?.toDate?.() ?? (data.lastLogin ? new Date(data.lastLogin) : null);
                if (
                  lastLogin &&
                  !Number.isNaN(lastLogin.getTime()) &&
                  !logins.some((l) => Math.abs(l.at.getTime() - lastLogin.getTime()) < 2 * 60 * 1000)
                ) {
                  logins.push({ at: lastLogin, location: null });
                }
                logins.forEach(({ at, location }) => {
                  rows.push({
                    id: `${member.id}:login:${at.getTime()}`,
                    memberId: member.id,
                    memberName,
                    type: 'login',
                    label: 'Logged in',
                    at,
                    location,
                  });
                });
              }
            } catch (err) {
              console.warn('Could not load login history for', member.id, err);
            }

            // Portal page views (mirrored by AnalyticsTracker)
            const activity = await fetchPortalActivity(member.id);
            activity.forEach((entry) => {
              const d = new Date(entry.at);
              if (Number.isNaN(d.getTime())) return;
              rows.push({
                id: `${member.id}:${entry.id}`,
                memberId: member.id,
                memberName,
                type: entry.kind || 'page_view',
                label: entry.label ? `Viewed ${entry.label}` : 'Viewed a page',
                path: entry.path || null,
                at: d,
                location: entry.location || null,
              });
            });

            return rows;
          })
        );
        if (cancelled) return;
        const merged = perMember.flat().sort((a, b) => b.at - a.at);
        setPortalActivityRows(merged);
      } catch (err) {
        console.warn('Could not load portal activity:', err);
        if (!cancelled) setPortalActivityRows([]);
      } finally {
        if (!cancelled) setPortalActivityLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [activeTab, teamMembers, teamMembersLoading]);

  // Fresh account → collapse the activity list back down
  useEffect(() => {
    setPortalActivityVisibleCount(15);
  }, [account?.id]);

  const additionalTeamMembersForAccess = useMemo(() => {
    if (!account) return [];
    const primaryEmail = String(account.contact?.email || account.email || '').trim().toLowerCase();
    return (teamMembers || []).filter(
      (m) => !m.isPrimary && String(m.email || '').trim().toLowerCase() !== primaryEmail
    );
  }, [account, teamMembers]);

  const sidebarContacts = useMemo(() => {
    if (!account) return [];
    const primaryEmail = String(account.contact?.email || account.email || '').trim().toLowerCase();
    const rows = [
      {
        key: 'account-primary',
        source: 'account',
        firstName: account.contact?.firstName || '',
        lastName: account.contact?.lastName || '',
        email: account.contact?.email || account.email || '',
        phone: account.contact?.phone || '',
        photoURL: getCrmContactDisplayPhotoUrl(account)
      }
    ];
    (teamMembers || []).forEach((m) => {
      if (m.isPrimary) return;
      const e = String(m.email || '').trim().toLowerCase();
      if (e && e === primaryEmail) return;
      const crmPhone = account?.crmTeamMemberPhones?.[m.id];
      rows.push({
        key: m.id,
        source: 'portal',
        firstName: m.firstName || '',
        lastName: m.lastName || '',
        email: m.email || '',
        phone: crmPhone !== undefined && crmPhone !== null ? crmPhone : m.phone || '',
        photoURL: getCrmTeamMemberDisplayPhotoUrl(account, m.id) || m.profileImage || ''
      });
    });
    return rows;
  }, [account, teamMembers]);

  const orderedSidebarContacts = useMemo(
    () => sortSidebarContactsWithPinnedFirst(sidebarContacts, pinnedSidebarContactKey),
    [sidebarContacts, pinnedSidebarContactKey]
  );

  useEffect(() => {
    if (!account?.id) return;
    setSidebarLeadContactIndex(0);
    try {
      const raw = localStorage.getItem(CLIENT_OVERVIEW_PINNED_CONTACT_STORAGE_PREFIX + account.id);
      setPinnedSidebarContactKey(raw && raw !== 'undefined' ? raw : null);
    } catch {
      setPinnedSidebarContactKey(null);
    }
  }, [account?.id]);

  useEffect(() => {
    const n = orderedSidebarContacts.length;
    if (n === 0) return;
    setSidebarLeadContactIndex((i) => (i >= n ? 0 : i));
  }, [orderedSidebarContacts]);

  // Fetch client integration status (JobTread, QuickBooks) for Access tab
  useEffect(() => {
    const fetchClientIntegrations = async () => {
      if (!account?.id) return;
      setClientIntegrationsLoading(true);
      try {
        const [accountStatus, usersSnap] = await Promise.all([
          getAccountIntegrationsStatus(account.id).catch(() => ({})),
          (async () => {
            const usersRef = collection(db, 'users');
            const accountQuery = query(usersRef, where('accountId', '==', account.id));
            const clientQuery = query(usersRef, where('clientId', '==', account.id));
            const [accountSnap, clientSnap] = await Promise.all([
              getDocs(accountQuery),
              getDocs(clientQuery)
            ]);
            const docMap = new Map();
            [...accountSnap.docs, ...clientSnap.docs].forEach(d => docMap.set(d.id, d));
            return Array.from(docMap.values());
          })()
        ]);
        const quickbooksConnected = !!(accountStatus?.quickbooks?.connected);
        const jobtreadConnected = usersSnap.some(
          (d) => d.data().integrations?.jobtread?.connected === true
        );
        setClientIntegrations({ jobtread: jobtreadConnected, quickbooks: quickbooksConnected });
      } catch (err) {
        console.warn('Could not load client integrations:', err);
        setClientIntegrations({ jobtread: false, quickbooks: false });
      } finally {
        setClientIntegrationsLoading(false);
      }
    };
    fetchClientIntegrations();
  }, [account?.id]);

  // Load QuickBooks revenue for Current Revenue card when client has QB connected
  useEffect(() => {
    if (!account?.id || !clientIntegrations.quickbooks) {
      setQbCurrentRevenue(null);
      return;
    }

    let cancelled = false;
    const loadQbRevenue = async () => {
      setQbRevenueLoading(true);
      try {
        // Prefer live YTD P&L for the client's QuickBooks company (single API call).
        const ytd = await getQuickBooksYtdRevenue(account.id);
        if (cancelled) return;
        if (ytd != null) {
          setQbCurrentRevenue(ytd);
          return;
        }

        // Fallback to cached monthly revenue history.
        const history = await getQuickBooksRevenueHistory({
          autoSyncIfEmpty: true,
          lookbackYears: 2,
          accountId: account.id,
        });
        if (cancelled) return;
        const months = Array.isArray(history?.revenueByMonth) ? history.revenueByMonth : [];
        const cached =
          computeCurrentYearRevenue(months) ??
          computeTrailingTwelveMonthRevenue(months);
        setQbCurrentRevenue(cached);
      } catch (err) {
        console.warn('Could not load QuickBooks revenue for client:', err);
        if (!cancelled) setQbCurrentRevenue(null);
      } finally {
        if (!cancelled) setQbRevenueLoading(false);
      }
    };

    loadQbRevenue();
    return () => { cancelled = true; };
  }, [account?.id, clientIntegrations.quickbooks]);

  const displayedCurrentRevenue = useMemo(() => {
    if (clientIntegrations.quickbooks && qbCurrentRevenue != null) {
      return qbCurrentRevenue;
    }
    return account?.metrics?.currentRevenue || 0;
  }, [clientIntegrations.quickbooks, qbCurrentRevenue, account?.metrics?.currentRevenue]);

  // Fetch events when account, internal users, and team roster are loaded
  useEffect(() => {
    if (account && internalUsers.length > 0 && activeTab === 'events' && !teamMembersLoading) {
      fetchClientEvents(teamMembers);
    }
  }, [account, internalUsers, activeTab, teamMembers, teamMembersLoading]);

  useEffect(() => {
    const accountId = account?.id || clientId;
    if (!accountId || activeTab !== 'events') {
      setAccountMeetingSummaries([]);
      return;
    }

    let cancelled = false;
    const recorderUids = internalUsers.map((u) => u.id).filter(Boolean);

    loadMeetingSummariesForContext(db, { accountId, recorderUids })
      .then((summaries) => {
        if (!cancelled) {
          if (process.env.NODE_ENV === 'development') {
            const withAccountId = summaries.filter((s) => s.accountId === accountId);
            const nullAccountId = summaries.filter((s) => s.accountId == null);
            console.log(
              `[Events] Meeting summaries loaded: ${summaries.length} total`,
              { accountId, byAccountId: withAccountId.length, byRecorderUid: nullAccountId.length }
            );
          }
          setAccountMeetingSummaries(summaries);
        }
      })
      .catch((error) => {
        console.error('Error loading meeting summaries:', error);
        if (!cancelled) setAccountMeetingSummaries([]);
      });

    return () => {
      cancelled = true;
    };
  }, [account?.id, clientId, activeTab, internalUsers]);

  // Fetch Gmail emails for the client
  const fetchClientEmails = async () => {
    if (!account?.contact?.email || !internalUsers.length) {
      setClientEmails([]);
      return;
    }

    try {
      setEmailsLoading(true);
      const clientEmail = [account.contact.email.toLowerCase(), ...accountAliasEmails(account)];

      // Fetch emails from all internal users who have Gmail connected
      const allEmails = [];
      const disconnected = [];

      for (const user of internalUsers) {
        try {
          const { messages: emails, status, profileConnected } = await fetchGmailMessagesForEmailWithStatus(user.id, clientEmail, 50);

          if (status !== 'ok') {
            // Google rejected the saved grant for the signed-in user — flip the profile
            // flag so CRM ▸ My Profile (the source of truth) stops showing "connected".
            let stillConnected = profileConnected;
            if (status === 'needs_reauth' && profileConnected && user.id === currentUser?.uid) {
              const marked = await markUserIntegrationNeedsReauth(user.id, 'gmail');
              if (marked) stillConnected = false;
            }
            disconnected.push({ id: user.id, name: user.name, status, profileConnected: stillConnected });
          }

          // Add user info to each email
          const emailsWithUser = emails.map(email => ({
            ...email,
            fetchedBy: {
              id: user.id,
              name: user.name,
              profileImage: user.profileImage,
              initials: user.initials,
              email: user.email
            }
          }));

          allEmails.push(...emailsWithUser);
        } catch (error) {
          console.error(`Error fetching emails for user ${user.id}:`, error);
          // Continue with other users even if one fails
        }
      }

      // Sort emails by date (newest first)
      allEmails.sort((a, b) => {
        const aDate = new Date(a.date);
        const bDate = new Date(b.date);
        return bDate - aDate; // Reverse order: newest first
      });

      setClientEmails(allEmails);
      setGmailDisconnectedUsers(disconnected);
    } catch (error) {
      console.error('Error fetching client emails:', error);
      setClientEmails([]);
    } finally {
      setEmailsLoading(false);
    }
  };

  // Fetch emails when account, internal users are loaded and Emails tab is active
  useEffect(() => {
    if (account && internalUsers.length > 0 && activeTab === 'emails') {
      fetchClientEmails();
    }
  }, [account, internalUsers, activeTab]);

  // Handle opening meeting summary modal
  const handleViewMeetingSummary = async (event) => {
    const accountId = account?.id || clientId;
    const cachedSummary = matchEventToMeetingSummary(event, accountMeetingSummaries, {
      accountId,
      internalEmails: internalUsers.map((u) => u.email),
    });
    if (!cachedSummary || cachedSummary.source !== 'fathom') return;

    setSelectedEventForSummary(event);
    setShowMeetingSummaryModal(true);
    setMeetingSummary(cachedSummary);
    setMeetingSummaryLoading(false);
  };

  // Fetch check-ins for this client (email variants, accountId, scheduled_check_ins fallback)
  useEffect(() => {
    if (!clientId && !account?.contact?.email) return;

    let cancelled = false;

    const loadCheckIns = async () => {
      try {
        setCheckInsLoading(true);
        const merged = new Map();
        const checkInsRef = collection(db, 'check_ins');
        const emailRaw = String(account?.contact?.email || '').trim();
        const emailsToQuery = new Set([emailRaw, normCheckInEmail(emailRaw)].filter(Boolean));

        const schedSnap = await getDocs(
          query(collection(db, 'scheduled_check_ins'), where('clientId', '==', clientId))
        );
        for (const s of schedSnap.docs) {
          const em = s.data().clientEmail;
          if (em) {
            const t = String(em).trim();
            if (t) emailsToQuery.add(t);
            emailsToQuery.add(normCheckInEmail(t));
          }
        }

        const periodKeys = new Set();
        const now = new Date();
        periodKeys.add(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`);
        if (account?.lastAutoCheckInPeriodKey) {
          periodKeys.add(account.lastAutoCheckInPeriodKey);
        }

        const queries = [
          ...[...emailsToQuery].map((em) => getDocs(query(checkInsRef, where('userEmail', '==', em)))),
          getDocs(query(checkInsRef, where('accountId', '==', clientId))),
          ...[...emailsToQuery].flatMap((em) =>
            [...periodKeys].map((pk) =>
              getDocs(query(checkInsRef, where('userEmail', '==', em), where('periodKey', '==', pk)))
            )
          ),
        ];

        const snapshots = await Promise.all(queries);
        for (const snap of snapshots) {
          for (const d of snap.docs) {
            merged.set(d.id, mapCheckInFirestoreDoc(d));
          }
        }

        const missingCheckInIds = [];
        for (const s of schedSnap.docs) {
          const checkInId = s.data().checkInId;
          if (checkInId && !merged.has(checkInId)) {
            missingCheckInIds.push(checkInId);
          }
        }
        if (missingCheckInIds.length > 0) {
          const extra = await Promise.all(
            missingCheckInIds.map((id) => getDoc(doc(db, 'check_ins', id)))
          );
          for (const d of extra) {
            if (d.exists()) merged.set(d.id, mapCheckInFirestoreDoc(d));
          }
        }

        for (const s of schedSnap.docs) {
          const data = s.data();
          if (data.status && data.status !== 'sent') continue;
          const checkInId = data.checkInId;
          const existing = checkInId ? merged.get(checkInId) : null;
          if (existing && !isCheckInCardAwaitingCompletion(existing)) continue;

          if (!existing) {
            const ts = data.sentAt || data.scheduledDate;
            const sentDate = ts?.toDate?.() || (ts ? new Date(ts) : null);
            const syntheticId = checkInId || `scheduled-${s.id}`;
            if (merged.has(syntheticId)) continue;
            merged.set(syntheticId, {
              id: syntheticId,
              month: monthLabelFromCheckInDate(ts) || 'Check-in sent',
              status: 'pending',
              surveyId: data.surveyId,
              userEmail: data.clientEmail || normCheckInEmail(account?.contact?.email),
              scheduledDate: sentDate,
              sentAt: sentDate,
              createdAt: sentDate,
              _fromScheduledId: s.id,
            });
          }
        }

        if (!cancelled) {
          setCheckIns(sortCheckInsForDisplay([...merged.values()]));
        }
      } catch (error) {
        console.error('Error fetching check-ins:', error);
        if (!cancelled) setCheckIns([]);
      } finally {
        if (!cancelled) setCheckInsLoading(false);
      }
    };

    loadCheckIns();

    const checkInsRef = collection(db, 'check_ins');
    const unsubs = [];
    const emailRaw = String(account?.contact?.email || '').trim();
    if (emailRaw) {
      unsubs.push(onSnapshot(query(checkInsRef, where('userEmail', '==', emailRaw)), () => loadCheckIns()));
      const lower = normCheckInEmail(emailRaw);
      if (lower !== emailRaw) {
        unsubs.push(onSnapshot(query(checkInsRef, where('userEmail', '==', lower)), () => loadCheckIns()));
      }
    }
    unsubs.push(onSnapshot(query(checkInsRef, where('accountId', '==', clientId)), () => loadCheckIns()));

    return () => {
      cancelled = true;
      unsubs.forEach((u) => u());
    };
  }, [account?.contact?.email, account?.lastAutoCheckInPeriodKey, clientId]);

  const handleSendCheckInNow = async () => {
    if (!clientId || !account) return;
    setSendingCheckInManual(true);
    try {
      const sendFn = httpsCallable(functions, 'sendClientCheckIn');
      const { data } = await sendFn({ accountId: clientId });
      if (!data?.success) {
        const messages = {
          already_completed: 'This client already completed the check-in for this month.',
          no_contact_email: 'Add a contact email on this account before sending a check-in.',
          no_portal_user: 'No portal user is linked to this account. Invite or link a portal user first.',
          account_not_found: 'Account not found.',
          pending_without_survey: 'The pending check-in is missing survey data. Contact support.',
        };
        alert(messages[data?.code] || 'Could not send check-in.');
        return;
      }
      const refreshed = await getAccountById(clientId);
      setAccount(refreshed);
      alert(
        data.resent
          ? 'Survey re-sent to the client portal (awaiting response).'
          : `Check-in sent for ${data.monthYear || 'this month'}. It will appear as Pending until the client responds.`
      );
    } catch (err) {
      console.error('Error sending check-in:', err);
      alert(err?.message || 'Failed to send check-in. Deploy sendClientCheckIn if this is a new function.');
    } finally {
      setSendingCheckInManual(false);
    }
  };

  const getSummaryRoadmapStatusStyles = (status) => {
    const s = (status || '').toLowerCase();
    if (s === 'in_progress' || s === 'active') {
      return 'border-yellow-500 bg-yellow-100 dark:bg-yellow-900/40';
    }
    switch (s) {
      case 'completed':
      case 'done':
        return 'border-green-500 bg-green-100 dark:bg-green-900/40';
      case 'in-progress':
        return 'border-yellow-500 bg-yellow-100 dark:bg-yellow-900/40';
      case 'locked':
      case 'not-started':
      case 'not_started':
        return 'border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-800';
      default:
        return 'border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-800';
    }
  };

  const getSummaryRoadmapDepartmentEmoji = (item) => {
    if (!item) return '📋';
    if (item.emoji) return item.emoji;
    const dept = (item.department && typeof item.department === 'string') ? item.department.toLowerCase() : '';
    return getPillarEmoji(dept);
  };

  const getSummaryRoadmapDepartmentPill = (dept) => {
    const deptLower = dept?.toLowerCase() || '';
    const colorMap = {
      sales: 'bg-red-500 text-white',
      operations: 'bg-blue-500 text-white',
      finance: 'bg-green-500 text-white',
      technology: 'bg-purple-500 text-white',
      marketing: 'bg-orange-500 text-white',
      hr: 'bg-yellow-500 text-white',
      onboarding: 'bg-gray-500 text-white',
      general: 'bg-gray-500 text-white',
    };
    return colorMap[deptLower] || 'bg-gray-500 text-white';
  };

  const getSummaryRoadmapDepartmentLabel = (dept) => {
    const deptLower = dept?.toLowerCase() || '';
    const nameMap = {
      sales: 'Sales',
      operations: 'Operations',
      finance: 'Finance',
      technology: 'Technology',
      marketing: 'Marketing',
      hr: 'HR',
      onboarding: 'Onboarding',
      general: 'General',
    };
    return nameMap[deptLower] || dept || 'General';
  };

  const handleEdit = (field, value) => {
    setEditingField(field);
    setEditValue(value);
  };

  // program.startDate may be a Firestore Timestamp, ISO string, YYYY-MM-DD, or Date.
  // Normalize to the local YYYY-MM-DD that <input type="date"> expects; never throws.
  const toDateInputValue = (value) => {
    if (!value) return '';
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const d = value instanceof Date ? value : parseFlexibleAccountDate(value);
    if (!d || isNaN(d.getTime())) return '';
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };

  const handleSave = async (field) => {
    try {
      const updatedData = { ...account };
      
      // Get the new value - use editValue if field matches, otherwise use current account value
      let newValue = field === editingField ? editValue : (field === 'contact.email' ? account?.contact?.email : null);
      
      // Check if email is being changed
      const isEmailChange = field === 'contact.email' && 
                           originalEmail && 
                           newValue && 
                           newValue.toLowerCase().trim() !== originalEmail.toLowerCase().trim();

      // Handle nested contact fields
      if (field.startsWith('contact.')) {
        const contactField = field.split('.')[1];
        const valueToUse = field === editingField ? editValue : (field === 'contact.email' ? account?.contact?.email : editValue);
        updatedData.contact = {
          ...updatedData.contact,
          [contactField]: valueToUse
        };
      } 
      // Handle nested metrics fields
      else if (field.startsWith('metrics.')) {
        const metricsField = field.split('.')[1];
        updatedData.metrics = {
          ...updatedData.metrics,
          [metricsField]: editValue
        };
      } 
      // Handle nested billing fields
      else if (field.startsWith('billing.')) {
        const billingField = field.split('.')[1];
        // Monthly expenses is a manual override: a blank value clears it so the
        // card goes back to summing this month's logged expenses.
        const billingValue =
          billingField === 'monthlyExpenses'
            ? (String(editValue ?? '').trim() === '' ? null : Number(editValue) || 0)
            : editValue;
        updatedData.billing = {
          ...updatedData.billing,
          [billingField]: billingValue
        };
      } 
      // Handle nested program fields
      else if (field.startsWith('program.')) {
        const programField = field.split('.')[1];
        updatedData.program = programMapWith(updatedData.program, { [programField]: editValue });
      } 
      else {
        updatedData[field] = editValue;
      }

      // If email is being changed, use the Cloud Function to update everything
      if (isEmailChange) {
        const oldEmail = originalEmail;
        const newEmail = newValue;
        
        try {
          const updateClientEmailFunction = httpsCallable(functions, 'updateClientEmail');
          const result = await updateClientEmailFunction({
            accountId: clientId,
            oldEmail: oldEmail,
            newEmail: newEmail
          });

          if (result.data && result.data.success) {
            // Update local state with the new email
            setAccount(updatedData);
            setOriginalEmail(newEmail); // Update original email so it doesn't trigger again
            setEditingField(null);
            // Show success message
            alert(`Email updated successfully! ${result.data.message || ''}`);
          } else {
            const errorMsg = result.data?.error || 'Failed to update email';
            throw new Error(errorMsg);
          }
        } catch (error) {
          console.error('Error updating client email:', error);
          console.error('Error details:', {
            code: error.code,
            message: error.message,
            details: error.details
          });
          // Server may return error message in details when code is functions/internal
          const detailsMsg = error.details && (typeof error.details === 'string' ? error.details : error.details.message || error.details.error);
          // Provide more helpful error messages
          let errorMessage = 'Failed to update email';
          if (error.code === 'functions/unavailable' || error.code === 'functions/deadline-exceeded') {
            errorMessage = 'The email update service is temporarily unavailable. Please try again in a moment.';
          } else if (error.code === 'functions/permission-denied') {
            errorMessage = 'You do not have permission to update this email. Please contact support.';
          } else if (error.code === 'functions/unauthenticated') {
            errorMessage = 'You must be logged in to update email addresses. Please refresh the page and try again.';
          } else if (detailsMsg) {
            errorMessage = String(detailsMsg);
          } else if (error.message && error.message !== 'internal') {
            errorMessage = error.message;
          } else if (error.message === 'internal') {
            errorMessage = 'An internal error occurred. The function may need to be redeployed. Please contact support.';
          }
          
          alert(errorMessage);
          // Don't update the state if email update failed
          return;
        }
      } else {
        // For non-email fields, use the regular update (billing fields as a single dotted path —
        // updateAccount never writes the billing map)
        if (field.startsWith('billing.')) {
          await writeAccount(clientId, { [field]: updatedData.billing[field.split('.')[1]] });
        } else {
          await updateAccount(clientId, updatedData);
        }
        setAccount(updatedData);
        setEditingField(null);
      }
    } catch (error) {
      console.error('Error updating client:', error);
      alert(`Failed to update: ${error.message || 'Unknown error'}`);
    }
  };

  /**
   * Billing tab summary edits (ClientBillingSummary): one field per write so nothing else on the
   * account — Stripe-synced billing, other tabs' edits — is overwritten. null clears the field.
   */
  const handleSaveBillingField = async (path, value) => {
    if (!clientId) return;
    const [group, key] = path.split('.');
    const withValue = (map) => {
      const next = group === 'program' ? programMapWith(map, {}) : { ...(map || {}) };
      if (value === null) delete next[key];
      else next[key] = value;
      return next;
    };
    // Legacy accounts store `program` as a plain status string — those need the whole map written.
    const legacyProgram = group === 'program' && account?.program && typeof account.program !== 'object';
    await writeAccount(
      clientId,
      legacyProgram ? { program: withValue(account.program) } : { [path]: value === null ? deleteField() : value }
    );
    setAccount((prev) => (prev ? { ...prev, [group]: withValue(prev[group]) } : prev));
  };

  const handleSyncStripeBilling = async () => {
    if (!clientId) return;
    try {
      setSyncBillingLoading(true);
      const syncStripeBillingFn = httpsCallable(functions, 'syncStripeBilling');
      const { data } = await syncStripeBillingFn({ accountId: clientId });
      const acc = await getAccountById(clientId);
      setAccount(acc);
      const payments = await getAccountPayments(clientId);
      setStripePayments(payments);
      if (data?.subscriptionSyncFailed) {
        alert(
          `Lifetime amount saved from payment records. Subscription details could not be loaded: ${data.subscriptionError || 'unknown error'}.`
        );
      } else if (data?.lifetimeOnly) {
        alert('Lifetime amount updated from payment records.');
      } else {
        const imported = (Number(data?.invoicesImported) || 0) + (Number(data?.chargesImported) || 0);
        const extra =
          imported > 0
            ? ` Imported ${imported} paid payment${imported === 1 ? '' : 's'} from Stripe into payment history.`
            : '';
        alert(`Billing synced from Stripe. Lifetime amount, customer ID, and billing period are updated.${extra}`);
      }
    } catch (error) {
      console.error('Sync Stripe billing:', error);
      alert(error.message || 'Failed to sync billing from Stripe');
    } finally {
      setSyncBillingLoading(false);
    }
  };

  const applyStripeIdsFromClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const cus = text.match(/cus_[a-zA-Z0-9]+/)?.[0];
      const sub = text.match(/sub_[a-zA-Z0-9]+/)?.[0];
      setStripeBillingLinkDraft((d) => ({
        customerId: cus || d.customerId,
        subscriptionId: sub || d.subscriptionId,
      }));
      if (!cus && !sub) {
        alert('Clipboard did not contain a Stripe customer id (cus_…) or subscription id (sub_…). Paste into the fields manually if needed.');
      }
    } catch (e) {
      console.error(e);
      alert('Could not read the clipboard. Paste the ids into the fields manually.');
    }
  };

  const runStripeCustomerSearch = async (queryOverride) => {
    const q = String(queryOverride ?? stripeMatchQuery).trim();
    if (q.length < 2) {
      setStripeMatchError('Enter at least 2 characters (a name or email) to search.');
      return;
    }
    try {
      setStripeMatchLoading(true);
      setStripeMatchError('');
      setStripeMatchSearched(true);
      const searchFn = httpsCallable(functions, 'searchStripeCustomers');
      const { data } = await searchFn({ query: q });
      setStripeMatchResults(Array.isArray(data?.customers) ? data.customers : []);
    } catch (e) {
      console.error('searchStripeCustomers:', e);
      setStripeMatchResults([]);
      setStripeMatchError(e.message || 'Failed to search Stripe customers.');
    } finally {
      setStripeMatchLoading(false);
    }
  };

  const openStripeMatchModal = () => {
    const prefill =
      String(account?.contact?.email || account?.email || '').trim() ||
      String(account?.company || '').trim();
    setStripeMatchQuery(prefill);
    setStripeMatchResults([]);
    setStripeMatchError('');
    setStripeMatchSearched(false);
    setStripeMatchSaved(null);
    setShowStripeMatchModal(true);
    if (prefill && prefill.length >= 2) {
      runStripeCustomerSearch(prefill);
    }
  };

  /** Pick a Stripe customer (and optionally one of its subscriptions) from the search picker — saves the link right away. */
  const selectStripeCustomerMatch = async (customer, subscriptionId) => {
    // Prefer an explicitly chosen sub; else the customer's only/most relevant active one.
    let subId = subscriptionId || '';
    if (!subId && Array.isArray(customer.subscriptions) && customer.subscriptions.length) {
      const active = customer.subscriptions.find((s) => s.status === 'active' || s.status === 'trialing');
      subId = (active || customer.subscriptions[0]).id;
    }
    setStripeBillingLinkDraft({ customerId: customer.id, subscriptionId: subId });
    setShowStripeMatchModal(false);
    setStripeMatchSaved(null);
    const saved = await saveStripeBillingLinkOverrides({
      ids: { customerId: customer.id, subscriptionId: subId },
      quiet: true,
    });
    if (saved) {
      setStripeMatchSaved({
        name: customer.name || '',
        email: customer.email || '',
        customerId: customer.id,
        subscriptionId: subId,
      });
    }
  };

  const saveStripeBillingLinkOverrides = async ({ syncAfter = false, ids = null, quiet = false } = {}) => {
    if (!clientId || !account) return false;
    const cus = String((ids ? ids.customerId : stripeBillingLinkDraft.customerId) || '').trim();
    const sub = String((ids ? ids.subscriptionId : stripeBillingLinkDraft.subscriptionId) || '').trim();
    if (cus && !/^cus_[a-zA-Z0-9]+$/.test(cus)) {
      alert('Stripe Customer ID must look like cus_ followed by letters and numbers only.');
      return false;
    }
    if (sub && !/^sub_[a-zA-Z0-9]+$/.test(sub)) {
      alert('Stripe Subscription ID must look like sub_ followed by letters and numbers only.');
      return false;
    }
    try {
      setStripeBillingLinkSaving(true);
      const payload = {
        stripeCustomerId: cus ? cus : deleteField(),
        'billing.stripeSubscriptionId': sub ? sub : deleteField(),
      };
      // A changed id means the old link was wrong: restart the linked lists from the new ids and
      // let the sync rediscover the client's other subscriptions from there.
      if (sub !== (account.billing?.stripeSubscriptionId || '')) {
        payload['billing.stripeSubscriptionIds'] = sub ? [sub] : [];
      }
      if (cus !== (account.stripeCustomerId || '')) {
        payload.stripeCustomerIds = cus ? [cus] : deleteField();
      }
      await writeAccount(clientId, payload);
      const acc = await getAccountById(clientId);
      setAccount(acc);
      setStripeBillingLinkDraft({
        customerId: acc.stripeCustomerId || '',
        subscriptionId: acc.billing?.stripeSubscriptionId || '',
      });
    } catch (e) {
      console.error(e);
      alert(e.message || 'Failed to save Stripe ids');
      return false;
    } finally {
      setStripeBillingLinkSaving(false);
    }

    if (syncAfter) {
      try {
        setSyncBillingLoading(true);
        const syncStripeBillingFn = httpsCallable(functions, 'syncStripeBilling');
        const { data } = await syncStripeBillingFn({ accountId: clientId });
        const acc2 = await getAccountById(clientId);
        setAccount(acc2);
        const payments = await getAccountPayments(clientId);
        setStripePayments(payments);
        const imported = (Number(data?.invoicesImported) || 0) + (Number(data?.chargesImported) || 0);
        const extra =
          imported > 0
            ? ` Imported ${imported} paid payment${imported === 1 ? '' : 's'} from Stripe.`
            : '';
        if (data?.subscriptionSyncFailed) {
          alert(
            `Stripe IDs saved. Sync could not load full subscription details: ${data.subscriptionError || 'unknown error'}.${extra}`
          );
        } else if (data?.lifetimeOnly) {
          alert(`Stripe IDs saved. Lifetime updated from payment records.${extra}`);
        } else {
          alert(`Stripe IDs saved and billing synced from Stripe.${extra}`);
        }
      } catch (syncErr) {
        console.error(syncErr);
        alert(
          syncErr.message ||
            'Stripe IDs saved, but billing sync failed. Open the Billing tab and try “Sync billing / lifetime”.'
        );
      } finally {
        setSyncBillingLoading(false);
      }
    } else if (!quiet) {
      alert(
        'Stripe customer and subscription ids saved. Open the Billing tab and use “Sync billing / lifetime” to pull invoices and billing period from Stripe.'
      );
    }
    return true;
  };

  const handleDeleteClient = async () => {
    try {
      await deleteAccount(clientId);
      navigate('/crm/clients');
    } catch (error) {
      console.error('Error deleting client:', error);
      setError('Failed to delete client');
    }
  };

  // Check if portal user exists for this client
  const checkPortalUserExists = async (email) => {
    try {
      if (!email && !clientId) return false;

      const usersRef = collection(db, 'users');
      const checks = [];

      if (clientId) {
        checks.push(getDocs(query(usersRef, where('accountId', '==', clientId), limit(1))));
        checks.push(getDocs(query(usersRef, where('clientId', '==', clientId), limit(1))));
        checks.push(getDoc(doc(usersRef, clientId)));
      }
      if (email) {
        checks.push(getDocs(query(usersRef, where('email', '==', email), limit(1))));
      }

      const results = await Promise.all(checks);
      for (const r of results) {
        if (r && typeof r.empty === 'boolean' && !r.empty) return true;
        if (r && r.exists === true) return true;
      }
      return false;
    } catch (error) {
      console.error('Error checking portal user:', error);
      return false;
    }
  };

  const syncACHDataWithPortalUser = async (clientData) => {
    try {
      // Find the portal user by email
      const usersQuery = query(
        collection(db, 'users'),
        where('email', '==', clientData.contact.email)
      );
      const usersSnapshot = await getDocs(usersQuery);
      
      if (!usersSnapshot.empty) {
        const userDoc = usersSnapshot.docs[0];
        const userData = userDoc.data();
        
        // Check if user has billing ACH data
        const userAchDoc = await getDoc(doc(db, 'users', userData.uid, 'billing', 'ach'));
        if (userAchDoc.exists()) {
          const userAchData = userAchDoc.data();
          
          // If client doesn't have ACH data or user's is newer, sync from user to client
          if (!clientData.achInfo || !clientData.achLastUpdated || 
              (userAchData.lastUpdated && new Date(userAchData.lastUpdated) > new Date(clientData.achLastUpdated))) {
            
            const updatedClientData = {
              ...clientData,
              achInfo: userAchData,
              achStatus: 'Completed',
              achLastUpdated: new Date().toISOString()
            };
            
            await updateAccount(clientId, updatedClientData);
            setAccount(updatedClientData);
          }
        } else if (clientData.achInfo) {
          // If client has ACH data but user doesn't, sync from client to user
          await setDoc(doc(db, 'users', userData.uid, 'billing', 'ach'), {
            ...clientData.achInfo,
            lastUpdated: new Date().toISOString()
          });
        }
      }
    } catch (error) {
      console.error('Error syncing ACH data with portal user:', error);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      // You could add a toast notification here if you have one
      console.log('Copied to clipboard:', text);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const maskSensitiveData = (text, visibleChars = 4) => {
    if (!text) return 'Not provided';
    if (showSensitiveData) return text;
    return text.slice(0, visibleChars) + '•'.repeat(Math.max(0, text.length - visibleChars));
  };

  const handleInviteToPortal = async () => {
    if (!account) return;
    
    setIsInvitingToPortal(true);
    try {
      const inviteData = {
        leadId: clientId,
        email: account.contact?.email || '',
        firstName: account.contact?.firstName || '',
        lastName: account.contact?.lastName || '',
        company: account.company || 'Unknown Company'
      };

      const result = await createPortalInvite(inviteData);
      
      // Use the signup URL from the service
      setGeneratedInviteLink(result.signupUrl);
      setInviteModalRecipient(null);
      setShowInviteLinkModal(true);
      
      // Update client status to "Portal Invite Generated"
      const updatedData = { ...account };
      updatedData.substatus = 'Portal Invite Generated';
      
      // Add to status history
      const statusEntry = {
        status: 'Portal Invite Generated',
        previousStatus: account.substatus || account.stage,
        date: new Date().toISOString(),
        updatedBy: currentUser?.displayName || currentUser?.email || 'Unknown User',
        action: 'Portal invitation link generated for client'
      };
      
      updatedData.statusHistory = [...(updatedData.statusHistory || []), statusEntry];
      
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);
      
    } catch (error) {
      console.error('Error generating portal invite:', error);
      alert(`Failed to generate portal invitation: ${error.message}`);
    } finally {
      setIsInvitingToPortal(false);
    }
  };

  const handleAddTeamMember = () => {
    setNewTeamMemberForm({ firstName: '', lastName: '', email: '' });
    setShowAddTeamMemberModal(true);
  };

  const handleSubmitAddTeamMember = async () => {
    if (isAddingTeamMember) return;
    const { firstName, lastName, email } = newTeamMemberForm;
    const trimmedEmail = (email || '').trim().toLowerCase();
    if (!trimmedEmail) {
      alert('Please enter an email address.');
      return;
    }
    if (!(firstName || lastName)) {
      alert('Please enter at least a first or last name.');
      return;
    }
    if (!account) return;

    // Don't stack a second person (or a second invite) on an email already on the roster
    const existingMember = (teamMembers || []).find((m) => {
      const emails = [m.email, ...(m.alternateEmails || [])]
        .filter(Boolean)
        .map((e) => String(e).trim().toLowerCase());
      return emails.includes(trimmedEmail);
    });
    const primaryEmail = String(account.contact?.email || account.email || '').trim().toLowerCase();

    if (existingMember && !existingMember.isPendingInvite) {
      alert(`${existingMember.name || trimmedEmail} already has a portal account for this company.`);
      return;
    }
    if (!existingMember && primaryEmail && primaryEmail === trimmedEmail) {
      alert('That email belongs to the primary contact for this company.');
      return;
    }
    if (existingMember?.isPendingInvite) {
      const proceed = window.confirm(
        `${existingMember.name || trimmedEmail} already has a pending invitation. Show that existing link instead of creating a new one?`
      );
      if (!proceed) return;
    }

    setIsAddingTeamMember(true);
    try {
      const inviteData = {
        leadId: clientId,
        email: trimmedEmail,
        firstName: (firstName || '').trim(),
        lastName: (lastName || '').trim(),
        company: account.company || 'Unknown Company'
      };
      const result = await createPortalInvite(inviteData);
      setGeneratedInviteLink(result.signupUrl);
      setInviteModalRecipient({ firstName: inviteData.firstName, lastName: inviteData.lastName, email: inviteData.email });
      setShowAddTeamMemberModal(false);
      setNewTeamMemberForm({ firstName: '', lastName: '', email: '' });
      setShowInviteLinkModal(true);
      setTeamMembersRefreshKey((k) => k + 1);
    } catch (error) {
      console.error('Error generating team member invite:', error);
      alert(`Failed to generate team member invitation: ${error.message}`);
    } finally {
      setIsAddingTeamMember(false);
    }
  };

  const handleCopyMemberInviteLink = async (member) => {
    if (!member?.inviteToken) {
      alert('No invitation link is available for this member. Delete the pending invite and add them again to generate a new link.');
      return;
    }
    try {
      await navigator.clipboard.writeText(buildInviteSignupUrl(member.inviteToken, member.email));
      setCopiedInviteMemberId(member.id);
      setTimeout(() => {
        setCopiedInviteMemberId((current) => (current === member.id ? null : current));
      }, 2000);
    } catch (error) {
      console.error('Failed to copy invite link:', error);
      alert('Could not copy the invitation link to your clipboard.');
    }
  };

  const handleDeletePendingInvite = async (member) => {
    if (!member?.isPendingInvite || !member.id?.startsWith('invite:')) return;
    const inviteId = member.id.slice('invite:'.length);
    if (!inviteId) return;
    const label = member.name || member.email || 'this invitation';
    if (!window.confirm(`Delete the pending invitation for ${label}? They will no longer be able to sign up with the existing link.`)) {
      return;
    }
    setDeletingInviteId(member.id);
    try {
      await deleteDoc(doc(db, 'portalInvites', inviteId));
      setTeamMembers((prev) => prev.filter((m) => m.id !== member.id));
    } catch (error) {
      console.error('Error deleting pending invite:', error);
      alert(`Failed to delete invitation: ${error.message}`);
    } finally {
      setDeletingInviteId(null);
    }
  };

  const handlePromoteToPortal = async () => {
    try {
      const updatedData = { ...account };
      
      // Grant portal access. program.status stays as is: it is the client's tier and price basis.
      updatedData.program = programMapWith(updatedData.program, {
        clientStatus: 'Active',
        portalAccess: true,
        promotedToPortalDate: new Date().toISOString()
      });
      
      // Update the stage to reflect they're now a portal client
      updatedData.stage = 'Portal Client';
      
      // Add to status history
      const statusEntry = {
        status: 'Promoted to Portal',
        previousStatus: account.stage || 'Unknown',
        date: new Date().toISOString(),
        updatedBy: currentUser?.displayName || currentUser?.email || 'Unknown User',
        action: 'Client promoted from start directory to portal directory'
      };
      
      updatedData.statusHistory = [...(updatedData.statusHistory || []), statusEntry];
      
      // Clean up any invalid date fields before saving
      const cleanData = { ...updatedData };
      // Lead-only partial list; full portal clients must see every SOP
      cleanData.unlockedSOPs = deleteField();
      
      // Remove or fix any invalid date fields that might cause issues
      if (cleanData.contractStart && isNaN(new Date(cleanData.contractStart).getTime())) {
        delete cleanData.contractStart;
      }
      if (cleanData.contractEnd && isNaN(new Date(cleanData.contractEnd).getTime())) {
        delete cleanData.contractEnd;
      }
      
      // Save to database
      await updateAccount(clientId, cleanData);
      setAccount(updatedData);
      setShowPromoteModal(false);
      
      // Show success message
      alert('Client successfully promoted to portal! They now have access to the full client portal.');
      
    } catch (error) {
      console.error('Error promoting client to portal:', error);
      alert('Failed to promote client to portal. Please try again.');
    }
  };

  // ACH form validation and formatting
  const formatRoutingNumber = (value) => {
    return value.replace(/\D/g, '').slice(0, 9);
  };

  const formatAccountNumber = (value) => {
    return value.replace(/\D/g, '').slice(0, 17);
  };

  const validateACHForm = () => {
    const errors = {};
    
    if (!achFormData.accountType) {
      errors.accountType = 'Account type is required';
    }
    if (!achFormData.bankName.trim()) {
      errors.bankName = 'Bank name is required';
    }
    if (!achFormData.routingNumber.trim()) {
      errors.routingNumber = 'Routing number is required';
    } else if (achFormData.routingNumber.length !== 9) {
      errors.routingNumber = 'Routing number must be 9 digits';
    }
    if (!achFormData.accountNumber.trim()) {
      errors.accountNumber = 'Account number is required';
    }
    if (!achFormData.nameOnAccount.trim()) {
      errors.nameOnAccount = 'Name on account is required';
    }
    
    setAchFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleACHFormSubmit = async () => {
    if (!validateACHForm()) {
      return;
    }

    try {
      const updatedData = { ...account };
      updatedData.achInfo = achFormData;
      updatedData.achStatus = 'Completed';
      updatedData.achLastUpdated = new Date().toISOString();
      
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);
      
      // Also sync to linked portal user's billing collection
      if (account.contact?.email) {
        const usersQuery = query(
          collection(db, 'users'),
          where('email', '==', account.contact.email)
        );
        const usersSnapshot = await getDocs(usersQuery);
        
        if (!usersSnapshot.empty) {
          const userDoc = usersSnapshot.docs[0];
          const userData = userDoc.data();
          
          // Save to user's billing collection
          await setDoc(doc(db, 'users', userData.uid, 'billing', 'ach'), {
            ...achFormData,
            lastUpdated: new Date().toISOString()
          });
        }
      }
      
      setShowACHUploadModal(false);
      setAchFormData({
        accountType: '',
        bankName: '',
        routingNumber: '',
        accountNumber: '',
        nameOnAccount: ''
      });
      setAchFormErrors({});
      
      alert('ACH information saved successfully!');
    } catch (error) {
      console.error('Error saving ACH information:', error);
      alert('Failed to save ACH information. Please try again.');
    }
  };

  // Load program data and available items for deliverables (pass updatedAccount after add/remove/adjust so cards use latest data)
  const loadProgramData = async (accountOverride) => {
    const acc = accountOverride ?? account;
    if (!acc) return;
    const generation = ++loadProgramDataGenerationRef.current;
    const isStale = () => generation !== loadProgramDataGenerationRef.current;
    try {
      const bundle = await fetchProgramDeliverablesBundle(acc, contractData || null);
      if (isStale()) return;
      setAvailableItems(bundle.itemsData);
      setProgramItems(bundle.programItems || []);
      setProgramPriceData(bundle.programPriceData ?? null);
      // Scheduled next-period changes were folded into the roster during this load (reset date
      // reached) — sync local account state so cards, badges, and the log reflect the new period.
      if (bundle.appliedAccount) setAccount(bundle.appliedAccount);
    } catch (error) {
      console.error('Error loading program data:', error);
      if (!accountOverride && !isStale()) setProgramItems([]);
    }
  };

  const isStrategyCallDeliverable = (item) => {
    const name = (item?.name || item?.deliverable?.name || '').toLowerCase();
    return isStrategyCallDeliverableName(name) || name.includes('1:1');
  };

  const handleDeliverableClick = (item) => {
    setSelectedDeliverable(item);
    setActiveDeliverableTab('update');
    setDeliverableEditQuantity(Number(item.programQuantity) || parseInt(item.deliverable?.quantity, 10) || 1);
    setDeliverableQuantityEditing(false);

    const progress = resolveDeliverableProgress(account, item.id, item.deliverableCatalogId);
    const logs = progress.logs || [];
    setDeliverableLogs(logs);

    const period = item.deliverable?.period || item.deliverable?.frequency || 'One Time';
    const billingPeriod = isMonthlyDeliverablePeriod(period)
      ? getAccountStrategyCallPeriod(account, contractData)
      : null;
    const currentPeriod = billingPeriod ? billingPeriod.periodKey : getCurrentPeriod(period);

    setDeliverableUpdate({
      completed: 0,
      date: new Date().toISOString().split('T')[0],
      period: currentPeriod,
      completedWith: ''
    });
    setDeliverableLogPeriodIndex(0);
    setShowDeliverableModal(true);
  };

  // Deliverable period/frequency: Month/Monthly = resets each billing period; One Time = forever (never resets)
  const getCurrentPeriodDisplay = (period) => {
    const p = (period || '').trim();
    const now = new Date();
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    
    switch (p) {
      case 'One Time':
        return 'One Time';
      case 'Week':
        return `Week ${Math.ceil(now.getDate() / 7)}`;
      case 'Month':
      case 'Monthly':
        return monthNames[now.getMonth()];
      case 'Quarter':
        return `Q${Math.ceil((now.getMonth() + 1) / 3)}`;
      case 'Year':
        return now.getFullYear().toString();
      default:
        return 'One Time';
    }
  };

  const getDeliverablePeriodDisplay = (period) => {
    if (isMonthlyDeliverablePeriod(period)) {
      const billingPeriod = getAccountStrategyCallPeriod(account, contractData);
      return billingPeriod?.displayLabel || '—';
    }
    return getCurrentPeriodDisplay(period);
  };

  const getRenewsOnDate = () => lifecycle.renewsOn;

  const handleDeliverableUpdate = async () => {
    if (!selectedDeliverable) return;

    try {
      const prevProgress = resolveDeliverableProgress(
        account,
        selectedDeliverable.id,
        selectedDeliverable.deliverableCatalogId
      );
      const prevLogs = Array.isArray(prevProgress.logs) ? prevProgress.logs : [];

      let nextLogs;
      let lastCompleted;

      if (deliverableUpdate.completed > 0) {
        const newLog = {
          id: Date.now().toString(),
          quantity: deliverableUpdate.completed,
          date: deliverableUpdate.date,
          period: deliverableUpdate.period,
          completedWith: deliverableUpdate.completedWith || '',
          timestamp: new Date().toISOString()
        };
        nextLogs = [...prevLogs, newLog];
        lastCompleted = deliverableUpdate.date;
      } else {
        const itemPeriod =
          selectedDeliverable.deliverable?.period || selectedDeliverable.deliverable?.frequency || 'One Time';
        const billingPeriod = isMonthlyDeliverablePeriod(itemPeriod)
          ? getAccountStrategyCallPeriod(account, contractData)
          : null;

        if (billingPeriod) {
          nextLogs = prevLogs.filter((log) => {
            const logDate = parseFlexibleAccountDate(log.date) || parseFlexibleAccountDate(log.timestamp);
            if (!logDate) return true;
            return logDate < billingPeriod.periodStart || logDate >= billingPeriod.periodEnd;
          });
        } else if (isOneTimeStylePeriod(deliverableUpdate.period)) {
          nextLogs = prevLogs.filter(
            (log) =>
              !isOneTimeStylePeriod(log.period) && log.period !== deliverableUpdate.period && log.period
          );
        } else {
          nextLogs = prevLogs.filter((log) => log.period !== deliverableUpdate.period);
        }
        if (nextLogs.length > 0) {
          const mostRecentLog = [...nextLogs].sort(
            (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
          )[0];
          lastCompleted = mostRecentLog.date;
        } else {
          lastCompleted = null;
        }
      }

      const nextSlice = {
        ...prevProgress,
        logs: nextLogs,
        lastCompleted,
        lastUpdated: new Date().toISOString()
      };

      await updateAccountDeliverableSlice(clientId, selectedDeliverable.id, nextSlice);

      const catId = selectedDeliverable.deliverableCatalogId;
      if (catId && String(catId) !== String(selectedDeliverable.id)) {
        try {
          await updateDoc(doc(db, 'accounts', clientId), {
            [`deliverables.${catId}`]: deleteField(),
            updatedAt: Timestamp.fromDate(new Date())
          });
        } catch (legacyErr) {
          console.warn('Could not remove legacy deliverable key', legacyErr);
        }
      }

      const nextDeliverables = {
        ...(account.deliverables || {}),
        [selectedDeliverable.id]: nextSlice
      };
      if (catId && String(catId) !== String(selectedDeliverable.id)) {
        delete nextDeliverables[catId];
      }

      const updatedData = {
        ...account,
        deliverables: nextDeliverables
      };
      setAccount(updatedData);

      const period =
        selectedDeliverable.deliverable?.period || selectedDeliverable.deliverable?.frequency || 'One Time';
      const billingPeriod = isMonthlyDeliverablePeriod(period)
        ? getAccountStrategyCallPeriod(updatedData, contractData)
        : null;
      const cp = billingPeriod ? billingPeriod.periodKey : getCurrentPeriod(period);
      const currentPeriodLogs = filterLogsForCurrentPeriod(
        nextSlice.logs || [],
        period,
        cp,
        billingPeriod
      );
      const currentCompleted = currentPeriodLogs.reduce((sum, log) => sum + log.quantity, 0);

      setProgramItems((prevItems) =>
        prevItems.map((item) =>
          item.id === selectedDeliverable.id
            ? {
                ...item,
                completed: currentCompleted,
                lastCompleted: nextSlice.lastCompleted,
                currentPeriod: deliverableUpdate.period
              }
            : item
        )
      );
      
      setShowDeliverableModal(false);
      setSelectedDeliverable(null);
      setDeliverableQuantityEditing(false);
      setDeliverableUpdate({ completed: 0, date: '', period: '', completedWith: '' });
      setDeliverableLogs([]);
      setDeliverableLogPeriodIndex(0);
      setShowCompletedWithDropdown(false);
      
    } catch (error) {
      console.error('Error updating deliverable:', error);
      alert('Failed to update deliverable. Please try again.');
    }
  };

  const programStatus = typeof account?.program === 'string' ? account.program : account?.program?.status;
  const isCustomProgram = programStatus === 'Custom';
  const canEditDeliverables = isEditMode && (isCustomProgram || programItems.length > 0);

  const deliverableChangeActor = currentUser?.displayName || currentUser?.email || 'Unknown User';

  // Pending next-period changes keyed by item, for the card badges + header count.
  const scheduledDeliverableChangesByItemId = {};
  (Array.isArray(account?.scheduledDeliverableChanges) ? account.scheduledDeliverableChanges : []).forEach((c) => {
    if (c?.itemId) scheduledDeliverableChangesByItemId[c.itemId] = c;
  });
  const pendingScheduledCount = Object.keys(scheduledDeliverableChangesByItemId).length;
  const nextPeriodBadgeLabel = (c) =>
    c.type === 'remove' ? 'removed' : c.type === 'quantity' ? `qty → ${c.quantity}` : `added ×${c.quantity}`;

  // Record an immediate roster edit in the deliverable change log. Fire-and-forget, called AFTER
  // the main save: the log is a targeted field write, so a full-document save that already
  // completed cannot clobber it.
  const logDeliverableChange = (action, item, description) => {
    appendDeliverableChangeLog(
      clientId,
      buildChangeLogEntry({
        actor: deliverableChangeActor,
        action,
        itemId: item?.id,
        itemName: item?.name || item?.itemName || item?.title || item?.id,
        description,
      })
    )
      .then((log) => {
        setAccount((prev) => (prev ? { ...prev, deliverableChangeLog: log } : prev));
      })
      .catch((err) => {
        console.warn('Could not record deliverable change log entry', err);
      });
  };

  const handleAddDeliverable = async (alaCarteItem) => {
    if (!clientId || !account) return;
    try {
      const updatedData = { ...account };
      if (isCustomProgram) {
        const list = Array.isArray(updatedData.customProgramDeliverables) ? [...updatedData.customProgramDeliverables] : [];
        if (list.includes(alaCarteItem.id)) return;
        updatedData.customProgramDeliverables = [...list, alaCarteItem.id];
        updatedData.customProgramDeliverableQuantities = { ...(updatedData.customProgramDeliverableQuantities || {}), [alaCarteItem.id]: 1 };
      } else {
        const extra = Array.isArray(updatedData.extraDeliverables) ? [...updatedData.extraDeliverables] : [];
        if (extra.some(e => e.id === alaCarteItem.id)) return;
        updatedData.extraDeliverables = [...extra, { id: alaCarteItem.id, quantity: 1 }];
      }
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);
      setShowAddDeliverablePicker(false);
      logDeliverableChange(
        'added',
        alaCarteItem,
        `Added ${alaCarteItem.name || alaCarteItem.itemName || alaCarteItem.title || alaCarteItem.id} (qty 1)`
      );
      await loadProgramData(updatedData);
    } catch (error) {
      console.error('Error adding deliverable:', error);
      alert('Failed to add deliverable.');
    }
  };

  // Add a deliverable pinned to the client's CURRENT billing period only. Works both as a brand-new
  // one-off deliverable (item not already listed) and as a this-period-only quantity bump (item
  // already listed). It disappears automatically when the period rolls over.
  const handleAddPeriodDeliverable = async (alaCarteItem, quantity) => {
    if (!clientId || !account) return;
    try {
      const qty = Math.max(1, parseInt(String(quantity), 10) || 1);
      const periodKey = getCurrentDeliverablePeriodKey(account, contractData);
      const updatedList = await addAccountPeriodDeliverable(clientId, alaCarteItem.id, qty, periodKey);
      const updatedData = { ...account, periodDeliverables: updatedList };
      setAccount(updatedData);
      setShowAddDeliverablePicker(false);
      logDeliverableChange(
        'added-period-only',
        alaCarteItem,
        `Added ${alaCarteItem.name || alaCarteItem.itemName || alaCarteItem.title || alaCarteItem.id} ×${qty} for the current period only`
      );
      await loadProgramData(updatedData);
    } catch (error) {
      console.error('Error adding period deliverable:', error);
      alert('Failed to add one-period deliverable.');
    }
  };

  // Remove a one-period-only deliverable (or this-period quantity bump) for the current period.
  const handleRemovePeriodDeliverable = async (item) => {
    if (!clientId || !account || !item?.oneTimePeriodKey) return;
    try {
      const updatedList = await removeAccountPeriodDeliverable(clientId, item.id, item.oneTimePeriodKey);
      const updatedData = { ...account, periodDeliverables: updatedList };
      setAccount(updatedData);
      logDeliverableChange(
        'removed-period-only',
        item,
        `Removed one-period ${item.name || item.id} for the current period`
      );
      await loadProgramData(updatedData);
    } catch (error) {
      console.error('Error removing period deliverable:', error);
      alert('Failed to remove one-period deliverable.');
    }
  };

  const handleRemoveDeliverable = async (item) => {
    if (!clientId || !account) return;
    // A pure one-off row (not part of the recurring roster) is removed from periodDeliverables.
    if (item?.oneTimePeriodOnly) {
      return handleRemovePeriodDeliverable(item);
    }
    try {
      const updatedData = { ...account };
      if (isCustomProgram) {
        updatedData.customProgramDeliverables = (updatedData.customProgramDeliverables || []).filter(id => id !== item.id);
        const qty = { ...(updatedData.customProgramDeliverableQuantities || {}) };
        delete qty[item.id];
        updatedData.customProgramDeliverableQuantities = qty;
      } else {
        const inExtra = (updatedData.extraDeliverables || []).some(e => e.id === item.id);
        if (inExtra) {
          updatedData.extraDeliverables = (updatedData.extraDeliverables || []).filter(e => e.id !== item.id);
        } else {
          updatedData.removedDeliverableIds = [...(updatedData.removedDeliverableIds || []), item.id];
        }
      }
      // Drop any one-period bumps for this item too, so they don't resurface as a standalone row.
      if (Array.isArray(updatedData.periodDeliverables) && updatedData.periodDeliverables.some(e => e?.id === item.id)) {
        updatedData.periodDeliverables = updatedData.periodDeliverables.filter(e => e?.id !== item.id);
      }
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);
      logDeliverableChange('removed', item, `Removed ${item.name || item.id}`);
      await loadProgramData(updatedData);
    } catch (error) {
      console.error('Error removing deliverable:', error);
      alert('Failed to remove deliverable.');
    }
  };

  const handleAdjustDeliverableQuantity = async (item, newQty) => {
    if (!clientId) return;
    const itemId = item?.id;
    if (!itemId) {
      console.error('Deliverable item has no id', item);
      alert('Cannot save: deliverable has no id.');
      return;
    }
    const qty = Math.max(0, parseInt(String(newQty), 10) || 0);
    try {
      // Detect whether this deliverable belongs to a custom program configuration
      // based on the account's customProgramDeliverables list, not just program status.
      const customIds = Array.isArray(account?.customProgramDeliverables)
        ? account.customProgramDeliverables
        : [];
      const isCustom = customIds.includes(itemId);
      if (isCustom) {
        await updateAccountDeliverableQuantity(clientId, itemId, qty);
        const updatedQuantities = { ...(account?.customProgramDeliverableQuantities || {}), [itemId]: qty };
        // Mirror the writer: drop any stale override for this id so the optimistic rebuild doesn't
        // keep shadowing the new custom quantity with an old deliverableQuantityOverrides value.
        const updatedOverrides = { ...(account?.deliverableQuantityOverrides || {}) };
        delete updatedOverrides[itemId];
        const updatedData = {
          ...account,
          customProgramDeliverableQuantities: updatedQuantities,
          deliverableQuantityOverrides: updatedOverrides,
        };
        setAccount(updatedData);
        await loadProgramData(updatedData);
      } else {
        const latest = await getAccountById(clientId);
        const base = latest || account;
        if (!base) return;
        const extra = (base.extraDeliverables || []).find(e => e.id === itemId);
        if (extra) {
          const updatedData = { ...base };
          updatedData.extraDeliverables = (updatedData.extraDeliverables || []).map(e => e.id === itemId ? { ...e, quantity: qty } : e);
          await updateAccount(clientId, updatedData);
          setAccount(updatedData);
          await loadProgramData(updatedData);
        } else {
          await updateAccountDeliverableQuantityOverride(clientId, itemId, qty);
          const updatedOverrides = { ...(account?.deliverableQuantityOverrides || {}), [itemId]: qty };
          const updatedData = { ...account, deliverableQuantityOverrides: updatedOverrides };
          setAccount(updatedData);
          await loadProgramData(updatedData);
        }
      }
      const prevQty = Number(item?.programQuantity);
      logDeliverableChange(
        'quantity-changed',
        item,
        Number.isFinite(prevQty)
          ? `${item.name || itemId} quantity ${prevQty} → ${qty}`
          : `${item.name || itemId} quantity → ${qty}`
      );
    } catch (error) {
      console.error('Error adjusting quantity:', error);
      alert('Failed to update quantity.');
      throw error;
    }
  };

  const handleDeleteLog = async (logId) => {
    if (!selectedDeliverable) return;

    try {
      const prevProgress = resolveDeliverableProgress(
        account,
        selectedDeliverable.id,
        selectedDeliverable.deliverableCatalogId
      );
      const prevLogs = Array.isArray(prevProgress.logs) ? prevProgress.logs : [];
      const remainingLogs = prevLogs.filter((log) => log.id !== logId);

      let lastCompleted = null;
      if (remainingLogs.length > 0) {
        const mostRecentLog = [...remainingLogs].sort(
          (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
        )[0];
        lastCompleted = mostRecentLog.date;
      }

      const nextSlice = {
        ...prevProgress,
        logs: remainingLogs,
        lastCompleted,
        lastUpdated: new Date().toISOString()
      };

      await updateAccountDeliverableSlice(clientId, selectedDeliverable.id, nextSlice);

      const catId = selectedDeliverable.deliverableCatalogId;
      if (catId && String(catId) !== String(selectedDeliverable.id)) {
        try {
          await updateDoc(doc(db, 'accounts', clientId), {
            [`deliverables.${catId}`]: deleteField(),
            updatedAt: Timestamp.fromDate(new Date())
          });
        } catch (legacyErr) {
          console.warn('Could not remove legacy deliverable key', legacyErr);
        }
      }

      const nextDeliverables = {
        ...(account.deliverables || {}),
        [selectedDeliverable.id]: nextSlice
      };
      if (catId && String(catId) !== String(selectedDeliverable.id)) {
        delete nextDeliverables[catId];
      }

      const updatedData = {
        ...account,
        deliverables: nextDeliverables
      };
      setAccount(updatedData);

      setDeliverableLogs(remainingLogs);

      const period =
        selectedDeliverable.deliverable?.period || selectedDeliverable.deliverable?.frequency || 'One Time';
      const billingPeriod = isMonthlyDeliverablePeriod(period)
        ? getAccountStrategyCallPeriod(updatedData, contractData)
        : null;
      const currentPeriod = billingPeriod ? billingPeriod.periodKey : getCurrentPeriod(period);
      const currentPeriodLogs = filterLogsForCurrentPeriod(
        remainingLogs,
        period,
        currentPeriod,
        billingPeriod
      );
      const currentCompleted = currentPeriodLogs.reduce((sum, log) => sum + log.quantity, 0);

      setProgramItems((prevItems) =>
        prevItems.map((item) =>
          item.id === selectedDeliverable.id
            ? {
                ...item,
                completed: currentCompleted,
                lastCompleted: nextSlice.lastCompleted,
                currentPeriod: currentPeriod
              }
            : item
        )
      );
      
    } catch (error) {
      console.error('Error deleting log:', error);
      alert('Failed to delete log entry. Please try again.');
    }
  };

  const handleCommunityToggle = async () => {
    try {
      const newStatus = communityStatus === 'Active' ? 'Inactive' : 'Active';
      const updatedData = { ...account };
      updatedData.communityStatus = newStatus;
      updatedData.lastUpdated = new Date().toISOString();
      
      // Update account data
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);
      setCommunityStatus(newStatus);
      
      // Update user active status in users collection if client has portal account
      if (account.contact?.email) {
        try {
          const user = await getUserByEmail(account.contact.email);
          if (user) {
            await updateUserActiveStatus(user.id, newStatus === 'Active');
            console.log(`User ${user.id} active status updated to ${newStatus === 'Active'}`);
          } else {
            console.log('No portal user found for email:', account.contact.email);
          }
        } catch (userError) {
          console.error('Error updating user active status:', userError);
          // Don't show error to user as account update was successful
        }
      }
      
    } catch (error) {
      console.error('Error updating community status:', error);
      alert('Failed to update community status. Please try again.');
    }
  };

  const handlePortalPageAccessToggle = async (accessKey) => {
    if (!account?.id) return;
    try {
      const current = account.portalAccess || {};
      const newValue = !(current[accessKey] === true);
      const updatedPortalAccess = { ...current, [accessKey]: newValue };
      const accountRef = doc(db, 'accounts', account.id);
      await updateDoc(accountRef, {
        portalAccess: updatedPortalAccess,
        updatedAt: Timestamp.fromDate(new Date())
      });
      setAccount(prev => ({ ...prev, portalAccess: updatedPortalAccess }));
      // Notify portal users so their sidebar/access refreshes
      const usersRef = collection(db, 'users');
      const accountQuery = query(usersRef, where('accountId', '==', account.id));
      const clientQuery = query(usersRef, where('clientId', '==', account.id));
      const [accountSnap, clientSnap] = await Promise.all([getDocs(accountQuery), getDocs(clientQuery)]);
      const allDocs = [...(accountSnap.docs || []), ...(clientSnap.docs || [])];
      const seen = new Set();
      allDocs.forEach(d => { if (d.id && !seen.has(d.id)) { seen.add(d.id); portalAccessEventService.notifyAccessChanged(d.id); } });
    } catch (error) {
      console.error('Error updating portal page access:', error);
      alert('Failed to update portal page access. Please try again.');
    }
  };

  const handleLockToggle = async () => {
    const isCurrentlyLocked = account.lockStatus === 'locked';

    setIsLocking(true);
    try {
      const updatedData = { ...account };
      const newLockStatus = isCurrentlyLocked ? 'unlocked' : 'locked';

      updatedData.lockStatus = newLockStatus;
      if (!isCurrentlyLocked) {
        // The locked dashboard no longer shows a client-facing message; clear
        // any stale one so nothing odd resurfaces if that ever changes.
        updatedData.lockMessage = '';
        // Locking hides the whole portal, so every page-access toggle flips off
        // with it — the Access tab reflects reality and an unlock later starts
        // from a clean slate instead of silently restoring old access.
        const clearedAccess = { ...(account.portalAccess || {}) };
        PORTAL_PAGE_TOGGLE_KEYS.forEach((key) => { clearedAccess[key] = false; });
        updatedData.portalAccess = clearedAccess;
      }
      updatedData.lockDate = new Date().toISOString();
      updatedData.lockedBy = currentUser?.displayName || currentUser?.email || 'Unknown User';
      updatedData.lastUpdated = new Date().toISOString();
      
      // If unlocking, ensure contact email exists
      if (newLockStatus === 'unlocked' && !account.contact?.email) {
        alert('Cannot unlock account without an email address. Please add an email first.');
        setIsLocking(false);
        return;
      }
      
      // Add to status history
      const statusEntry = {
        status: `Account ${newLockStatus}`,
        previousStatus: isCurrentlyLocked ? 'Locked' : 'Unlocked',
        date: new Date().toISOString(),
        updatedBy: currentUser?.displayName || currentUser?.email || 'Unknown User',
        action: `Account ${newLockStatus}`
      };
      
      updatedData.statusHistory = [...(updatedData.statusHistory || []), statusEntry];
      
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);

      // Nudge any signed-in portal users so the lock (and cleared page access)
      // takes effect live instead of on their next full reload.
      try {
        const usersRef = collection(db, 'users');
        const accountQuery = query(usersRef, where('accountId', '==', clientId));
        const clientQuery = query(usersRef, where('clientId', '==', clientId));
        const [accountSnap, clientSnap] = await Promise.all([getDocs(accountQuery), getDocs(clientQuery)]);
        const seen = new Set();
        [...(accountSnap.docs || []), ...(clientSnap.docs || [])].forEach((d) => {
          if (d.id && !seen.has(d.id)) {
            seen.add(d.id);
            portalAccessEventService.notifyAccessChanged(d.id);
          }
        });
      } catch (notifyError) {
        console.error('Error notifying portal users of lock change:', notifyError);
      }

      setShowLockModal(false);

    } catch (error) {
      console.error('Error updating lock status:', error);
      alert('Failed to update lock status. Please try again.');
    } finally {
      setIsLocking(false);
    }
  };

  const handleShowOnKanbanUpdate = async (shouldShow) => {
    try {
      const updatedData = { ...account };
      updatedData.showOnKanban = shouldShow;
      
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);
      setShowOnKanban(shouldShow);
    } catch (error) {
      console.error('Error updating show on kanban status:', error);
      alert('Failed to update show on kanban status. Please try again.');
    }
  };

  /**
   * Move the client between Active / Canceled / Lost / Archived. The program tier is never
   * touched — program.clientStatus, lostAt|canceledAt|archivedAt, tierBeforeLost and a history
   * entry are written instead (accountLifecycle.applyClientLifecycleTransition).
   */
  const handleLifecycleChange = async (to) => {
    if (!account || !STORABLE_CLIENT_LIFECYCLES.includes(to)) return;
    if (to === clientLifecycle.storedState && !clientLifecycle.isDerived) {
      setEditingField(null);
      return;
    }
    try {
      const { account: next } = applyClientLifecycleTransition(account, {
        to,
        reason: to === 'Active' ? null : lostReason || null,
        by: currentUser?.displayName || currentUser?.email || 'Unknown User',
      });
      await updateAccount(clientId, next);
      setAccount(next);
      setEditingField(null);
    } catch (error) {
      console.error('Error updating client lifecycle:', error);
      alert('Failed to update client status. Please try again.');
    }
  };

  const handleLostReasonUpdate = async (reason) => {
    try {
      const updatedData = { ...account };
      updatedData.resultReason = reason;
      
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);
      setLostReason(reason);
    } catch (error) {
      console.error('Error updating lost reason:', error);
      alert('Failed to update lost reason. Please try again.');
    }
  };

  // Function to handle when client signs up to portal (called from portal signup process)
  const handlePortalSignup = async () => {
    try {
      const updatedData = { ...account };
      updatedData.substatus = 'Portal Signup Completed';
      updatedData.portalSignupDate = new Date().toISOString();
      updatedData.lastLogin = new Date().toISOString();
      
      // Add to status history
      const statusEntry = {
        status: 'Portal Signup Completed',
        previousStatus: account.substatus || account.stage,
        date: new Date().toISOString(),
        updatedBy: 'Client Self-Signup',
        action: 'Client completed portal signup process'
      };
      
      updatedData.statusHistory = [...(updatedData.statusHistory || []), statusEntry];
      
      await updateAccount(clientId, updatedData);
      setAccount(updatedData);
      
    } catch (error) {
      console.error('Error updating portal signup:', error);
    }
  };

  // Render NDA content with variables injected
  const renderNDAContentWithVariables = (content, ndaData) => {
    if (!content) return '';
    
    let updatedContent = content;
    const nda = ndaData || signedNDA || account?.signedNDA;
    
    // Get client data from account and NDA
    const clientData = {
      companyName: account?.company || nda?.companyName || '',
      state: account?.state || nda?.state || '',
      companyAddress: account?.streetAddress || account?.location || nda?.companyAddress || '',
      city: account?.city || nda?.city || '',
      zipCode: account?.zipCode || nda?.zipCode || '',
      businessStructure: account?.businessStructure || nda?.businessStructure || '',
      signerName: account?.contact?.name || nda?.signerName || '',
      signerTitle: account?.contact?.title || nda?.signerTitle || '',
      signature: nda?.signature || '',
      initial: nda?.initial || ''
    };

    // Replace client variables
    const clientVariables = {
      'Company Name': clientData.companyName,
      'Company_Name': clientData.companyName,
      'COMPANY_NAME': clientData.companyName,
      'State': clientData.state,
      'STATE': clientData.state,
      'Company Address': clientData.companyAddress,
      'Company_Address': clientData.companyAddress,
      'COMPANY_ADDRESS': clientData.companyAddress,
      'Address': clientData.companyAddress,
      'ADDRESS': clientData.companyAddress,
      'Street Address': clientData.companyAddress,
      'Street_Address': clientData.companyAddress,
      'City': clientData.city,
      'CITY': clientData.city,
      'Zip Code': clientData.zipCode,
      'Zip_Code': clientData.zipCode,
      'ZIP_CODE': clientData.zipCode,
      'Business Structure': clientData.businessStructure,
      'Business_Structure': clientData.businessStructure,
      'Signer Name': clientData.signerName,
      'Signer_Name': clientData.signerName,
      'SIGNER_NAME': clientData.signerName,
      'Signer Title': clientData.signerTitle,
      'Signer_Title': clientData.signerTitle,
      'SIGNER_TITLE': clientData.signerTitle,
      'Name': clientData.signerName,
      'NAME': clientData.signerName,
      'Title': clientData.signerTitle,
      'TITLE': clientData.signerTitle
    };

    Object.entries(clientVariables).forEach(([variableName, value]) => {
      const patterns = [
        new RegExp(`\\[${variableName}\\]`, 'g'),
        new RegExp(`\\{${variableName}\\}`, 'g')
      ];
      patterns.forEach(pattern => {
        updatedContent = updatedContent.replace(pattern, value || '');
      });
    });

    // Get BBA signature data from NDA
    const bbaSignature = nda?.bbaSignature || nda?.bbaFormData || {};
    const bbaName = bbaSignature.bbaName || 
                   bbaSignature.BBA_Name ||
                   Object.values(bbaSignature).find((val, idx, arr) => {
                     const key = Object.keys(bbaSignature)[idx];
                     return key && key.toLowerCase().includes('name') && typeof val === 'string' && val.trim().length > 0;
                   }) || 
                   'Builders Breakthrough Advisors';
    const bbaTitle = bbaSignature.bbaTitle || 
                    bbaSignature.BBA_Title ||
                    Object.values(bbaSignature).find((val, idx, arr) => {
                      const key = Object.keys(bbaSignature)[idx];
                      return key && key.toLowerCase().includes('title') && typeof val === 'string' && val.trim().length > 0;
                    }) || 
                    '';
    const bbaSignatureValue = bbaSignature.bbaSignature || 
                             bbaSignature.BBA_Signature ||
                             Object.values(bbaSignature).find((val, idx, arr) => {
                               const key = Object.keys(bbaSignature)[idx];
                               return key && key.toLowerCase().includes('signature') && typeof val === 'string' && val.trim().length > 0;
                             }) || 
                             '';
    // Get BBA date and format it properly (handle ISO timestamps)
    let bbaDateRaw = bbaSignature.bbaDate || 
                     bbaSignature.BBA_Date ||
                     bbaSignature.bbaSignatureDate || 
                     nda?.finalizedAt || 
                     nda?.bbaSignedAt ||
                     (nda?.isFullyExecuted ? new Date() : new Date());
    
    // Format date - if it's a string ISO timestamp, parse it; otherwise use as-is
    let bbaDate = '';
    if (bbaDateRaw) {
      try {
        // If it's already a formatted date string (like "12/11/2025"), use it
        if (typeof bbaDateRaw === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(bbaDateRaw)) {
          bbaDate = bbaDateRaw;
        } else {
          // Otherwise, parse and format it
          const dateObj = new Date(bbaDateRaw);
          if (!isNaN(dateObj.getTime())) {
            bbaDate = dateObj.toLocaleDateString('en-US', { 
              month: '2-digit', 
              day: '2-digit', 
              year: 'numeric' 
            });
          } else {
            bbaDate = new Date().toLocaleDateString('en-US', { 
              month: '2-digit', 
              day: '2-digit', 
              year: 'numeric' 
            });
          }
        }
      } catch (error) {
        // Fallback to current date if parsing fails
        bbaDate = new Date().toLocaleDateString('en-US', { 
          month: '2-digit', 
          day: '2-digit', 
          year: 'numeric' 
        });
      }
    } else {
      bbaDate = new Date().toLocaleDateString('en-US', { 
        month: '2-digit', 
        day: '2-digit', 
        year: 'numeric' 
      });
    }

    // Replace BBA variables
    const bbaVariables = {
      'BBA_Name': bbaName,
      'BBA Name': bbaName,
      'BBA_NAME': bbaName,
      'BBA_Title': bbaTitle,
      'BBA Title': bbaTitle,
      'BBA_TITLE': bbaTitle,
      'BBA_Signature': bbaSignatureValue,
      'BBA Signature': bbaSignatureValue,
      'BBA_SIGNATURE': bbaSignatureValue,
      'BBA_Date': bbaDate,
      'BBA Date': bbaDate,
      'BBA_DATE': bbaDate
    };

    Object.entries(bbaVariables).forEach(([variableName, value]) => {
      const patterns = [
        new RegExp(`\\[${variableName}\\]`, 'g'),
        new RegExp(`\\{${variableName}\\}`, 'g')
      ];
      patterns.forEach(pattern => {
        updatedContent = updatedContent.replace(pattern, value || '');
      });
    });

    // Get client initials
    const clientInitials = nda?.initial || 
                          nda?.initials ||
                          clientData.initial ||
                          (clientData.signerName ? clientData.signerName.split(' ').map(n => n[0]).join('').toUpperCase() : '');

    // Replace initial variables (Your_Initials, Initials_Two, Initials_Three, etc.)
    const initialPattern = /\[(Your_Initials|Initials_Two|Initials_Three|Initials?)\]/gi;
    updatedContent = updatedContent.replace(initialPattern, () => {
      return clientInitials || '[Initial]';
    });

    // Replace special variables
    const specialPattern = /\[(SIGNATURE|INITIAL|INITIALS|TEXT_INPUT|CHECKBOX|DATE)\]/gi;
    updatedContent = updatedContent.replace(specialPattern, (match, type) => {
      switch(type.toUpperCase()) {
        case 'SIGNATURE':
          return clientData.signature || '[Signature]';
        case 'INITIAL':
        case 'INITIALS':
          return clientInitials || '[Initial]';
        case 'CHECKBOX':
          return '☑ '; // Add space after checkbox for better readability
        case 'DATE':
          return nda?.signedAt ? new Date(nda.signedAt).toLocaleDateString() : new Date().toLocaleDateString();
        default:
          return match;
      }
    });
    
    return updatedContent;
  };

  // Render contract content with variables injected
  const renderContractContentWithVariables = (content, contract) => {
    if (!content) return '';
    
    let updatedContent = content;
    const contractData = contract || account?.signedContract || account?.contractData;
    
    // Get client data from account and contract
    // Prioritize contract data for signature-related fields since that's what was actually signed
    const clientData = {
      companyName: account?.company || contractData?.companyName || '',
      state: account?.state || contractData?.state || '',
      companyAddress: account?.streetAddress || account?.location || contractData?.companyAddress || '',
      city: account?.city || contractData?.city || '',
      zipCode: account?.zipCode || contractData?.zipCode || '',
      businessStructure: account?.businessStructure || contractData?.businessStructure || '',
      // For name, use signature if available (it's the actual signed name), otherwise fall back to signerName or contact name
      signerName: contractData?.signature?.trim() || contractData?.signerName || account?.contact?.name || '',
      // For title, prioritize contract signerTitle
      signerTitle: contractData?.signerTitle || account?.contact?.title || '',
      signature: contractData?.signature || '',
      initial: contractData?.initial || ''
    };

    // Get contract-specific variables
    let contractNumber = contractData?.contractNumber || contractData?.contractId || contractData?.documentId || 'N/A';
    
    // If contract number starts with "contract-", extract just the number part
    if (typeof contractNumber === 'string' && contractNumber.startsWith('contract-')) {
      contractNumber = contractNumber.replace(/^contract-/, '');
    }
    
    // Get program items - prioritize actual items list over program name
    let programItemsText = 'Not specified';
    
    // Check if contractData has programItems as an array
    if (contractData?.programItems && Array.isArray(contractData.programItems) && contractData.programItems.length > 0) {
      programItemsText = contractData.programItems
        .map(item => {
          const name = item.name || item.itemName || item.title || 'Item';
          const quantity = item.quantity || item.qty || 1;
          if (quantity === '0' || quantity === 0) {
            return name;
          } else {
            return `${name} (${quantity})`;
          }
        })
        .join(', ');
    }
    // Check account programSelectionData for items
    else if (account?.programSelectionData?.items && Array.isArray(account.programSelectionData.items) && account.programSelectionData.items.length > 0) {
      programItemsText = account.programSelectionData.items
        .map(item => {
          const name = item.name || item.itemName || item.title || 'Item';
          const quantity = item.quantity || item.qty || 1;
          if (quantity === '0' || quantity === 0) {
            return name;
          } else {
            return `${name} (${quantity})`;
          }
        })
        .join(', ');
    }
    // Check account programSelectionData for contractItems
    else if (account?.programSelectionData?.contractItems && Array.isArray(account.programSelectionData.contractItems) && account.programSelectionData.contractItems.length > 0) {
      programItemsText = account.programSelectionData.contractItems
        .map(item => {
          const name = item.name || item.itemName || item.title || 'Item';
          const quantity = item.quantity || item.qty || 1;
          if (quantity === '0' || quantity === 0) {
            return name;
          } else {
            return `${name} (${quantity})`;
          }
        })
        .join(', ');
    }
    // Check if programItems state has items (from program features)
    else if (programItems && Array.isArray(programItems) && programItems.length > 0) {
      programItemsText = programItems
        .map(item => {
          const name = item.name || item.itemName || item.title || 'Item';
          const quantity = item.programQuantity || item.quantity || item.qty || 1;
          if (quantity === '0' || quantity === 0) {
            return name;
          } else {
            return `${name} (${quantity})`;
          }
        })
        .join(', ');
    }
    // Fallback to program name only if no items found
    else {
      programItemsText = contractData?.program || 
                        account?.program?.name || 
                        account?.program?.status ||
                        account?.programSelectionData?.programName ||
                        'Not specified';
    }
    
    // Get monthly price from multiple sources - prioritize programSelectionData
    let monthlyPrice = null;
    
    const billingCycleForPrice =
      contractData?.billingCycle || account?.billingCycle || account?.program?.billingCycle || account?.programSelectionData?.billingCycle || 'monthly';
    const bcLower = String(billingCycleForPrice).toLowerCase();

    // First, try programSelectionData which should have the price (nested .program is used when saving from Program.js)
    if (account?.programSelectionData) {
      const programData = account.programSelectionData;
      const nestedProgram = programData.program || programData.selectedProgram;
      const basePrice =
        programData.pricePerMonth ||
        programData.monthlyPrice ||
        programData.price ||
        (nestedProgram &&
          (nestedProgram.pricePerMonth || nestedProgram.monthlyPrice || nestedProgram.price)) ||
        (programData.selectedProgram &&
          (programData.selectedProgram.pricePerMonth ||
            programData.selectedProgram.monthlyPrice ||
            programData.selectedProgram.price));

      if (basePrice) {
        if (bcLower === 'quarterly' || bcLower === 'quarter') {
          monthlyPrice = Math.round(basePrice * 3 * 0.9); // 10% discount
        } else if (bcLower === 'annual' || bcLower === 'year') {
          monthlyPrice = Math.round(basePrice * 12 * 0.8); // 20% discount
        } else {
          monthlyPrice = basePrice; // Monthly
        }
      }
    }
    
    // If still no price, check other sources
    if (!monthlyPrice) {
      monthlyPrice = contractData?.monthlyPrice || 
                    contractData?.price || 
                    contractData?.monthlyAmount ||
                    contractData?.amount ||
                    account?.signedContract?.monthlyPrice ||
                    account?.signedContract?.price ||
                    account?.signedContract?.monthlyAmount ||
                    account?.signedContract?.amount ||
                    account?.program?.monthlyAmount ||
                    account?.program?.price ||
                    account?.program?.monthlyPrice ||
                    null;
    }
    
    // If still no price, try to get from program data using program name
    if (!monthlyPrice) {
      const programName = contractData?.program || account?.program?.status || account?.program?.name;
      const billingCycle = contractData?.billingCycle || account?.billingCycle || account?.program?.billingCycle || 'monthly';
      const bcP = String(billingCycle).toLowerCase();

      // Try to get price from stored programPriceData (loaded in loadProgramData)
      const customNameMatch =
        programPriceData &&
        (programPriceData.name === programName ||
          programPriceData.id === programName ||
          (programPriceData.id === 'Custom' &&
            (programName === 'Custom' ||
              programName === 'Custom Program' ||
              /custom/i.test(String(programName || '')))));
      if (customNameMatch) {
        const basePrice = programPriceData.pricePerMonth || programPriceData.monthlyPrice || programPriceData.price;
        if (basePrice) {
          if (bcP === 'quarterly' || bcP === 'quarter') {
            monthlyPrice = Math.round(basePrice * 3 * 0.9); // 10% discount
          } else if (bcP === 'annual' || bcP === 'year') {
            monthlyPrice = Math.round(basePrice * 12 * 0.8); // 20% discount
          } else {
            monthlyPrice = basePrice; // Monthly
          }
        }
      }

      // Try to get from loadedProgramPrice (set by useEffect when modal opens)
      if (!monthlyPrice && loadedProgramPrice) {
        monthlyPrice = loadedProgramPrice;
      }
    }

    // Custom programs: Firestore template "Custom" is often $0; derive from alaCarte deliverables + quantities
    if (
      (!monthlyPrice || monthlyPrice === 0) &&
      isCustomProgramContractContext(contractData, account) &&
      Array.isArray(account?.customProgramDeliverables) &&
      account.customProgramDeliverables.length > 0 &&
      availableItems?.length > 0
    ) {
      const baseCustom = computeCustomProgramMonthlyBaseFromAccount(account, availableItems, billingCycleForPrice);
      if (baseCustom != null && baseCustom > 0) {
        if (bcLower === 'quarterly' || bcLower === 'quarter') {
          monthlyPrice = Math.round(baseCustom * 3 * 0.9);
        } else if (bcLower === 'annual' || bcLower === 'year') {
          monthlyPrice = Math.round(baseCustom * 12 * 0.8);
        } else {
          monthlyPrice = baseCustom;
        }
      }
    }
    
    // Format monthly price
    let formattedMonthlyPrice = '$0.00';
    if (monthlyPrice) {
      if (typeof monthlyPrice === 'number') {
        formattedMonthlyPrice = `$${monthlyPrice.toFixed(2)}`;
      } else if (typeof monthlyPrice === 'string') {
        // If it's already a string, check if it starts with $, if not add it
        formattedMonthlyPrice = monthlyPrice.startsWith('$') ? monthlyPrice : `$${monthlyPrice}`;
      } else {
        formattedMonthlyPrice = monthlyPrice.toString();
      }
    }
    
    const billingCycle = contractData?.billingCycle || account?.billingCycle || account?.program?.billingCycle || account?.programSelectionData?.billingCycle || 'monthly';
    const startDate = contractData?.startDate || account?.program?.startDate || new Date().toLocaleDateString();

    const billingCycleNorm = String(billingCycle || 'monthly').toLowerCase();
    // Get billing cycle text
    const billingCycleText = billingCycleNorm === 'quarterly' || billingCycleNorm === 'quarter'
      ? 'Quarterly'
      : billingCycleNorm === 'annual' || billingCycleNorm === 'year'
        ? 'Annual'
        : billingCycleNorm === 'weekly' || billingCycleNorm === 'week'
          ? 'Weekly'
          : 'Monthly';

    // Get billing days (typically 30 for monthly)
    const billingDays = billingCycleNorm === 'quarterly' || billingCycleNorm === 'quarter'
      ? '90'
      : billingCycleNorm === 'annual' || billingCycleNorm === 'year'
        ? '365'
        : billingCycleNorm === 'weekly' || billingCycleNorm === 'week'
          ? '7'
          : '30';

    // Replace client variables
    const clientVariables = {
      'Company Name': clientData.companyName,
      'Company_Name': clientData.companyName,
      'COMPANY_NAME': clientData.companyName,
      'State': clientData.state,
      'STATE': clientData.state,
      'Company Address': clientData.companyAddress,
      'Company_Address': clientData.companyAddress,
      'COMPANY_ADDRESS': clientData.companyAddress,
      'Address': clientData.companyAddress,
      'ADDRESS': clientData.companyAddress,
      'Street Address': clientData.companyAddress,
      'Street_Address': clientData.companyAddress,
      'City': clientData.city,
      'CITY': clientData.city,
      'Zip Code': clientData.zipCode,
      'Zip_Code': clientData.zipCode,
      'ZIP_CODE': clientData.zipCode,
      'Business Structure': clientData.businessStructure,
      'Business_Structure': clientData.businessStructure,
      'Signer Name': clientData.signerName,
      'Signer_Name': clientData.signerName,
      'SIGNER_NAME': clientData.signerName,
      'Signer Title': clientData.signerTitle,
      'Signer_Title': clientData.signerTitle,
      'SIGNER_TITLE': clientData.signerTitle,
      'Client Name': clientData.signerName,
      'Client_Name': clientData.signerName,
      'Name': clientData.signerName,
      'NAME': clientData.signerName,
      'Title': clientData.signerTitle,
      'TITLE': clientData.signerTitle
    };

    Object.entries(clientVariables).forEach(([variableName, value]) => {
      const patterns = [
        new RegExp(`\\[${variableName}\\]`, 'g'),
        new RegExp(`\\{${variableName}\\}`, 'g'),
        new RegExp(`\\{\\{${variableName}\\}\\}`, 'g')
      ];
      patterns.forEach(pattern => {
        updatedContent = updatedContent.replace(pattern, value || '');
      });
    });

    // Replace system variables
    const systemVariables = {
      'Contract_Number': contractNumber,
      'Contract Number': contractNumber,
      'Program_Name': programItemsText,
      'Program Name': programItemsText,
      'Program_Items': programItemsText,
      'Program Items': programItemsText,
      'Monthly_Price': formattedMonthlyPrice,
      'Monthly Price': formattedMonthlyPrice,
      'Billing_Cycle': billingCycleText,
      'Billing Cycle': billingCycleText,
      'Billing_Days': billingDays,
      'Billing Days': billingDays,
      'Start_Date': startDate,
      'Start Date': startDate
    };

    Object.entries(systemVariables).forEach(([variableName, value]) => {
      const patterns = [
        new RegExp(`\\[${variableName}\\]`, 'g'),
        new RegExp(`\\{${variableName}\\}`, 'g')
      ];
      patterns.forEach(pattern => {
        updatedContent = updatedContent.replace(pattern, value || '');
      });
    });

    // Get bank information from ACH data
    const achInfo = account?.achInfo || {};
    const bankName = achInfo.bankName || '';
    const bankAddress = achInfo.bankAddress || '';
    const accountNumber = achInfo.accountNumber || '';
    const routingNumber = achInfo.routingNumber || '';

    // Replace bank variables
    const bankVariables = {
      'Bank_Name': bankName,
      'Bank Name': bankName,
      'BANK_NAME': bankName,
      'Bank_Address': bankAddress,
      'Bank Address': bankAddress,
      'BANK_ADDRESS': bankAddress,
      'Account_Number': accountNumber,
      'Account Number': accountNumber,
      'ACCOUNT_NUMBER': accountNumber,
      'Routing_Number': routingNumber,
      'Routing Number': routingNumber,
      'ROUTING_NUMBER': routingNumber
    };

    Object.entries(bankVariables).forEach(([variableName, value]) => {
      const patterns = [
        new RegExp(`\\[${variableName}\\]`, 'g'),
        new RegExp(`\\{${variableName}\\}`, 'g')
      ];
      patterns.forEach(pattern => {
        updatedContent = updatedContent.replace(pattern, value || '');
      });
    });

    // Get BBA signature data
    const bbaSignature = contractData?.bbaSignature || {};
    const bbaName = bbaSignature.bbaName || 
                   Object.values(bbaSignature).find((val, idx, arr) => {
                     const key = Object.keys(bbaSignature)[idx];
                     return key && key.toLowerCase().includes('name') && typeof val === 'string' && val.trim().length > 0;
                   }) || 
                   'Builders Breakthrough Advisors';
    const bbaTitle = bbaSignature.bbaTitle || 
                    Object.values(bbaSignature).find((val, idx, arr) => {
                      const key = Object.keys(bbaSignature)[idx];
                      return key && key.toLowerCase().includes('title') && typeof val === 'string' && val.trim().length > 0;
                    }) || 
                    '';
    const bbaSignatureValue = bbaSignature.bbaSignature || 
                             Object.values(bbaSignature).find((val, idx, arr) => {
                               const key = Object.keys(bbaSignature)[idx];
                               return key && key.toLowerCase().includes('signature') && typeof val === 'string' && val.trim().length > 0;
                             }) || 
                             '';
    const bbaDate = bbaSignature.bbaDate || 
                   bbaSignature.bbaSignatureDate || 
                   contractData?.finalizedAt || 
                   contractData?.bbaSignedAt ||
                   (contractData?.isFullyExecuted ? new Date().toLocaleDateString() : '');

    // Replace BBA variables
    const bbaVariables = {
      'BBA_Name': bbaName,
      'BBA Name': bbaName,
      'BBA_NAME': bbaName,
      'BBA_Title': bbaTitle,
      'BBA Title': bbaTitle,
      'BBA_TITLE': bbaTitle,
      'BBA_Signature': bbaSignatureValue,
      'BBA Signature': bbaSignatureValue,
      'BBA_SIGNATURE': bbaSignatureValue,
      'BBA_Date': bbaDate,
      'BBA Date': bbaDate,
      'BBA_DATE': bbaDate
    };

    Object.entries(bbaVariables).forEach(([variableName, value]) => {
      const patterns = [
        new RegExp(`\\[${variableName}\\]`, 'g'),
        new RegExp(`\\{${variableName}\\}`, 'g')
      ];
      patterns.forEach(pattern => {
        updatedContent = updatedContent.replace(pattern, value || '');
      });
    });

    // Get client initials
    const clientInitials = contractData?.initial || 
                          contractData?.initials ||
                          clientData.initial ||
                          (clientData.signerName ? clientData.signerName.split(' ').map(n => n[0]).join('').toUpperCase() : '');

    // Replace initial variables (Your_Initials, Initials_Two, Initials_Three, etc.)
    const initialPattern = /\[(Your_Initials|Initials_Two|Initials_Three|Initials?)\]/gi;
    updatedContent = updatedContent.replace(initialPattern, () => {
      return clientInitials || '[Initial]';
    });

    // Replace special variables
    const specialPattern = /\[(SIGNATURE|INITIAL|INITIALS|TEXT_INPUT|CHECKBOX|DATE)\]/gi;
    updatedContent = updatedContent.replace(specialPattern, (match, type) => {
      switch(type.toUpperCase()) {
        case 'SIGNATURE':
          return clientData.signature || '[Signature]';
        case 'INITIAL':
        case 'INITIALS':
          return clientInitials || '[Initial]';
        case 'CHECKBOX':
          return '☑ '; // Add space after checkbox for better readability
        case 'DATE':
          return contractData?.signedAt ? new Date(contractData.signedAt).toLocaleDateString() : new Date().toLocaleDateString();
        default:
          return match;
      }
    });

    // Fix HTML entities and ensure proper text wrapping
    // Handle authorization text with checkbox replacement
    if (updatedContent.includes('I authorize Builders Breakthrough Advisors') && 
        (updatedContent.includes('debit') || updatedContent.includes('account'))) {
      
      // Handle "&  I authorize" (ampersand followed by spaces) - replace with checkbox
      // This pattern matches: & followed by one or more spaces, then "I authorize"
      updatedContent = updatedContent.replace(/&\s+I\s+authorize/i, '☑ I authorize');
      
      // Handle "& & I authorize" (multiple ampersands with spaces)
      updatedContent = updatedContent.replace(/&+\s*&+\s*I\s+authorize/i, '☑ I authorize');
      
      // Handle any sequence of & characters (one or more) with optional spaces before "I authorize"
      updatedContent = updatedContent.replace(/(^|\s)(&+\s*)+I\s+authorize/i, '$1☑ I authorize');
      
      // Also handle cases at the very start of the string
      updatedContent = updatedContent.replace(/^(&+\s*)+I\s+authorize/i, '☑ I authorize');
      
      // More aggressive: match & followed by any whitespace (including special characters) and "I authorize"
      updatedContent = updatedContent.replace(/&[^\w]*I\s+authorize/i, '☑ I authorize');
      
      // Ensure checkbox is present - if no checkbox found but "I authorize" exists, add it
      if (!updatedContent.includes('☑') && updatedContent.match(/I\s+authorize/i)) {
        updatedContent = updatedContent.replace(/(^|\s)(I\s+authorize)/i, '$1☑ $2');
      }
      
      // Fix any remaining standalone & characters in the middle of the text (replace with "and")
      updatedContent = updatedContent.replace(/\s+&+\s+/g, ' and ');
      // Also fix & at the start of words
      updatedContent = updatedContent.replace(/\s+&+([a-zA-Z])/g, ' and $1');
    }
    
    return updatedContent;
  };

  // Render contract elements with subitems (similar to LeadOverview)
  const renderContractElements = (elements, contract) => {
    if (!elements || !Array.isArray(elements)) return '';
    
    let renderedContent = elements.map(element => {
      if (element.type === 'header') {
        const headerContent = renderContractContentWithVariables(element.content || '', contract);
        return `<h2 style="font-size: 1.5rem; font-weight: bold; margin-bottom: 1rem; color: #1f2937;">${headerContent}</h2>`;
      } else if (element.type === 'text') {
        let content = renderContractContentWithVariables(element.content || '', contract);
        
        // Add subitems if they exist
        if (element.subItems && element.subItems.length > 0) {
          content += '<ul style="list-style-type: disc; margin-left: 1rem; margin-top: 0.5rem;">';
          element.subItems.forEach(subItem => {
            const subItemContent = renderContractContentWithVariables(subItem.text || subItem.content || 'Empty sub-item', contract);
            content += `<li style="margin-bottom: 0.25rem;">${subItemContent}`;
            
            // Add nested subitems if they exist
            if (subItem.subItems && subItem.subItems.length > 0) {
              content += '<ul style="list-style-type: disc; margin-left: 1rem; margin-top: 0.25rem;">';
              subItem.subItems.forEach(nestedSubItem => {
                const nestedContent = renderContractContentWithVariables(nestedSubItem.text || nestedSubItem.content || 'Empty nested sub-item', contract);
                content += `<li style="margin-bottom: 0.25rem;">${nestedContent}</li>`;
              });
              content += '</ul>';
            }
            
            content += '</li>';
          });
          content += '</ul>';
        }
        
        return `<div style="margin-bottom: 0.75rem;">${content}</div>`;
      } else if (['signature', 'initial', 'text_input', 'checkbox', 'date'].includes(element.type)) {
        // Handle form elements
        const value = element.value || '';
        if (element.type === 'signature' && value) {
          return `<div style="margin-bottom: 0.75rem;"><strong>${element.label || 'Signature'}:</strong> <span style="font-family: 'Dancing Script', 'Brush Script MT', cursive; font-size: 1.2em; font-weight: 600;">${value}</span></div>`;
        } else if (element.type === 'initial' && value) {
          return `<div style="margin-bottom: 0.75rem;"><strong>${element.label || 'Initial'}:</strong> <span style="font-family: 'Dancing Script', 'Brush Script MT', cursive; font-size: 1.2em; font-weight: 600;">${value}</span></div>`;
        } else if (element.type === 'checkbox') {
          // For checkbox elements, render checkbox symbol + label/content
          const checkboxSymbol = '☑ ';
          const label = element.label || element.content || '';
          const processedLabel = renderContractContentWithVariables(label, contract);
          return `<div style="margin-bottom: 0.75rem;">${checkboxSymbol}${processedLabel}</div>`;
        } else if (value) {
          return `<div style="margin-bottom: 0.75rem;"><strong>${element.label || element.type}:</strong> ${value}</div>`;
        }
        return '';
      }
      return '';
    }).join('');
    
    return renderedContent;
  };

  // Handle NDA PDF generation and viewing
  const handleViewNDAPDF = async () => {
    const ndaData = signedNDA || account?.signedNDA;
    const documentUrl = ndaData?.documentUrl || account?.ndaUrl;
    
    if (documentUrl) {
      window.open(documentUrl, '_blank');
    } else if (ndaData) {
      try {
        // Fetch NDA template to get proper order and page breaks
        let templateElements = ndaData.templateElements || ndaData.ndaElements;
        
        // If no template elements in NDA data, fetch from shared template
        if (!templateElements || templateElements.length === 0) {
          try {
            const template = await getSharedNdaTemplate();
            templateElements = template.ndaElements || [];
          } catch (error) {
            console.warn('Could not load NDA template, using NDA data as-is:', error);
          }
        }
        
        // Process template elements to replace variables
        let processedTemplateElements = null;
        if (templateElements && templateElements.length > 0) {
          // Templates maintain order by array position, preserve original order
          processedTemplateElements = [...templateElements].map(element => {
            const processedElement = { 
              ...element,
              // Explicitly preserve hasPageBreak property
              hasPageBreak: element.hasPageBreak
            };
            
            // Process main content
            if (element.content) {
              processedElement.content = renderNDAContentWithVariables(element.content, ndaData);
            }
            
            // Process subitems if they exist
            if (element.subItems && element.subItems.length > 0) {
              processedElement.subItems = element.subItems.map(subItem => {
                const processedSubItem = { ...subItem };
                
                // Process text property
                if (subItem.text) {
                  processedSubItem.text = renderNDAContentWithVariables(subItem.text, ndaData);
                } else if (subItem.content) {
                  processedSubItem.text = renderNDAContentWithVariables(subItem.content, ndaData);
                }
                
                // Also process content property for consistency
                if (subItem.content) {
                  processedSubItem.content = renderNDAContentWithVariables(subItem.content, ndaData);
                } else if (subItem.text) {
                  processedSubItem.content = renderNDAContentWithVariables(subItem.text, ndaData);
                }
                
                return processedSubItem;
              });
            }
            
            return processedElement;
          });
        }
        
        // Create enhanced document - explicitly remove finalizedDocumentContent to force use of template elements
        const enhancedNDADocument = {
          ...ndaData,
          templateElements: processedTemplateElements || templateElements,
          // Explicitly delete finalizedDocumentContent to ensure template elements are used
          finalizedDocumentContent: undefined,
          documentContent: undefined,
          leadData: {
            companyName: account?.company || ndaData.companyName || '',
            state: account?.state || ndaData.state || '',
            companyAddress: account?.streetAddress || account?.location || ndaData.companyAddress || '',
            city: account?.city || ndaData.city || '',
            zipCode: account?.zipCode || ndaData.zipCode || '',
            businessStructure: account?.businessStructure || ndaData.businessStructure || '',
            signerName: account?.contact?.name || ndaData.signerName || '',
            signerTitle: account?.contact?.title || ndaData.signerTitle || ''
          }
        };
        
        const { pdf } = await PDFService.generateNDAPDF(enhancedNDADocument);
        const pdfBlob = pdf.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
      } catch (error) {
        console.error('Error generating NDA PDF:', error);
        alert('Failed to generate PDF. Please try again.');
      }
    }
  };

  const handleDownloadNDAPDF = async () => {
    const ndaData = signedNDA || account?.signedNDA;
    const documentUrl = ndaData?.documentUrl || account?.ndaUrl;
    
    if (documentUrl) {
      const link = document.createElement('a');
      link.href = documentUrl;
      link.download = `NDA_${account?.company || ndaData?.companyName || 'document'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (ndaData) {
      try {
        // Fetch NDA template to get proper order and page breaks
        let templateElements = ndaData.templateElements || ndaData.ndaElements;
        
        // If no template elements in NDA data, fetch from shared template
        if (!templateElements || templateElements.length === 0) {
          try {
            const template = await getSharedNdaTemplate();
            templateElements = template.ndaElements || [];
          } catch (error) {
            console.warn('Could not load NDA template, using NDA data as-is:', error);
          }
        }
        
        // Process template elements to replace variables
        let processedTemplateElements = null;
        if (templateElements && templateElements.length > 0) {
          // Templates maintain order by array position, preserve original order
          processedTemplateElements = [...templateElements].map(element => {
            const processedElement = { 
              ...element,
              // Explicitly preserve hasPageBreak property
              hasPageBreak: element.hasPageBreak
            };
            
            // Process main content
            if (element.content) {
              processedElement.content = renderNDAContentWithVariables(element.content, ndaData);
            }
            
            // Process subitems if they exist
            if (element.subItems && element.subItems.length > 0) {
              processedElement.subItems = element.subItems.map(subItem => {
                const processedSubItem = { ...subItem };
                
                // Process text property
                if (subItem.text) {
                  processedSubItem.text = renderNDAContentWithVariables(subItem.text, ndaData);
                } else if (subItem.content) {
                  processedSubItem.text = renderNDAContentWithVariables(subItem.content, ndaData);
                }
                
                // Also process content property for consistency
                if (subItem.content) {
                  processedSubItem.content = renderNDAContentWithVariables(subItem.content, ndaData);
                } else if (subItem.text) {
                  processedSubItem.content = renderNDAContentWithVariables(subItem.text, ndaData);
                }
                
                return processedSubItem;
              });
            }
            
            return processedElement;
          });
        }
        
        // Create enhanced document - explicitly remove finalizedDocumentContent to force use of template elements
        const enhancedNDADocument = {
          ...ndaData,
          templateElements: processedTemplateElements || templateElements,
          // Explicitly delete finalizedDocumentContent to ensure template elements are used
          finalizedDocumentContent: undefined,
          documentContent: undefined,
          leadData: {
            companyName: account?.company || ndaData.companyName || '',
            state: account?.state || ndaData.state || '',
            companyAddress: account?.streetAddress || account?.location || ndaData.companyAddress || '',
            city: account?.city || ndaData.city || '',
            zipCode: account?.zipCode || ndaData.zipCode || '',
            businessStructure: account?.businessStructure || ndaData.businessStructure || '',
            signerName: account?.contact?.name || ndaData.signerName || '',
            signerTitle: account?.contact?.title || ndaData.signerTitle || ''
          }
        };
        
        await PDFService.downloadNDAPDF(enhancedNDADocument);
      } catch (error) {
        console.error('Error generating NDA PDF:', error);
        alert('Failed to generate PDF. Please try again.');
      }
    }
  };

  // Handle Contract PDF generation and viewing
  const handleViewContractPDF = async () => {
    const contract = contractData || account?.signedContract || account?.contractData;
    const documentUrl = contract?.documentUrl || account?.contractUrl;
    
    if (documentUrl) {
      window.open(documentUrl, '_blank');
    } else if (contract) {
      try {
        // Process the contract content with variables injected
        let processedContent = '';
        if (contract.finalizedDocumentContent) {
          processedContent = renderContractContentWithVariables(contract.finalizedDocumentContent, contract);
        } else if (contract.documentContent) {
          processedContent = renderContractContentWithVariables(contract.documentContent, contract);
        } else if (contract.templateElements && contract.templateElements.length > 0) {
          // For template elements, render them with variables
          processedContent = renderContractElements(contract.templateElements, contract);
        }
        
        // Process template elements with variables if they exist
        let processedTemplateElements = null;
        if (contract.templateElements && contract.templateElements.length > 0) {
          // Templates maintain order by array position, preserve original order
          processedTemplateElements = [...contract.templateElements].map(element => {
            const processedElement = { 
              ...element,
              // Explicitly preserve hasPageBreak property
              hasPageBreak: element.hasPageBreak
            };
            
            // Process main content
            if (element.content) {
              processedElement.content = renderContractContentWithVariables(element.content, contract);
            }
            
            // Process subitems - CRITICAL: preserve all subitems structure
            if (element.subItems && element.subItems.length > 0) {
              processedElement.subItems = element.subItems.map(subItem => {
                const processedSubItem = { ...subItem };
                
                // Process text property (PDF service uses this)
                if (subItem.text) {
                  processedSubItem.text = renderContractContentWithVariables(subItem.text, contract);
                } else if (subItem.content) {
                  // If no text but has content, use content as text
                  processedSubItem.text = renderContractContentWithVariables(subItem.content, contract);
                }
                
                // Also process content property for consistency
                if (subItem.content) {
                  processedSubItem.content = renderContractContentWithVariables(subItem.content, contract);
                } else if (subItem.text) {
                  // If no content but has text, use text as content
                  processedSubItem.content = renderContractContentWithVariables(subItem.text, contract);
                }
                
                // Process nested subitems
                if (subItem.subItems && subItem.subItems.length > 0) {
                  processedSubItem.subItems = subItem.subItems.map(nestedSubItem => {
                    const processedNested = { ...nestedSubItem };
                    if (nestedSubItem.text) {
                      processedNested.text = renderContractContentWithVariables(nestedSubItem.text, contract);
                    } else if (nestedSubItem.content) {
                      processedNested.text = renderContractContentWithVariables(nestedSubItem.content, contract);
                    }
                    if (nestedSubItem.content) {
                      processedNested.content = renderContractContentWithVariables(nestedSubItem.content, contract);
                    } else if (nestedSubItem.text) {
                      processedNested.content = renderContractContentWithVariables(nestedSubItem.text, contract);
                    }
                    return processedNested;
                  });
                }
                
                return processedSubItem;
              });
            }
            
            return processedElement;
          });
          
          // Debug: Log page break information
          const elementsWithPageBreaks = processedTemplateElements.filter(el => el.hasPageBreak);
          console.log('Processed template elements with page breaks:', elementsWithPageBreaks.length);
          console.log('Page break elements:', elementsWithPageBreaks.map(el => ({
            id: el.id,
            type: el.type,
            content: el.content?.substring(0, 50),
            hasPageBreak: el.hasPageBreak
          })));
        } else {
          // If no template elements, try to fetch from shared template
          try {
            const template = await getSharedContractTemplate();
            if (template.contractElements && template.contractElements.length > 0) {
              // Sort by order
              const sortedElements = [...template.contractElements].sort((a, b) => {
                const orderA = a.order !== undefined ? a.order : (a.elementIndex !== undefined ? a.elementIndex : 0);
                const orderB = b.order !== undefined ? b.order : (b.elementIndex !== undefined ? b.elementIndex : 0);
                return orderA - orderB;
              });
              
              processedTemplateElements = sortedElements.map(element => {
                const processedElement = { 
                  ...element,
                  hasPageBreak: element.hasPageBreak
                };
                
                if (element.content) {
                  processedElement.content = renderContractContentWithVariables(element.content, contract);
                }
                
                return processedElement;
              });
            }
          } catch (error) {
            console.warn('Could not load contract template, using contract data as-is:', error);
          }
        }
        
        // Create enhanced document - explicitly remove finalizedDocumentContent when using template elements
        const enhancedContractDocument = {
          ...contract,
          // Explicitly delete finalizedDocumentContent to ensure template elements are used
          finalizedDocumentContent: processedTemplateElements ? undefined : (processedContent || contract.finalizedDocumentContent || contract.documentContent),
          documentContent: processedTemplateElements ? undefined : (processedContent || contract.documentContent),
          templateElements: processedTemplateElements || contract.templateElements,
          leadData: {
            companyName: account?.company || contract.companyName || '',
            state: account?.state || contract.state || '',
            companyAddress: account?.streetAddress || account?.location || contract.companyAddress || '',
            city: account?.city || contract.city || '',
            zipCode: account?.zipCode || contract.zipCode || '',
            businessStructure: account?.businessStructure || contract.businessStructure || '',
            signerName: contract?.signature?.trim() || contract.signerName || account?.contact?.name || '',
            signerTitle: contract?.signerTitle || account?.contact?.title || ''
          }
        };
        
        const { pdf } = await PDFService.generateNDAPDF(enhancedContractDocument);
        const pdfBlob = pdf.output('blob');
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
      } catch (error) {
        console.error('Error generating Contract PDF:', error);
        alert('Failed to generate PDF. Please try again.');
      }
    }
  };

  const handleDownloadContractPDF = async () => {
    const contract = contractData || account?.signedContract || account?.contractData;
    const documentUrl = contract?.documentUrl || account?.contractUrl;
    
    if (documentUrl) {
      const link = document.createElement('a');
      link.href = documentUrl;
      link.download = `Contract_${account?.company || contract?.companyName || 'document'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (contract) {
      try {
        // Process the contract content with variables injected
        let processedContent = '';
        if (contract.finalizedDocumentContent) {
          processedContent = renderContractContentWithVariables(contract.finalizedDocumentContent, contract);
        } else if (contract.documentContent) {
          processedContent = renderContractContentWithVariables(contract.documentContent, contract);
        } else if (contract.templateElements && contract.templateElements.length > 0) {
          // For template elements, render them with variables
          processedContent = renderContractElements(contract.templateElements, contract);
        }
        
        // Process template elements with variables if they exist
        let processedTemplateElements = null;
        if (contract.templateElements && contract.templateElements.length > 0) {
          // Templates maintain order by array position, preserve original order
          processedTemplateElements = [...contract.templateElements].map(element => {
            const processedElement = { 
              ...element,
              // Explicitly preserve hasPageBreak property
              hasPageBreak: element.hasPageBreak
            };
            
            // Process main content
            if (element.content) {
              processedElement.content = renderContractContentWithVariables(element.content, contract);
            }
            
            // Process subitems - CRITICAL: preserve all subitems structure
            if (element.subItems && element.subItems.length > 0) {
              processedElement.subItems = element.subItems.map(subItem => {
                const processedSubItem = { ...subItem };
                
                // Process text property (PDF service uses this)
                if (subItem.text) {
                  processedSubItem.text = renderContractContentWithVariables(subItem.text, contract);
                } else if (subItem.content) {
                  // If no text but has content, use content as text
                  processedSubItem.text = renderContractContentWithVariables(subItem.content, contract);
                }
                
                // Also process content property for consistency
                if (subItem.content) {
                  processedSubItem.content = renderContractContentWithVariables(subItem.content, contract);
                } else if (subItem.text) {
                  // If no content but has text, use text as content
                  processedSubItem.content = renderContractContentWithVariables(subItem.text, contract);
                }
                
                // Process nested subitems
                if (subItem.subItems && subItem.subItems.length > 0) {
                  processedSubItem.subItems = subItem.subItems.map(nestedSubItem => {
                    const processedNested = { ...nestedSubItem };
                    if (nestedSubItem.text) {
                      processedNested.text = renderContractContentWithVariables(nestedSubItem.text, contract);
                    } else if (nestedSubItem.content) {
                      processedNested.text = renderContractContentWithVariables(nestedSubItem.content, contract);
                    }
                    if (nestedSubItem.content) {
                      processedNested.content = renderContractContentWithVariables(nestedSubItem.content, contract);
                    } else if (nestedSubItem.text) {
                      processedNested.content = renderContractContentWithVariables(nestedSubItem.text, contract);
                    }
                    return processedNested;
                  });
                }
                
                return processedSubItem;
              });
            }
            
            // Debug: log element structure
            console.log('Processed element:', {
              id: processedElement.id,
              type: processedElement.type,
              hasContent: !!processedElement.content,
              hasSubItems: !!(processedElement.subItems && processedElement.subItems.length > 0),
              subItemsCount: processedElement.subItems?.length || 0,
              hasPageBreak: processedElement.hasPageBreak
            });
            
            return processedElement;
          });
          
          // Don't set finalizedDocumentContent when we have template elements
          // Let the PDF service use template elements directly for proper rendering
          // Only set finalizedDocumentContent if we don't have template elements
          if (!processedTemplateElements && !processedContent) {
            processedContent = renderContractElements(contract.templateElements, contract);
          }
        } else {
          // If no template elements, try to fetch from shared template
          try {
            const template = await getSharedContractTemplate();
            if (template.contractElements && template.contractElements.length > 0) {
              // Templates maintain order by array position, preserve original order
              processedTemplateElements = [...template.contractElements].map(element => {
                const processedElement = { 
                  ...element,
                  hasPageBreak: element.hasPageBreak
                };
                
                if (element.content) {
                  processedElement.content = renderContractContentWithVariables(element.content, contract);
                }
                
                return processedElement;
              });
            }
          } catch (error) {
            console.warn('Could not load contract template, using contract data as-is:', error);
          }
        }
        
        // Create enhanced document - explicitly remove finalizedDocumentContent when using template elements
        const enhancedContractDocument = {
          ...contract,
          // Explicitly delete finalizedDocumentContent to ensure template elements are used
          finalizedDocumentContent: processedTemplateElements ? undefined : (processedContent || contract.finalizedDocumentContent || contract.documentContent),
          documentContent: processedTemplateElements ? undefined : (processedContent || contract.documentContent),
          templateElements: processedTemplateElements || contract.templateElements,
          leadData: {
            companyName: account?.company || contract.companyName || '',
            state: account?.state || contract.state || '',
            companyAddress: account?.streetAddress || account?.location || contract.companyAddress || '',
            city: account?.city || contract.city || '',
            zipCode: account?.zipCode || contract.zipCode || '',
            businessStructure: account?.businessStructure || contract.businessStructure || '',
            signerName: contract?.signature?.trim() || contract.signerName || account?.contact?.name || '',
            signerTitle: contract?.signerTitle || account?.contact?.title || ''
          }
        };
        
        await PDFService.downloadNDAPDF(enhancedContractDocument);
      } catch (error) {
        console.error('Error generating Contract PDF:', error);
        alert('Failed to generate PDF. Please try again.');
      }
    }
  };

  const renderEditableField = (label, value, field, icon) => {
    const isEditing = editingField === field;
    return (
      <div className="flex items-center justify-between p-3 bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm">
        <div className="flex items-center space-x-3">
          {icon}
          <div className="w-full">
            <div className="text-sm text-gray-500 dark:text-gray-400">{label}</div>
            {isEditMode ? (
              <input
                type="text"
                value={isEditing ? editValue : value || ''}
                onChange={(e) => {
                  if (isEditing) {
                    setEditValue(e.target.value);
                  } else {
                    handleEdit(field, e.target.value);
                  }
                }}
                className="mt-1 p-1 border border-gray-300 dark:border-gray-600 rounded w-full bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                placeholder={value || 'Not set'}
                autoFocus={isEditing}
              />
            ) : (
              <div className="font-medium text-gray-900 dark:text-white">{value || 'Not set'}</div>
            )}
          </div>
        </div>
        {isEditing && (
          <button
            onClick={() => setEditingField(null)}
            className="text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    );
  };

  const renderMilestone = (title, date, description, isCompleted) => (
    <div className={`p-4 rounded-lg ${isCompleted ? 'bg-green-50' : 'bg-gray-50'}`}>
      <div className="flex items-center justify-between mb-2">
        <h4 className="font-medium">{title}</h4>
        <span className={`text-sm ${isCompleted ? 'text-green-600' : 'text-gray-500'}`}>
          {date}
        </span>
      </div>
      <p className="text-sm text-gray-600">{description}</p>
    </div>
  );

  const cycleSidebarLeadContact = () => {
    const n = orderedSidebarContacts.length;
    if (n < 2) return;
    setSidebarLeadContactIndex((i) => (i + 1) % n);
  };

  const togglePinnedSidebarContact = () => {
    const n = orderedSidebarContacts.length;
    if (n < 2 || !account?.id) return;
    const lead = orderedSidebarContacts[sidebarLeadContactIndex] || orderedSidebarContacts[0];
    if (!lead) return;
    const isPinned = pinnedSidebarContactKey === lead.key;
    const next = isPinned ? null : lead.key;
    setPinnedSidebarContactKey(next);
    try {
      const storageKey = CLIENT_OVERVIEW_PINNED_CONTACT_STORAGE_PREFIX + account.id;
      if (next == null) localStorage.removeItem(storageKey);
      else localStorage.setItem(storageKey, next);
    } catch (_) {
      /* ignore */
    }
    setSidebarLeadContactIndex(0);
  };

  const leadSidebarContact =
    orderedSidebarContacts[sidebarLeadContactIndex] || orderedSidebarContacts[0] || null;
  const isAccountPrimaryLead = leadSidebarContact?.key === 'account-primary';
  const canEditSidebarContactPhoto =
    isEditMode && (isAccountPrimaryLead || leadSidebarContact?.source === 'portal');
  const sidebarPhotoDropZoneKey = isAccountPrimaryLead
    ? 'sidebar-primary'
    : leadSidebarContact?.source === 'portal'
      ? `sidebar-portal:${leadSidebarContact.key}`
      : null;

  const handleSidebarPhotoDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!sidebarPhotoDropZoneKey || !canEditSidebarContactPhoto) return;
    if (uploadingImage || uploadingTeamMemberPhotoId) return;
    setPhotoDropHighlightKey(sidebarPhotoDropZoneKey);
  };

  const handleSidebarPhotoDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const rel = e.relatedTarget;
    if (rel && e.currentTarget.contains(rel)) return;
    setPhotoDropHighlightKey((cur) => (cur === sidebarPhotoDropZoneKey ? null : cur));
  };

  const handleSidebarPhotoDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setPhotoDropHighlightKey(null);
    if (!canEditSidebarContactPhoto) return;
    const f = e.dataTransfer.files?.[0];
    if (!f) return;
    if (!f.type.startsWith('image/')) {
      alert('Please drop an image file.');
      return;
    }
    if (isAccountPrimaryLead) {
      await handleImageUpload(f);
    } else if (leadSidebarContact?.source === 'portal') {
      await handleTeamMemberPhotoUpload(leadSidebarContact.key, f);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen p-4 relative">
        <PortalBackground />
        <div className="relative flex items-center justify-center py-32">
          <BBALoader size={48} />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-xl text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 relative">
      {/* Same ambient BBA background as the Dashboard, Leads board and Lead Overview */}
      <PortalBackground />
      <div className="relative">
      {/* Back button, Company Name, and Account Management */}
      <div className="flex justify-between items-center mb-6">
        <BackButton onClick={() => navigate(-1)} />
        
        {/* Centered Company Name */}
        <div className="flex-1 flex justify-center">
          {isEditMode ? (
            <input
              type="text"
              value={editingField === 'company' ? editValue : account.company}
              onChange={(e) => {
                if (editingField === 'company') {
                  setEditValue(e.target.value);
                } else {
                  handleEdit('company', e.target.value);
                }
              }}
              className="text-4xl font-bold text-gray-900 dark:text-white text-center bg-transparent border-b border-gray-300 dark:border-gray-600 focus:border-red-600 focus:outline-none"
              placeholder="Company Name"
            />
          ) : (
            <h1 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white">{account.company}</h1>
          )}
        </div>
        
        <div className="flex items-center space-x-4">
          {!isEditMode ? (
            <button
              onClick={() => navigate(`/crm/portalview/${clientId}/General/courses`)}
              className="inline-flex items-center gap-2 px-3.5 py-2.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm font-medium text-gray-700 dark:text-gray-200 shadow-sm hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <Eye className="w-4 h-4" />
              <span>Portal View</span>
            </button>
          ) : (
            <div className="flex items-center space-x-2">
              <button
                onClick={() => setShowDeleteConfirm(true)}
                className="inline-flex items-center gap-2 px-3.5 py-2.5 rounded-xl border border-red-200 dark:border-red-800/60 bg-white dark:bg-gray-800 text-sm font-medium text-red-600 dark:text-red-400 shadow-sm hover:bg-red-50 dark:hover:bg-red-900/30 transition-colors"
              >
                <Trash2 className="w-4 h-4" />
                <span>Delete Client</span>
              </button>
              <button
                onClick={() => {
                  setIsEditMode(false);
                  setEditingField(null);
                }}
                className="inline-flex items-center gap-2 px-3.5 py-2.5 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-sm font-medium text-gray-700 dark:text-gray-200 shadow-sm hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  // Check if email was changed
                  const currentEmail = account?.contact?.email || '';
                  if (originalEmail && currentEmail.toLowerCase().trim() !== originalEmail.toLowerCase().trim()) {
                    // Email was changed, use the email update function
                    await handleSave('contact.email');
                  } else if (editingField) {
                    // Other field was edited
                    await handleSave(editingField);
                  } else {
                    // Sidebar contact fields, team CRM phones, etc. (no editingField / email workflow)
                    await updateAccount(clientId, account);
                  }
                  setIsEditMode(false);
                }}
                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl bg-red-600 text-white text-sm font-semibold shadow-sm hover:bg-red-700 transition-colors"
              >
                Save
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-md w-full">
            <h3 className="text-lg font-semibold mb-4 text-center text-gray-900 dark:text-white">Delete Client</h3>
            <p className="text-gray-600 dark:text-gray-300 mb-6">
                              Are you sure you want to delete this client? This action cannot be undone.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowDeleteConfirm(false)}
                className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteClient}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Delete Client
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Stage Badge */}
      <div className="text-center mb-6">
        <div className="relative">
          <span className={`px-4 py-1 rounded-full text-sm font-medium ${
            account.substatus === 'Portal Signup Completed' 
              ? 'bg-emerald-100 dark:bg-emerald-900 text-emerald-700 dark:text-emerald-300'
              : 'bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300'
          }`}>
            {programPriceData?.name || account?.program?.name || account?.program?.status || 'No Program'}
          </span>
        </div>
      </div>

      {/* Main content area with tabs */}
      <div className="flex gap-6">
        {/* Main content */}
        <div className="flex-1">
          {/* Tabs */}
          <div className="flex items-center gap-2 overflow-x-auto pb-1 mb-5 [&::-webkit-scrollbar]:hidden [scrollbar-width:none]">
            {tabs.map((tab) => {
              const selected = activeTab === tab.toLowerCase();
              return (
                <button
                  key={tab}
                  type="button"
                  onClick={() => setActiveTab(tab.toLowerCase())}
                  className={`shrink-0 px-4 py-2 rounded-full border text-sm font-medium whitespace-nowrap transition-colors ${
                    selected
                      ? 'border-red-600 bg-red-600 text-white shadow-sm'
                      : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800'
                  }`}
                >
                  {tab}
                </button>
              );
            })}
          </div>

          {/* Tab content */}
          {activeTab === 'summary' ? (
            <div className="space-y-6">
              {/* Client debrief: AI rundown + recent calls, pulse, action items, coming up */}
              <ClientDebrief account={account} clientId={clientId} checkIns={checkIns} />

              <div className="space-y-4">
                {/* Next 6 roadmap cards (in-progress first, then following in order) */}
                <div className="mt-2">
                  <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3 text-center">
                    Roadmap — Next Up
                  </h3>
                  {roadmapLoading ? (
                    <p className="text-center text-sm text-gray-500 dark:text-gray-400">Loading roadmap...</p>
                  ) : summaryNextRoadmapCards.length === 0 ? (
                    <p className="text-center text-sm text-gray-500 dark:text-gray-400">No roadmap cards to show.</p>
                  ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                      {summaryNextRoadmapCards.map((template) => {
                        const templateId = template.clientRoadmapId ?? template.id;
                        const displayStatus = (() => {
                          const s = (template.status || '').toLowerCase();
                          if (s === 'in_progress' || s === 'active') return 'in-progress';
                          return template.status || 'not-started';
                        })();
                        return (
                          <button
                            key={String(templateId)}
                            type="button"
                            onClick={() => templateId != null && navigate(`/crm/fulfillment/clientroadmaps/${clientId}/template/${templateId}`)}
                            className={`rounded-lg border-2 p-3 text-left shadow-sm transition-all hover:shadow-md ${getSummaryRoadmapStatusStyles(displayStatus)}`}
                          >
                            <div className="flex flex-col h-full min-h-[100px]">
                              <div className="text-center mb-2">
                                <span className="text-2xl">{getSummaryRoadmapDepartmentEmoji(template)}</span>
                              </div>
                              <h4 className="font-semibold text-sm text-gray-900 dark:text-white mb-2 line-clamp-2 text-center">
                                {template.title || 'Untitled'}
                              </h4>
                              <div className="mt-auto flex justify-center">
                                <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getSummaryRoadmapDepartmentPill(template.department)}`}>
                                  {getSummaryRoadmapDepartmentLabel(template.department)}
                                </span>
                              </div>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
                </div>

              </div>
          ) : activeTab === 'progress' ? (
            <div className="space-y-6">
              {/* Compact revenue strip (click a value to edit) */}
              <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm px-4 py-3 grid grid-cols-3 divide-x divide-gray-200 dark:divide-gray-700">
                <div
                  className="text-center cursor-pointer px-2"
                  onClick={() => handleEdit('metrics.startingRevenue', account.metrics?.startingRevenue || 0)}
                >
                  <h3 className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-0.5">Starting Revenue</h3>
                  {isEditMode && editingField === 'metrics.startingRevenue' ? (
                    <input
                      type="number"
                      value={editValue}
                      onChange={(e) => setEditValue(parseFloat(e.target.value) || 0)}
                      className="text-lg font-semibold text-gray-900 dark:text-white text-center bg-transparent border-b border-gray-300 dark:border-gray-600 focus:border-red-600 focus:outline-none w-full"
                      placeholder="0"
                      autoFocus
                    />
                  ) : (
                    <div className="text-lg font-semibold text-gray-900 dark:text-white">
                      ${account.metrics?.startingRevenue?.toLocaleString() || '0'}
                    </div>
                  )}
                </div>
                <div
                  className="text-center cursor-pointer px-2"
                  onClick={() => handleEdit('metrics.currentRevenue', account.metrics?.currentRevenue || 0)}
                >
                  <h3 className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-0.5">
                    Current Revenue
                    {clientIntegrations.quickbooks && qbCurrentRevenue != null && !isEditMode && (
                      <span className="ml-1 text-amber-600 dark:text-amber-400">· YTD QB</span>
                    )}
                  </h3>
                  {isEditMode && editingField === 'metrics.currentRevenue' ? (
                    <input
                      type="number"
                      value={editValue}
                      onChange={(e) => setEditValue(parseFloat(e.target.value) || 0)}
                      className="text-lg font-semibold text-gray-900 dark:text-white text-center bg-transparent border-b border-gray-300 dark:border-gray-600 focus:border-red-600 focus:outline-none w-full"
                      placeholder="0"
                      autoFocus
                    />
                  ) : qbRevenueLoading && clientIntegrations.quickbooks ? (
                    <div className="text-lg font-semibold text-gray-400 dark:text-gray-500 animate-pulse">—</div>
                  ) : (
                    <div className="text-lg font-semibold text-gray-900 dark:text-white">
                      ${displayedCurrentRevenue.toLocaleString()}
                    </div>
                  )}
                </div>
                <div
                  className="text-center cursor-pointer px-2"
                  onClick={() => handleEdit('metrics.revenueGoal', account.metrics?.revenueGoal || 0)}
                >
                  <h3 className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-0.5">Revenue Goal</h3>
                  {isEditMode && editingField === 'metrics.revenueGoal' ? (
                    <input
                      type="number"
                      value={editValue}
                      onChange={(e) => setEditValue(parseFloat(e.target.value) || 0)}
                      className="text-lg font-semibold text-gray-900 dark:text-white text-center bg-transparent border-b border-gray-300 dark:border-gray-600 focus:border-red-600 focus:outline-none w-full"
                      placeholder="0"
                      autoFocus
                    />
                  ) : (
                    <div className="text-lg font-semibold text-gray-900 dark:text-white">
                      ${account.metrics?.revenueGoal?.toLocaleString() || '0'}
                    </div>
                  )}
                </div>
              </div>

              <ClientProgressTab clientId={clientId} checkIns={checkIns} />
            </div>
          ) : activeTab === 'program' ? (
                <div className="space-y-6">
              <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
                {/* Above Deliverables: Program, Client Status, Billing Status, Start Date, Minimum Term, Renews On, Cancel State */}
                <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-7 gap-4 mb-6">
                  <div 
                    className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 cursor-pointer hover:shadow-md transition-shadow text-center"
                    onClick={() => handleEdit('program.status', getProgramTier(account))}
                  >
                    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Program</div>
                    {isEditMode && editingField === 'program.status' ? (
                      <select
                        value={PROGRAM_TIERS.includes(editValue) ? editValue : 'Not Started'}
                        onChange={(e) => {
                          // Tier only. Lost / Canceled / Archived live on the Client Status card so
                          // changing lifecycle never erases which program they were on.
                          setEditValue(e.target.value);
                          const updatedData = { ...account };
                          updatedData.program = { ...(typeof account.program === 'object' && account.program ? account.program : {}), status: e.target.value };
                          updatedData.stage = e.target.value;
                          updateAccount(clientId, updatedData);
                          setAccount(updatedData);
                        }}
                        className="text-sm font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded w-full text-center"
                        autoFocus
                      >
                        {PROGRAM_TIERS.map((tier) => (
                          <option key={tier} value={tier}>{tier}</option>
                        ))}
                      </select>
                    ) : (
                      <div className="text-sm font-semibold text-gray-900 dark:text-white">
                        {getProgramTier(account)}
                      </div>
                    )}
                  </div>
                  <div
                    className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 cursor-pointer hover:shadow-md transition-shadow text-center"
                    onClick={() => handleEdit('program.clientStatus', clientLifecycle.storedState)}
                  >
                    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Client Status</div>
                    {isEditMode && editingField === 'program.clientStatus' ? (
                      <select
                        value={STORABLE_CLIENT_LIFECYCLES.includes(editValue) ? editValue : clientLifecycle.storedState}
                        onChange={(e) => {
                          setEditValue(e.target.value);
                          handleLifecycleChange(e.target.value);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        className="text-sm font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded w-full text-center"
                        autoFocus
                      >
                        {STORABLE_CLIENT_LIFECYCLES.map((state) => (
                          <option key={state} value={state}>{state}</option>
                        ))}
                      </select>
                    ) : (
                      (() => {
                        const chip = describeClientLifecycle(clientLifecycle.state);
                        const when = clientLifecycle.state === 'Canceling' ? clientLifecycle.cancelEffectiveDate : clientLifecycle.endedAt;
                        return (
                          <div className="flex flex-col items-center gap-1">
                            <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${chip.className}`}>{chip.label}</span>
                            {when ? (
                              <span className="text-[10px] text-gray-400 dark:text-gray-500">
                                {clientLifecycle.state === 'Canceling' ? 'ends ' : 'since '}{when.toLocaleDateString()}
                              </span>
                            ) : null}
                          </div>
                        );
                      })()
                    )}
                  </div>
                  <div
                    className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 cursor-pointer hover:shadow-md transition-shadow text-center"
                    onClick={() => handleEdit('program.subscriptionStatus', account.billing?.status || account.program?.subscriptionStatus || 'active')}
                  >
                    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Billing Status</div>
                    {isEditMode && editingField === 'program.subscriptionStatus' ? (
                      <select
                        value={editValue}
                        onChange={async (e) => {
                          setEditValue(e.target.value);
                          const updatedData = { ...account };
                          updatedData.program = programMapWith(updatedData.program, { subscriptionStatus: e.target.value });
                          await updateAccount(clientId, updatedData);
                          setAccount(updatedData);
                        }}
                        className="text-sm font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded w-full text-center"
                        autoFocus
                      >
                        <option value="active">Active</option>
                        <option value="trialing">Trialing</option>
                        <option value="past_due">Past Due</option>
                        <option value="canceled">Canceled</option>
                        <option value="unpaid">Unpaid</option>
                        <option value="incomplete">Incomplete</option>
                      </select>
                    ) : (
                      <div className="text-sm font-semibold text-gray-900 dark:text-white">
                        {String(lifecycle.status || 'active')
                          .replace(/_/g, ' ')
                          .replace(/\b\w/g, (ch) => ch.toUpperCase())}
                      </div>
                    )}
                  </div>
                  <div
                    className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 cursor-pointer hover:shadow-md transition-shadow text-center"
                    onClick={() => {
                      // Clicks inside the open date input bubble here; don't reset the draft value.
                      if (editingField === 'program.startDate') return;
                      handleEdit('program.startDate', toDateInputValue(clientActualStartDate));
                    }}
                  >
                    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Start Date</div>
                    {isEditMode && editingField === 'program.startDate' ? (
                      <input
                        type="date"
                        value={toDateInputValue(editValue)}
                        onChange={(e) => setEditValue(e.target.value || '')}
                        onClick={(e) => e.stopPropagation()}
                        onBlur={() => handleSave('program.startDate')}
                        onKeyDown={(e) => e.key === 'Enter' && handleSave('program.startDate')}
                        className="text-sm font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded w-full text-center"
                        autoFocus
                      />
                    ) : (
                      <div className="text-sm font-semibold text-gray-900 dark:text-white">
                        {clientActualStartDate ? clientActualStartDate.toLocaleDateString() : 'Not Set'}
                      </div>
                    )}
                  </div>
                  <div
                    className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 cursor-pointer hover:shadow-md transition-shadow text-center"
                    onClick={() => handleEdit('program.minimumTerm', account.program?.minimumTerm || '')}
                  >
                    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Minimum Term</div>
                    {isEditMode && editingField === 'program.minimumTerm' ? (
                      <select
                        value={editValue}
                        onChange={async (e) => {
                          const nextTerm = e.target.value;
                          const prevTerm = account.program?.minimumTerm ?? '';
                          setEditValue(nextTerm);
                          // Show the pick right away, then confirm the write. Both use the
                          // functional form so a refresh landing mid-save can't be overwritten
                          // with a stale snapshot of the account.
                          setAccount((prev) =>
                            prev ? { ...prev, program: programMapWith(prev.program, { minimumTerm: nextTerm }) } : prev
                          );
                          try {
                            // Field-scoped write: sending the whole account here let any other
                            // save on the page (built from an older snapshot) silently revert it.
                            // Legacy accounts store `program` as a plain status string — those
                            // need the whole map written so the status survives.
                            await updateAccount(
                              clientId,
                              account.program && typeof account.program !== 'object'
                                ? { program: programMapWith(account.program, { minimumTerm: nextTerm }) }
                                : { 'program.minimumTerm': nextTerm }
                            );
                            // Close the editor so the green Save button doesn't re-save this
                            // field from a stale copy of the account.
                            setEditingField(null);
                          } catch (error) {
                            console.error('Error updating minimum term:', error);
                            setEditValue(prevTerm);
                            setAccount((prev) =>
                              prev ? { ...prev, program: programMapWith(prev.program, { minimumTerm: prevTerm }) } : prev
                            );
                            alert(`Failed to update minimum term: ${error.message || 'Unknown error'}`);
                          }
                        }}
                        className="text-sm font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded w-full text-center"
                        autoFocus
                      >
                        <option value="">Not Set</option>
                        {MINIMUM_TERM_OPTIONS.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    ) : (
                      <div className="text-sm font-semibold text-gray-900 dark:text-white">
                        {lifecycle.termEndDate ? lifecycle.termEndDate.toLocaleDateString() : 'Not Set'}
                      </div>
                    )}
                    {(() => {
                      const selected = getMinimumTermOption(account?.program?.minimumTerm);
                      if (selected) {
                        return (
                          <div className="text-[10px] text-gray-400 dark:text-gray-500 mt-0.5">
                            {selected.label.toLowerCase()} · {selected.days} days from start
                          </div>
                        );
                      }
                      const contractLen =
                        contractData?.contractLength ||
                        account?.signedContract?.contractLength ||
                        account?.contractData?.contractLength;
                      const months = parseInt(contractLen, 10);
                      return months ? (
                        <div className="text-[10px] text-gray-400 dark:text-gray-500 mt-0.5">
                          {months} month{months === 1 ? '' : 's'} from start
                        </div>
                      ) : null;
                    })()}
                  </div>
                  <div className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 text-center">
                    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">
                      {lifecycle.cancelType === 'cancels' ? 'Cancels On' : 'Renews On'}
                    </div>
                    <div className="text-sm font-semibold text-gray-900 dark:text-white">
                      {lifecycle.cancelType === 'cancels' && lifecycle.cancelEffectiveDate
                        ? lifecycle.cancelEffectiveDate.toLocaleDateString()
                        : lifecycle.renewsOn
                          ? lifecycle.renewsOn.toLocaleDateString()
                          : '—'}
                    </div>
                  </div>
                  <div 
                    className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 cursor-pointer hover:shadow-md transition-shadow text-center"
                    onClick={() => {
                      const initVal = lifecycle.cancelType === 'cancels' && lifecycle.cancelEffectiveDate
                        ? lifecycle.cancelEffectiveDate.toISOString().split('T')[0]
                        : 'renews';
                      handleEdit('program.cancelState', initVal);
                    }}
                  >
                    <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-1">Cancel State</div>
                    {isEditMode && editingField === 'program.cancelState' ? (
                      <div className="space-y-2 text-center" onClick={(e) => e.stopPropagation()}>
                        <select
                          value={editValue === 'renews' ? 'renews' : 'cancels'}
                          onChange={async (e) => {
                            if (e.target.value === 'renews') {
                              const updatedData = { ...account };
                              updatedData.program = programMapWith(updatedData.program, {
                                cancelState: 'Renews',
                                lifecycleOverrides: {
                                  ...(updatedData.program?.lifecycleOverrides || {}),
                                  cancelState: 'renews',
                                  cancelEffectiveDate: null,
                                },
                              });
                              await updateAccount(clientId, updatedData);
                              setAccount(updatedData);
                              setEditingField(null);
                            } else {
                              const defaultDate = lifecycle.cancelEffectiveDate
                                ? lifecycle.cancelEffectiveDate.toISOString().split('T')[0]
                                : new Date().toISOString().split('T')[0];
                              setEditValue(editValue === 'renews' ? defaultDate : editValue);
                            }
                          }}
                          className="text-sm font-semibold text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded w-full text-center"
                        >
                          <option value="renews">Renews</option>
                          <option value="cancels">Cancels on</option>
                        </select>
                        {editValue !== 'renews' && (
                          <input
                            type="date"
                            value={editValue || ''}
                            onChange={async (e) => {
                              const isoDate = e.target.value;
                              if (!isoDate) return;
                              const displayDate = new Date(isoDate + 'T00:00:00').toLocaleDateString();
                              const updatedData = { ...account };
                              updatedData.program = programMapWith(updatedData.program, {
                                cancelState: `Cancels on ${displayDate}`,
                                lifecycleOverrides: {
                                  ...(updatedData.program?.lifecycleOverrides || {}),
                                  cancelState: 'cancels',
                                  cancelEffectiveDate: isoDate + 'T00:00:00',
                                },
                              });
                              await updateAccount(clientId, updatedData);
                              setAccount(updatedData);
                              setEditingField(null);
                            }}
                            className="text-sm w-full bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded text-center"
                          />
                        )}
                      </div>
                    ) : (
                      <div className="text-sm font-semibold text-gray-900 dark:text-white text-center">
                        {lifecycle.cancelType === 'cancels'
                          ? lifecycle.cancelEffectiveDate
                            ? `Cancels on ${lifecycle.cancelEffectiveDate.toLocaleDateString()}`
                            : 'Cancels at period end'
                          : 'Renews'}
                      </div>
                    )}
                  </div>
                </div>

                {/* Show on Kanban and Lost Reason - Only when status is Lost */}
                {clientLifecycle.isEnded && (
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                    <div className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 text-center">
                      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">Show on Kanban</h3>
                      <div className="flex justify-center space-x-2">
                        <button onClick={() => handleShowOnKanbanUpdate(true)} className={`px-4 py-2 rounded-full text-sm font-medium ${showOnKanban ? 'bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 border-2 border-green-500' : 'bg-gray-100 dark:bg-gray-600 text-gray-700 dark:text-gray-300'}`}>Yes</button>
                        <button onClick={() => handleShowOnKanbanUpdate(false)} className={`px-4 py-2 rounded-full text-sm font-medium ${!showOnKanban ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300 border-2 border-red-500' : 'bg-gray-100 dark:bg-gray-600 text-gray-700 dark:text-gray-300'}`}>No</button>
                      </div>
                    </div>
                    <div className="md:col-span-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4">
                      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-3 text-center">
                        {clientLifecycle.state === 'Lost' ? 'Lost Reason' : clientLifecycle.state === 'Archived' ? 'Archive Reason' : 'Cancel Reason'}
                        {account.tierBeforeLost ? <span className="ml-2 text-xs text-gray-400 dark:text-gray-500">(was on {account.tierBeforeLost})</span> : null}
                      </h3>
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                        {END_REASONS.map((reason) => (
                          <button key={reason} onClick={() => handleLostReasonUpdate(reason)} className={`px-3 py-2 rounded-lg text-sm font-medium ${lostReason === reason ? 'bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300 border-2 border-red-500' : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600'}`}>{reason}</button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* 2) Deliverables */}
                <div className="mb-6">
                  <div className="flex flex-wrap items-center justify-center gap-2 mb-3">
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white">Deliverables</h3>
                    {isEditMode && (typeof account?.program === 'string' ? account.program : account?.program?.status) && account?.program?.status !== 'Not Started' && (
                      <div className="relative">
                        <button
                          type="button"
                          onClick={() => setShowAddDeliverablePicker(prev => !prev)}
                          className="inline-flex items-center gap-1 px-2 py-1 text-sm font-medium rounded-md bg-gray-200 dark:bg-gray-600 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-500"
                        >
                          <Plus className="w-4 h-4" /> Add deliverable
                        </button>
                        {showAddDeliverablePicker && (
                          <>
                            <div className="fixed inset-0 z-10" onClick={() => setShowAddDeliverablePicker(false)} aria-hidden="true" />
                            <div className="absolute left-0 top-full mt-1 z-20 w-72 max-h-72 overflow-auto rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-lg py-1" onClick={(e) => e.stopPropagation()}>
                              {/* One-period-only controls: when on, the picked item is added to the client's
                                  current billing period only (a one-off), and already-listed items become
                                  selectable so their quantity can be bumped just for this period. */}
                              <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-600 space-y-2">
                                <label className="flex items-center gap-2 text-xs font-medium text-gray-700 dark:text-gray-300 cursor-pointer">
                                  <input
                                    type="checkbox"
                                    checked={addPeriodOnly}
                                    onChange={(e) => setAddPeriodOnly(e.target.checked)}
                                    className="rounded border-gray-300 dark:border-gray-600"
                                  />
                                  This period only (one-off)
                                </label>
                                {addPeriodOnly && (
                                  <div className="flex items-center gap-2">
                                    <span className="text-xs text-gray-500 dark:text-gray-400">Quantity</span>
                                    <input
                                      type="number"
                                      min={1}
                                      value={addPeriodOnlyQty}
                                      onChange={(e) => setAddPeriodOnlyQty(Math.max(1, parseInt(e.target.value, 10) || 1))}
                                      className="w-14 text-center text-sm rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                                    />
                                  </div>
                                )}
                              </div>
                              {(() => {
                                const pickable = availableItems.filter(i =>
                                  i.hasDeliverable &&
                                  (addPeriodOnly
                                    ? true
                                    : (!programItems.some(p => p.id === i.id) &&
                                       (isCustomProgram ? !(account?.customProgramDeliverables || []).includes(i.id) : true)))
                                );
                                if (pickable.length === 0) {
                                  return <p className="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">No items to add</p>;
                                }
                                return pickable.map(i => (
                                  <button
                                    key={i.id}
                                    type="button"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (addPeriodOnly) {
                                        handleAddPeriodDeliverable(i, addPeriodOnlyQty);
                                      } else {
                                        handleAddDeliverable(i);
                                      }
                                    }}
                                    className="w-full text-left px-3 py-2 text-sm text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
                                  >
                                    {i.name || i.itemName || i.title || i.id}
                                    {addPeriodOnly && programItems.some(p => p.id === i.id) && (
                                      <span className="ml-1 text-xs text-gray-400">(bump this period)</span>
                                    )}
                                  </button>
                                ));
                              })()}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                    {programStatus && programStatus !== 'Not Started' && (
                      <button
                        type="button"
                        onClick={() => setShowNextPeriodModal(true)}
                        className="inline-flex items-center gap-1 px-2 py-1 text-sm font-medium rounded-md bg-indigo-100 dark:bg-indigo-900/40 text-indigo-700 dark:text-indigo-300 hover:bg-indigo-200 dark:hover:bg-indigo-900/60"
                        title="Schedule deliverable changes for the next period and view the change log"
                      >
                        <CalendarClock className="w-4 h-4" /> Next period
                        {pendingScheduledCount > 0 && (
                          <span className="ml-0.5 inline-flex items-center justify-center rounded-full bg-indigo-600 text-white text-[10px] font-semibold px-1.5 min-w-[18px]">
                            {pendingScheduledCount}
                          </span>
                        )}
                      </button>
                    )}
                  </div>
                  {programItems.length > 0 ? (
                    <div className="space-y-4">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {programItems.map((item, index) => {
                          // Contract item quantity (from program template) takes precedence over ala carte default
                          const quantity = Number(item.programQuantity) || parseInt(item.deliverable?.quantity, 10) || 1;
                          const completed = item.completed || 0;
                          const isCheckboxMode = item.isCheckboxMode && quantity === 1;
                          return (
                            <div 
                              key={item.id || index} 
                              className={`rounded-lg border p-4 transition-shadow text-center relative ${
                                completed >= quantity 
                                  ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-700' 
                                  : 'bg-gray-50 dark:bg-gray-700 border-gray-200 dark:border-gray-600'
                              } ${!canEditDeliverables ? 'cursor-pointer hover:shadow-md' : ''}`}
                              onClick={!canEditDeliverables ? () => handleDeliverableClick(item) : undefined}
                            >
                              {canEditDeliverables && (
                                <div className="absolute top-2 right-2" onClick={(e) => e.stopPropagation()}>
                                  <button
                                    type="button"
                                    onClick={(e) => { e.stopPropagation(); handleRemoveDeliverable(item); }}
                                    className="p-1 rounded text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20"
                                    title="Remove deliverable"
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </button>
                                </div>
                              )}
                              <div className={canEditDeliverables ? 'cursor-pointer hover:shadow-md' : ''} onClick={canEditDeliverables ? () => handleDeliverableClick(item) : undefined}>
                                <div className="text-2xl mb-2">{item.icon || '📦'}</div>
                                <div className="font-medium text-gray-900 dark:text-white mb-2">{item.name}</div>
                                {scheduledDeliverableChangesByItemId[item.id] && (
                                  <div className="mb-2 flex justify-center">
                                    <span
                                      className="inline-flex items-center rounded-full bg-indigo-100 dark:bg-indigo-900/30 px-2 py-0.5 text-[10px] font-medium text-indigo-700 dark:text-indigo-300"
                                      title="A change is scheduled to apply on the reset date — the current period is not affected."
                                    >
                                      Next period: {nextPeriodBadgeLabel(scheduledDeliverableChangesByItemId[item.id])}
                                    </span>
                                  </div>
                                )}
                                {item.oneTimePeriodKey && (
                                  <div className="mb-2 flex justify-center">
                                    <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 dark:bg-amber-900/30 px-2 py-0.5 text-[10px] font-medium text-amber-700 dark:text-amber-300" title="Applies to the current billing period only — it will not carry into the next period.">
                                      {item.oneTimePeriodOnly ? 'This period only' : `+${item.oneTimePeriodQuantity} this period`}
                                      {canEditDeliverables && !item.oneTimePeriodOnly && (
                                        <button
                                          type="button"
                                          onClick={(e) => { e.stopPropagation(); handleRemovePeriodDeliverable(item); }}
                                          className="ml-0.5 hover:text-amber-900 dark:hover:text-amber-100"
                                          title="Remove this-period bump"
                                        >
                                          ×
                                        </button>
                                      )}
                                    </span>
                                  </div>
                                )}
                                {isCheckboxMode ? (
                                  <div className="flex justify-center">
                                    {completed >= 1 ? (
                                      <div className="w-8 h-8 rounded flex items-center justify-center bg-green-500 text-white">
                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                        </svg>
                                      </div>
                                    ) : (
                                      <div className="w-8 h-8 rounded border-2 border-gray-400 dark:border-gray-500 flex items-center justify-center bg-transparent" title="Not completed">
                                        <svg className="w-5 h-5 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2" />
                                        </svg>
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div className="flex justify-center gap-1 flex-wrap">
                                    {Array.from({ length: Math.max(1, quantity) }, (_, i) => i + 1).map((n) => (
                                      <DeliverableProgressCircle key={n} n={n} completed={completed} />
                                    ))}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400 pt-2 text-center">
                        Reset date:{' '}
                        {lifecycle.renewsOn ? lifecycle.renewsOn.toLocaleDateString() : '—'}
                      </div>
                    </div>
                  ) : (
                    <div className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-6 text-center">
                      <p className="text-gray-600 dark:text-gray-400">
                        {(() => {
                          const status = typeof account.program === 'string' ? account.program : account.program?.status;
                          return status === 'Not Started' || !status
                            ? 'No program selected yet'
                            : `No deliverables for ${status} program`;
                        })()}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : activeTab === 'bids' ? (
            <AccountAlaCarteBidsTab
              accountId={clientId}
              accountType="Clients"
              companyName={account?.company || ''}
              active={activeTab === 'bids'}
            />
          ) : activeTab === 'task time' ? (
            <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
              <AccountTaskTimeTab
                accountId={clientId}
                active={activeTab === 'task time'}
              />
            </div>
          ) : activeTab === 'billing' ? (
            !canSeePrivilegedClientTabs ? (
              <Navigate to={`/crm/client/${clientId}`} replace />
            ) : (
                <div className="space-y-6">
              <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
                {/* Billing Debug (dev-only) */}
                {isDevelopment && (
                  <div className="mb-6 p-4 bg-purple-50 dark:bg-purple-900/20 rounded-lg border border-purple-200 dark:border-purple-700">
                    <h3 className="text-sm font-medium text-purple-800 dark:text-purple-200 mb-2">Billing Debug</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs font-mono text-purple-700 dark:text-purple-300">
                      <div><span className="text-purple-500">stripeCustomerId:</span> {account.stripeCustomerId || '—'}</div>
                      <div><span className="text-purple-500">subscriptionId:</span> {account.billing?.stripeSubscriptionId || '—'}</div>
                      <div><span className="text-purple-500">status:</span> {account.billing?.status || '—'}</div>
                      <div><span className="text-purple-500">period:</span> {account.billing?.currentPeriodStart ? new Date(account.billing.currentPeriodStart).toLocaleDateString() : '—'} → {account.billing?.currentPeriodEnd ? new Date(account.billing.currentPeriodEnd).toLocaleDateString() : '—'}</div>
                      <div><span className="text-purple-500">callsUsed:</span> {stripeUsage?.callsUsed ?? '—'} / {stripeUsage?.callsLimit ?? account.billing?.entitlements?.callsLimitPerPeriod ?? '—'}</div>
                    </div>
                    <button
                      type="button"
                      onClick={handleSyncStripeBilling}
                      disabled={syncBillingLoading}
                      className="mt-2 px-3 py-1.5 text-xs font-medium rounded bg-purple-600 text-white hover:bg-purple-700 disabled:opacity-50"
                    >
                      {syncBillingLoading ? 'Syncing…' : 'Sync billing / lifetime'}
                    </button>
                  </div>
                )}

                {/* Subscriptions (one row each — a client can have several) + this month / lifetime P&L */}
                <ClientBillingSummary
                  account={account}
                  stripePayments={stripePayments}
                  expenses={accountExpenses}
                  onSaveField={handleSaveBillingField}
                  onSyncStripe={handleSyncStripeBilling}
                  syncing={syncBillingLoading}
                />

                {/* Billing Note */}
                {(() => {
                  const savedNote = account.billing?.note || '';
                  const hasNote = !!savedNote.trim();
                  const showEditor = !hasNote || editingBillingNote;
                  const noteAuthor = account.billing?.noteAuthorId
                    ? internalUsers.find((u) => u.id === account.billing.noteAuthorId)
                    : null;
                  const authorName = noteAuthor?.name || account.billing?.noteAuthorName || null;
                  const noteDate = account.billing?.noteUpdatedAt
                    ? new Date(account.billing.noteUpdatedAt).toLocaleDateString()
                    : null;

                  return (
                    <div className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 mb-6">
                      <div className="relative flex items-center justify-center mb-3 min-h-[1.75rem]">
                        {(noteDate || authorName) && (
                          <div className="absolute left-0 flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                            {authorName && (
                              <div className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-[10px] font-medium text-gray-600 dark:text-gray-300 overflow-hidden flex-shrink-0 relative">
                                {noteAuthor?.profileImage ? (
                                  <img
                                    src={noteAuthor.profileImage}
                                    alt={authorName}
                                    className="w-full h-full object-cover absolute inset-0 z-10"
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                  />
                                ) : null}
                                <span className="w-full h-full flex items-center justify-center">
                                  {noteAuthor?.initials || authorName.charAt(0).toUpperCase()}
                                </span>
                              </div>
                            )}
                            <span>
                              {authorName ? `${authorName} • ` : ''}{noteDate || ''}
                            </span>
                          </div>
                        )}
                        <h3 className="text-sm font-medium text-gray-900 dark:text-white text-center">Billing Note</h3>
                        {hasNote && !editingBillingNote && (
                          <button
                            type="button"
                            onClick={() => {
                              setBillingNoteDraft(savedNote);
                              setEditingBillingNote(true);
                            }}
                            className="absolute right-0 p-1.5 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 rounded"
                            title="Edit billing note"
                          >
                            <Edit className="w-4 h-4" />
                          </button>
                        )}
                      </div>

                      {showEditor ? (
                        <>
                          <textarea
                            value={billingNoteDraft}
                            onChange={(e) => setBillingNoteDraft(e.target.value)}
                            rows="3"
                            placeholder="Add a note about this client's billing..."
                            className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-1 focus:ring-red-500 focus:border-red-500 bg-white dark:bg-gray-800 text-sm text-gray-900 dark:text-white"
                          />
                          <div className="mt-2 flex items-center justify-end gap-2">
                            {editingBillingNote && (
                              <button
                                type="button"
                                onClick={() => {
                                  setBillingNoteDraft(savedNote);
                                  setEditingBillingNote(false);
                                }}
                                className="px-3 py-1.5 text-xs font-medium text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                              >
                                Cancel
                              </button>
                            )}
                            <button
                              type="button"
                              onClick={handleSaveBillingNote}
                              disabled={billingNoteSaving || billingNoteDraft === savedNote}
                              className="px-3 py-1.5 text-xs font-medium rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                              {billingNoteSaving ? 'Saving…' : 'Save Note'}
                            </button>
                          </div>
                        </>
                      ) : (
                        <p className="text-sm text-gray-900 dark:text-white whitespace-pre-wrap text-center">{savedNote}</p>
                      )}
                    </div>
                  );
                })()}

                {/* 4) Payments & Expenses Table — money in (green) and money out (red) */}
                <div>
                  <div className="relative flex items-center justify-center mb-4">
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white text-center">Payments &amp; Expenses</h3>
                    <div className="absolute right-0 flex items-center gap-2">
                      <button
                        type="button"
                        onClick={() => setShowAddPaymentModal(true)}
                        className="flex items-center gap-1 px-3 py-2 text-xs font-medium rounded-lg bg-green-600 text-white hover:bg-green-700"
                      >
                        <Plus className="w-4 h-4" /> Payment
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setEditingExpenseId(null);
                          setNewExpense({ amount: '', date: '', status: 'paid', subcontractorId: '', subcontractorName: '' });
                          setShowAddExpenseModal(true);
                        }}
                        className="flex items-center gap-1 px-3 py-2 text-xs font-medium rounded-lg bg-red-600 text-white hover:bg-red-700"
                      >
                        <Plus className="w-4 h-4" /> Expense
                      </button>
                    </div>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                      <thead className="bg-gray-50 dark:bg-gray-700">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Date</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Type</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Amount</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Status</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Subcontractor</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                        {(() => {
                          const fromBilling = (account.billing?.payments || []).filter(p => !p.stripeInvoiceId && !stripePayments.some(sp => sp.id === p.id));
                          const combined = [...stripePayments, ...fromBilling];
                          const seenStripeIds = new Set();
                          const dedupedPayments = combined.filter(p => {
                            const sid = p.stripeInvoiceId || null;
                            if (sid) {
                              if (seenStripeIds.has(sid)) return false;
                              seenStripeIds.add(sid);
                            }
                            return true;
                          });

                          const paymentRows = dedupedPayments.map((payment, index) => ({
                            kind: 'payment',
                            key: `payment-${payment.id || index}`,
                            sortDate: new Date(payment.createdAt?.toDate?.() || payment.createdAt || payment.dueDate || 0),
                            record: payment,
                          }));
                          const expenseRows = accountExpenses.map((expense, index) => ({
                            kind: 'expense',
                            key: `expense-${expense.id || index}`,
                            sortDate: parseExpenseDate(expense) || new Date(0),
                            record: expense,
                          }));
                          const rows = [...paymentRows, ...expenseRows].sort((a, b) => b.sortDate - a.sortDate);

                          if (rows.length === 0) {
                            return (
                              <tr>
                                <td colSpan="6" className="px-6 py-4 text-center text-sm text-gray-500 dark:text-gray-400">No payment or expense records found</td>
                              </tr>
                            );
                          }

                          const statusPill = (label) => (
                            <span className={`px-2 py-1 text-xs rounded-full ${
                              label === 'Paid' ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300' :
                              label === 'Failed' ? 'bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300' :
                              label === 'Refunded' ? 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300' :
                              'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-300'
                            }`}>
                              {label}
                            </span>
                          );

                          // With several subscriptions, say which one each Stripe payment was for.
                          const billingSubs = account.billing?.subscriptions || [];
                          const subscriptionLabelById = billingSubs.length > 1
                            ? new Map(billingSubs.map((s) => [s.id, s.label || 'Subscription']))
                            : null;

                          return rows.map((row) => {
                            if (row.kind === 'expense') {
                              const expense = row.record;
                              const displayStatus = expense.status === 'paid' ? 'Paid' : expense.status === 'failed' ? 'Failed' : 'Processing';
                              const expenseDate = parseExpenseDate(expense);
                              return (
                                <tr key={row.key} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                    {expenseDate ? expenseDate.toLocaleDateString() : 'Not set'}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="px-2 py-1 text-xs rounded-full bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-300">Expense</span>
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-red-600 dark:text-red-400">
                                    -${Math.abs(expense.amount || 0).toLocaleString()}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap">{statusPill(displayStatus)}</td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                    {expense.subcontractorName || '—'}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center gap-1">
                                      <button onClick={() => handleEditExpense(expense)} className="p-1.5 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 rounded" title="Update expense"><Edit className="w-4 h-4" /></button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            }

                            const payment = row.record;
                            const displayStatus = payment.status === 'paid' ? 'Paid' : payment.status === 'failed' ? 'Failed' : payment.status === 'refunded' ? 'Refunded' : payment.status === 'processing' ? 'Processing' : payment.status === 'overdue' ? 'Failed' : 'Processing';
                            const receiptUrl = payment.hostedInvoiceUrl || payment.receiptUrl;
                            return (
                              <tr key={row.key} className="hover:bg-gray-50 dark:hover:bg-gray-700">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                                  {(payment.dueDate || payment.createdAt) ? new Date(payment.dueDate || payment.createdAt?.toDate?.() || payment.createdAt).toLocaleDateString() : 'Not set'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <span className="px-2 py-1 text-xs rounded-full bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300">Payment</span>
                                  {subscriptionLabelById?.get(payment.stripeSubscriptionId) && (
                                    <div className="mt-1 text-[11px] text-gray-500 dark:text-gray-400">
                                      {subscriptionLabelById.get(payment.stripeSubscriptionId)}
                                    </div>
                                  )}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-green-600 dark:text-green-400">
                                  ${Math.abs(payment.amount || 0).toLocaleString()}{payment.amount < 0 ? ' (refund)' : ''}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">{statusPill(displayStatus)}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">—</td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                  <div className="flex items-center gap-1">
                                    {receiptUrl ? (
                                      <a href={receiptUrl} target="_blank" rel="noopener noreferrer" className="p-1.5 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 rounded" title="View receipt/invoice"><FileText className="w-4 h-4" /></a>
                                    ) : (
                                      <button onClick={() => {}} className="p-1.5 text-gray-400 cursor-not-allowed rounded" title="No receipt available"><FileText className="w-4 h-4" /></button>
                                    )}
                                    {displayStatus === 'Failed' && <button onClick={() => {}} className="p-1.5 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 rounded" title="Retry payment"><RefreshCw className="w-4 h-4" /></button>}
                                    {!payment.stripeInvoiceId && <button onClick={() => handleEditPayment(payment)} className="p-1.5 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 rounded" title="Update payment"><Edit className="w-4 h-4" /></button>}
                                    <button onClick={() => {}} className="p-1.5 text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 rounded" title="Update payment method"><CreditCard className="w-4 h-4" /></button>
                                  </div>
                                </td>
                              </tr>
                            );
                          });
                        })()}
                      </tbody>
                    </table>
                  </div>
                </div>

                {showAddPaymentModal && (
                      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
                        <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-lg w-full mx-4">
                          <div className="flex justify-between items-center mb-4">
                            <div className="flex-1"></div>
                            <h3 className="text-lg font-medium text-gray-900 dark:text-white text-center flex-1">
                              {editingPaymentId ? 'Edit Payment' : 'Add New Payment'}
                            </h3>
                            <div className="flex-1 flex justify-end">
                              <button
                                onClick={() => {
                                  setShowAddPaymentModal(false);
                                  setEditingPaymentId(null);
                                  setNewPayment({
                                    amount: '',
                                    dueDate: '',
                                    status: 'processing'
                                  });
                                }}
                                className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </button>
                            </div>
                          </div>
                          <div className="space-y-4">
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Amount</label>
                              <input
                                type="number"
                                value={newPayment.amount}
                                onChange={(e) => setNewPayment({ ...newPayment, amount: parseFloat(e.target.value) })}
                                className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                                placeholder="Enter amount"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Date</label>
                              <input
                                type="date"
                                value={newPayment.dueDate}
                                onChange={(e) => setNewPayment({ ...newPayment, dueDate: e.target.value })}
                                className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                              />
                            </div>
                            <div>
                              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Status</label>
                              <select
                                value={newPayment.status === 'overdue' ? 'failed' : newPayment.status === 'pending' ? 'processing' : newPayment.status}
                                onChange={(e) => setNewPayment({ ...newPayment, status: e.target.value === 'failed' ? 'failed' : e.target.value === 'processing' ? 'processing' : 'paid' })}
                                className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                              >
                                <option value="paid">Paid</option>
                                <option value="failed">Failed</option>
                                <option value="processing">Processing</option>
                              </select>
                            </div>
                          </div>
                          <div className="mt-6 flex justify-between items-center">
                            {editingPaymentId && (
                              <button
                                onClick={async () => {
                                  await handleDeletePayment(editingPaymentId);
                                  setShowAddPaymentModal(false);
                                  setEditingPaymentId(null);
                                  setNewPayment({
                                    amount: '',
                                    dueDate: '',
                                    status: 'processing'
                                  });
                                }}
                                className="px-4 py-2 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200"
                              >
                                Delete
                              </button>
                            )}
                            <div className="flex space-x-3 ml-auto">
                              <button
                                onClick={() => {
                                  setShowAddPaymentModal(false);
                                  setEditingPaymentId(null);
                                  setNewPayment({
                                    amount: '',
                                    dueDate: '',
                                    status: 'processing'
                                  });
                                }}
                                className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                              >
                                Cancel
                              </button>
                              <button
                                onClick={async () => {
                                  if (newPayment.amount) {
                                    try {
                                      if (editingPaymentId) {
                                        await handleUpdatePayment(editingPaymentId, newPayment);
                                      } else {
                                        const payment = {
                                          ...newPayment,
                                          id: Date.now().toString(),
                                          date: new Date().toISOString(),
                                          type: 'subscription',
                                          description: 'Payment'
                                        };
                                        const updatedPayments = [...(account.billing?.payments || []), payment];
                                        const updatedAccount = {
                                          ...account,
                                          billing: {
                                            ...account.billing,
                                            payments: updatedPayments
                                          }
                                        };
                                        setAccount(updatedAccount);
                                        await writeAccount(clientId, { 'billing.payments': updatedPayments });
                                      }
                                      setNewPayment({
                                        amount: '',
                                        dueDate: '',
                                        status: 'pending'
                                      });
                                      setEditingPaymentId(null);
                                      setShowAddPaymentModal(false);
                                    } catch (error) {
                                      console.error('Error saving payment:', error);
                                      alert('Failed to save payment. Please try again.');
                                    }
                                  }
                                }}
                                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                              >
                                {editingPaymentId ? 'Update Payment' : 'Add Payment'}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                {showAddExpenseModal && (
                  <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
                    <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-lg w-full mx-4">
                      <div className="flex justify-between items-center mb-4">
                        <div className="flex-1"></div>
                        <h3 className="text-lg font-medium text-gray-900 dark:text-white text-center flex-1">
                          {editingExpenseId ? 'Edit Expense' : 'Add New Expense'}
                        </h3>
                        <div className="flex-1 flex justify-end">
                          <button
                            onClick={closeExpenseModal}
                            className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                          >
                            <X className="h-6 w-6" />
                          </button>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Amount</label>
                          <input
                            type="number"
                            value={newExpense.amount}
                            onChange={(e) => setNewExpense({ ...newExpense, amount: e.target.value })}
                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="Enter amount"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Date</label>
                          <input
                            type="date"
                            value={newExpense.date}
                            onChange={(e) => setNewExpense({ ...newExpense, date: e.target.value })}
                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Status</label>
                          <select
                            value={newExpense.status}
                            onChange={(e) => setNewExpense({ ...newExpense, status: e.target.value })}
                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                          >
                            <option value="paid">Paid</option>
                            <option value="processing">Processing</option>
                            <option value="failed">Failed</option>
                          </select>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Subcontractor</label>
                          <select
                            value={newExpense.subcontractorId}
                            onChange={(e) => {
                              const partner = partnerOptions.find((p) => p.id === e.target.value);
                              setNewExpense({
                                ...newExpense,
                                subcontractorId: e.target.value,
                                subcontractorName: partner?.companyName || '',
                              });
                            }}
                            className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                          >
                            <option value="">Select a partner…</option>
                            {partnerOptions.map((partner) => (
                              <option key={partner.id} value={partner.id}>{partner.companyName}</option>
                            ))}
                          </select>
                          {/* Webhook-created expenses can name a subcontractor that is not in the partners list */}
                          {!newExpense.subcontractorId && newExpense.subcontractorName && (
                            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                              Currently recorded as “{newExpense.subcontractorName}” (not linked to a partner).
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mt-6 flex justify-between items-center">
                        {editingExpenseId && (
                          <button
                            onClick={() => handleDeleteExpense(editingExpenseId)}
                            disabled={expenseSaving}
                            className="px-4 py-2 text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-200 disabled:opacity-50"
                          >
                            Delete
                          </button>
                        )}
                        <div className="flex space-x-3 ml-auto">
                          <button
                            onClick={closeExpenseModal}
                            className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={handleSaveExpense}
                            disabled={expenseSaving || !newExpense.amount}
                            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                          >
                            {expenseSaving ? 'Saving…' : editingExpenseId ? 'Update Expense' : 'Add Expense'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            )
          ) : activeTab === 'events' ? (
            <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
              <div className="flex items-center justify-between mb-6">
                <div className="flex-1"></div>
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white text-center flex-1">Events</h2>
                
                {/* Filter Dropdown */}
                <div className="relative flex-1 flex justify-end">
                  <select
                    value={eventsFilter}
                    onChange={(e) => {
                      setEventsFilter(e.target.value);
                      setEventsCurrentPage(1); // Reset to first page when filter changes
                    }}
                    className="appearance-none bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2 pr-8 text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  >
                    <option value="upcoming">Upcoming</option>
                    <option value="completed">Completed</option>
                    <option value="all">All</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-300">
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
              
              {eventsLoading || teamMembersLoading ? (
                <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                  Loading events...
                </div>
              ) : (() => {
                // Filter events based on selected filter
                const now = new Date();
                const filteredEvents = clientEvents.filter(event => {
                  const eventDate = new Date(event.start || event.startTime);
                  if (eventsFilter === 'upcoming') {
                    return eventDate >= now;
                  } else if (eventsFilter === 'completed') {
                    return eventDate < now;
                  } else {
                    return true; // 'all'
                  }
                });

                if (process.env.NODE_ENV === 'development' && clientEvents.length > 0) {
                  const upcoming = clientEvents.filter(e => new Date(e.start || e.startTime) >= now).length;
                  const completed = clientEvents.length - upcoming;
                  console.log(`[Events] UI filter "${eventsFilter}": showing ${filteredEvents.length} of ${clientEvents.length} total (${upcoming} upcoming, ${completed} completed)`);
                }

                if (filteredEvents.length === 0) {
                  return (
                    <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                      {eventsFilter === 'upcoming' 
                        ? 'No upcoming events found with this client.'
                        : eventsFilter === 'completed'
                        ? 'No completed events found with this client.'
                        : 'No events found with this client.'}
                    </div>
                  );
                }

                // Calculate pagination
                const totalPages = Math.ceil(filteredEvents.length / eventsPerPage);
                const startIndex = (eventsCurrentPage - 1) * eventsPerPage;
                const endIndex = startIndex + eventsPerPage;
                const paginatedEvents = filteredEvents.slice(startIndex, endIndex);

                return (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {paginatedEvents.map((event, index) => {
                    const eventDate = new Date(event.start || event.startTime);
                    const isCompleted = eventDate < now;
                    const formattedDate = eventDate.toLocaleDateString('en-US', { 
                      month: 'short', 
                      day: 'numeric', 
                      year: 'numeric' 
                    });
                    const formattedTime = eventDate.toLocaleTimeString('en-US', { 
                      hour: 'numeric', 
                      minute: '2-digit',
                      hour12: true 
                    });
                    const eventTitle = event.title || event.summary || 'Untitled Event';
                    // Remove time prefix if it exists (from Google Calendar service formatting)
                    const cleanTitle = eventTitle.replace(/^\d{1,2}:\d{2}\s*(AM|PM)\s*-\s*/, '');
                    
                    return (
                      <div
                        key={event.id || event.googleEventId || index}
                        className="bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-600 hover:shadow-md transition-shadow duration-200"
                      >
                        <div className="flex items-start justify-between mb-3">
                          <div className="flex-1">
                            <div className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">
                              {formattedDate}
                            </div>
                            <div className="text-xs text-gray-500 dark:text-gray-500">
                              {formattedTime}
                            </div>
                          </div>
                        </div>
                        
                        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-3 line-clamp-2">
                          {cleanTitle}
                        </h3>
                        
                        {event.host && (
                          <div className="flex items-center space-x-2 mt-3 pt-3 border-t border-gray-200 dark:border-gray-600">
                            {event.host.profileImage ? (
                              <img
                                src={event.host.profileImage}
                                alt={event.host.name}
                                className="w-8 h-8 rounded-full object-cover"
                              />
                            ) : (
                              <div className="w-8 h-8 rounded-full bg-gray-400 dark:bg-gray-600 flex items-center justify-center text-white text-xs font-medium">
                                {event.host.initials}
                              </div>
                            )}
                            <div className="flex-1 min-w-0">
                              <div className="text-xs text-gray-500 dark:text-gray-400">Host</div>
                              <div className="text-sm font-medium text-gray-900 dark:text-white truncate">
                                {event.host.name}
                              </div>
                            </div>
                            {event.internalAttendees && event.internalAttendees.length > 0 && (
                              <div className="flex items-center -space-x-2">
                                {event.internalAttendees.slice(0, 3).map((attendee, idx) => (
                                  <div key={attendee.id || idx} className="relative group">
                                    {attendee.profileImage ? (
                                      <img
                                        src={attendee.profileImage}
                                        alt={attendee.name}
                                        title={attendee.name}
                                        className="w-8 h-8 rounded-full object-cover border-2 border-white dark:border-gray-800 hover:scale-110 transition-transform cursor-pointer"
                                      />
                                    ) : (
                                      <div 
                                        title={attendee.name}
                                        className="w-8 h-8 rounded-full bg-blue-400 dark:bg-blue-600 flex items-center justify-center text-white text-xs font-medium border-2 border-white dark:border-gray-800 hover:scale-110 transition-transform cursor-pointer"
                                      >
                                        {attendee.initials}
                                      </div>
                                    )}
                                  </div>
                                ))}
                                {event.internalAttendees.length > 3 && (
                                  <div 
                                    title={`+${event.internalAttendees.length - 3} more`}
                                    className="w-8 h-8 rounded-full bg-gray-300 dark:bg-gray-600 flex items-center justify-center text-gray-700 dark:text-gray-200 text-xs font-medium border-2 border-white dark:border-gray-800"
                                  >
                                    +{event.internalAttendees.length - 3}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}

                        {(() => {
                          const clientTeamInvitees = (event.clientInvitees || []).filter(
                            (inv) => inv.kind === 'team'
                          );
                          if (clientTeamInvitees.length === 0) return null;
                          return (
                          <div className="flex items-center space-x-2 mt-3 pt-3 border-t border-gray-200 dark:border-gray-600">
                            <div className="flex-1 min-w-0">
                              <div className="text-xs text-gray-500 dark:text-gray-400">Client team</div>
                              <div className="text-sm font-medium text-gray-900 dark:text-white truncate">
                                {clientTeamInvitees.map((inv) => inv.name).filter(Boolean).join(', ')}
                              </div>
                            </div>
                            <div className="flex items-center -space-x-2 shrink-0">
                              {clientTeamInvitees.slice(0, 4).map((invitee, idx) => (
                                <div key={invitee.id || invitee.email || idx} className="relative group">
                                  {invitee.profileImage ? (
                                    <img
                                      src={invitee.profileImage}
                                      alt={invitee.name}
                                      title={invitee.name}
                                      className="w-8 h-8 rounded-full object-cover border-2 border-white dark:border-gray-800 hover:scale-110 transition-transform cursor-pointer"
                                    />
                                  ) : (
                                    <div 
                                      title={invitee.name}
                                      className="w-8 h-8 rounded-full bg-emerald-500 dark:bg-emerald-600 flex items-center justify-center text-white text-xs font-medium border-2 border-white dark:border-gray-800 hover:scale-110 transition-transform cursor-pointer"
                                    >
                                      {invitee.initials}
                                    </div>
                                  )}
                                </div>
                              ))}
                              {clientTeamInvitees.length > 4 && (
                                <div 
                                  title={clientTeamInvitees.slice(4).map((inv) => inv.name).join(', ')}
                                  className="w-8 h-8 rounded-full bg-gray-300 dark:bg-gray-600 flex items-center justify-center text-gray-700 dark:text-gray-200 text-xs font-medium border-2 border-white dark:border-gray-800"
                                >
                                  +{clientTeamInvitees.length - 4}
                                </div>
                              )}
                            </div>
                          </div>
                          );
                        })()}
                        
                        <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-600">
                          {!isCompleted && event.htmlLink && (
                            <a
                              href={event.htmlLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-500"
                            >
                              View in Calendar
                              <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                              </svg>
                            </a>
                          )}
                          {isCompleted && (() => {
                            const hasFathomSummary = eventHasFathomSummary(
                              event,
                              accountMeetingSummaries,
                              account?.id || clientId,
                              internalUsers.map((u) => u.email)
                            );
                            if (hasFathomSummary) {
                              return (
                                <button
                                  type="button"
                                  onClick={() => handleViewMeetingSummary(event)}
                                  className="flex w-full items-center justify-center gap-2 rounded-lg bg-red-600 px-4 py-3 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-red-700 dark:bg-red-600 dark:hover:bg-red-500"
                                >
                                  Meeting Summary
                                  <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                  </svg>
                                </button>
                              );
                            }
                            return (
                              <div
                                aria-disabled="true"
                                className="flex w-full cursor-not-allowed items-center justify-center gap-2 rounded-lg bg-gray-200 px-4 py-3 text-sm font-semibold text-gray-500 dark:bg-gray-700 dark:text-gray-400"
                              >
                                No Meeting Summary
                              </div>
                            );
                          })()}
                        </div>
                      </div>
                    );
                  })}
                    </div>
                    
                    {/* Pagination Controls */}
                    {totalPages > 1 && (
                      <div className="flex items-center justify-center space-x-2 mt-6">
                        <button
                          onClick={() => setEventsCurrentPage(prev => Math.max(1, prev - 1))}
                          disabled={eventsCurrentPage === 1}
                          className="px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Previous
                        </button>
                        
                        <div className="flex items-center space-x-1">
                          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
                            // Show first page, last page, current page, and pages around current
                            if (
                              page === 1 ||
                              page === totalPages ||
                              (page >= eventsCurrentPage - 1 && page <= eventsCurrentPage + 1)
                            ) {
                              return (
                                <button
                                  key={page}
                                  onClick={() => setEventsCurrentPage(page)}
                                  className={`px-3 py-2 text-sm font-medium rounded-lg ${
                                    eventsCurrentPage === page
                                      ? 'bg-red-600 text-white'
                                      : 'text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600'
                                  }`}
                                >
                                  {page}
                                </button>
                              );
                            } else if (
                              page === eventsCurrentPage - 2 ||
                              page === eventsCurrentPage + 2
                            ) {
                              return (
                                <span key={page} className="px-2 text-gray-500 dark:text-gray-400">
                                  ...
                                </span>
                              );
                            }
                            return null;
                          })}
                        </div>
                        
                        <button
                          onClick={() => setEventsCurrentPage(prev => Math.min(totalPages, prev + 1))}
                          disabled={eventsCurrentPage === totalPages}
                          className="px-3 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </>
                );
              })()}
            </div>
          ) : activeTab === 'emails' ? (
            <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
              <div className="flex items-center justify-end mb-4">
                {/* Filter Dropdown */}
                <div className="relative">
                  <select
                    value={emailsFilter}
                    onChange={(e) => setEmailsFilter(e.target.value)}
                    className="appearance-none bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg px-4 py-2 pr-8 text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
                  >
                    <option value="all">All</option>
                    <option value="from">From Client</option>
                    <option value="to">To Client</option>
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-300">
                    <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                      <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                    </svg>
                  </div>
                </div>
              </div>
              
              {/* Gmail connection warning — without this a disconnected inbox just looks like "no emails" */}
              {!emailsLoading && (
                <GmailConnectionNotice
                  users={gmailDisconnectedUsers}
                  currentUserId={currentUser?.uid}
                  onConnect={() => navigate('/crm/my-profile')}
                />
              )}

              {emailsLoading ? (
                <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                  Loading emails...
                </div>
              ) : (
                <EmailThreadList
                  emails={clientEmails}
                  counterpartEmail={account?.contact?.email || ''}
                  counterpartPerson={{
                    email: account?.contact?.email || '',
                    name: account?.contact?.name || '',
                  }}
                  directory={internalUsers}
                  filter={emailsFilter}
                  labels={{ from: 'From Client', to: 'To Client' }}
                  emptyMessage="No emails found with this client."
                />
              )}
            </div>
          ) : activeTab === 'check in' ? (
            !canSeePrivilegedClientTabs ? (
              <Navigate to={`/crm/client/${clientId}`} replace />
            ) : (
            <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
              <div className="space-y-6">
                <div className="grid grid-cols-3 items-center gap-2 mb-6">
                  <div className="flex flex-wrap items-center gap-2 justify-self-start min-w-0">
                    <Calendar className="w-5 h-5 shrink-0 text-gray-600 dark:text-gray-300" aria-hidden />
                    <span
                      className="text-sm font-medium text-gray-900 dark:text-white"
                      title="Check-ins send automatically to all clients on the 1st of each month"
                    >
                      Auto-sends on the 1st
                    </span>
                  </div>
                  <h2 className="text-xl font-semibold text-gray-900 dark:text-white text-center">Check Ins</h2>
                  <div className="justify-self-end flex justify-end">
                    <button
                      type="button"
                      onClick={handleSendCheckInNow}
                      disabled={sendingCheckInManual || checkInsLoading || !account?.contact?.email}
                      title={
                        !account?.contact?.email
                          ? 'Add a contact email to send a check-in'
                          : 'Send this month’s check-in to the client portal now'
                      }
                      className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <Send className="w-4 h-4 shrink-0" aria-hidden />
                      {sendingCheckInManual ? 'Sending…' : 'Send check-in'}
                    </button>
                  </div>
                </div>

                {!hasPortalAccount && (
                  <p className="text-sm text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 rounded-lg px-3 py-2">
                    Check-ins auto-send on the 1st of each month, but no portal user is linked to this account
                    (by account id, client id, or contact email). Link or invite a portal user so surveys can be delivered.
                  </p>
                )}

                {checkInsLoading ? (
                  <div className="text-center py-8">
                    <BBALoader size={32} className="mx-auto mb-2" />
                    <p className="text-gray-500 dark:text-gray-400">Loading check-ins...</p>
                  </div>
                ) : checkIns.length === 0 ? (
                  <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                    <div className="text-4xl mb-2">📋</div>
                    <p>
                      No check-ins on file yet. Use Send check-in to deliver this month’s survey, or wait for the 1st of the month.
                    </p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {checkIns.map((checkIn) => {
                      const isPending = isCheckInCardAwaitingCompletion(checkIn);
                      return (
                      <div
                        key={checkIn.id}
                        className={`relative rounded-lg p-4 border cursor-pointer hover:shadow-md transition-shadow duration-200 ${
                          isPending
                            ? 'bg-amber-50/80 dark:bg-amber-950/30 border-amber-400 dark:border-amber-500'
                            : 'bg-gray-50 dark:bg-gray-700 border-gray-200 dark:border-gray-600'
                        }`}
                        onClick={() => {
                          setSelectedCheckIn(checkIn);
                          setShowCheckInDetailsModal(true);
                        }}
                      >
                        {isPending && (
                          <span className="absolute top-2 right-2 text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-amber-500 text-white">
                            Pending
                          </span>
                        )}
                        <div className="text-center">
                          <div className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                            {checkIn.month || 'Unknown Month'}
                          </div>
                          {isPending ? (
                            <div className="text-sm text-amber-800 dark:text-amber-200 mb-1 font-medium">
                              Sent — awaiting client response
                            </div>
                          ) : (() => {
                            const count = getCheckInCardStarCount(checkIn);
                            if (count == null) {
                              return (
                                <div className="text-sm text-gray-500 dark:text-gray-400 mb-1">
                                  No rating
                                </div>
                              );
                            }
                            return (
                              <div
                                className="flex justify-center gap-0.5 mb-1"
                                aria-label={`${count} out of 5 stars`}
                              >
                                {[1, 2, 3, 4, 5].map((i) => (
                                  <span
                                    key={i}
                                    className={`text-2xl leading-none select-none ${
                                      i <= count
                                        ? 'text-yellow-400'
                                        : 'text-gray-300 dark:text-gray-600'
                                    }`}
                                    aria-hidden
                                  >
                                    ★
                                  </span>
                                ))}
                              </div>
                            );
                          })()}
                          {(checkIn.wantsSuccessManagerQuestion || checkIn.requestedCheckInCall) && (
                            <div className="mt-2 flex flex-wrap gap-1 justify-center">
                              {checkIn.wantsSuccessManagerQuestion ? (
                                <span className="text-[10px] uppercase tracking-wide px-2 py-0.5 rounded bg-blue-100 dark:bg-blue-900/50 text-blue-800 dark:text-blue-200">
                                  Question
                                </span>
                              ) : null}
                              {checkIn.requestedCheckInCall ? (
                                <span className="text-[10px] uppercase tracking-wide px-2 py-0.5 rounded bg-purple-100 dark:bg-purple-900/50 text-purple-800 dark:text-purple-200">
                                  Call
                                </span>
                              ) : null}
                            </div>
                          )}
                        </div>
                      </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            )
          ) : activeTab === 'documents' ? (
            <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
              <AccountDocumentsTab
                accountId={clientId}
                account={account}
                onAccountChange={(patch) => setAccount((prev) => ({ ...prev, ...patch }))}
                storageFolder="client-documents"
                filePrefix="client"
              />
            </div>
          ) : activeTab === 'access' ? (
            !canSeePrivilegedClientTabs ? (
              <Navigate to={`/crm/client/${clientId}`} replace />
            ) : (
            <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
              <h2 className="text-xl font-semibold mb-6 text-gray-900 dark:text-white text-center">Access Management</h2>

              <div className="mb-8 rounded-xl border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-900/50 p-5 text-left">
                <div className="flex items-start gap-3 mb-3">
                  <CreditCard className="w-6 h-6 text-slate-600 dark:text-slate-300 shrink-0 mt-0.5" aria-hidden />
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Stripe ↔ CRM billing link</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      If this client paid in Stripe but the Billing tab is empty or wrong, paste the Customer id and Subscription id from the Stripe Dashboard here, save, then sync. In Stripe, set customer metadata{' '}
                      <span className="font-mono text-xs">companyId</span> to this CRM client id so future webhooks hit the right record.
                    </p>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      Clients can have several subscriptions. The id here is the primary one; the sync also picks up every other live subscription on this customer, plus any subscription (on any customer) whose metadata{' '}
                      <span className="font-mono text-xs">companyId</span> is this client id, and adds them all into the monthly amount.
                    </p>
                  </div>
                </div>
                <div className="flex flex-wrap items-center gap-2 mb-4 text-xs font-mono text-gray-600 dark:text-gray-400">
                  <span className="font-sans font-medium text-gray-700 dark:text-gray-300">This client (CRM id)</span>
                  <code className="px-2 py-0.5 rounded bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 text-gray-800 dark:text-gray-200">
                    {clientId}
                  </code>
                  <button
                    type="button"
                    onClick={() => {
                      navigator.clipboard.writeText(clientId);
                    }}
                    className="px-2 py-1 rounded bg-slate-200 dark:bg-slate-700 text-slate-800 dark:text-slate-100 text-xs font-sans hover:bg-slate-300 dark:hover:bg-slate-600"
                  >
                    Copy
                  </button>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label htmlFor="access-stripe-customer-id" className="block text-xs font-medium text-gray-600 dark:text-gray-300 mb-1">
                      Stripe Customer ID
                    </label>
                    <input
                      id="access-stripe-customer-id"
                      type="text"
                      autoComplete="off"
                      spellCheck={false}
                      value={stripeBillingLinkDraft.customerId}
                      onChange={(e) =>
                        setStripeBillingLinkDraft((d) => ({ ...d, customerId: e.target.value.trimStart() }))
                      }
                      placeholder="cus_…"
                      className="w-full px-3 py-2 text-sm font-mono rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                    />
                  </div>
                  <div>
                    <label htmlFor="access-stripe-subscription-id" className="block text-xs font-medium text-gray-600 dark:text-gray-300 mb-1">
                      Stripe Subscription ID
                    </label>
                    <input
                      id="access-stripe-subscription-id"
                      type="text"
                      autoComplete="off"
                      spellCheck={false}
                      value={stripeBillingLinkDraft.subscriptionId}
                      onChange={(e) =>
                        setStripeBillingLinkDraft((d) => ({ ...d, subscriptionId: e.target.value.trimStart() }))
                      }
                      placeholder="sub_…"
                      className="w-full px-3 py-2 text-sm font-mono rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                    />
                  </div>
                </div>
                <div className="flex flex-wrap gap-2">
                  <button
                    type="button"
                    onClick={openStripeMatchModal}
                    disabled={stripeBillingLinkSaving || syncBillingLoading}
                    className="px-4 py-2 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center gap-2"
                  >
                    <Search className="w-4 h-4" aria-hidden />
                    Match to Stripe customer
                  </button>
                  <button
                    type="button"
                    onClick={() => saveStripeBillingLinkOverrides({ syncAfter: false })}
                    disabled={stripeBillingLinkSaving || syncBillingLoading}
                    className="px-4 py-2 text-sm font-medium rounded-lg bg-slate-700 text-white hover:bg-slate-800 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {stripeBillingLinkSaving ? 'Saving…' : 'Save Stripe ids'}
                  </button>
                  <button
                    type="button"
                    onClick={() => saveStripeBillingLinkOverrides({ syncAfter: true })}
                    disabled={stripeBillingLinkSaving || syncBillingLoading}
                    className="px-4 py-2 text-sm font-medium rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {syncBillingLoading ? 'Syncing…' : 'Save & sync billing'}
                  </button>
                  <button
                    type="button"
                    onClick={applyStripeIdsFromClipboard}
                    disabled={stripeBillingLinkSaving || syncBillingLoading}
                    className="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-600 text-gray-800 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 disabled:opacity-50"
                  >
                    Paste ids from clipboard
                  </button>
                </div>
                {stripeMatchSaved && (
                  <div className="mt-4 rounded-lg border border-green-300 dark:border-green-700 bg-green-50 dark:bg-green-900/30 p-3 flex items-start gap-2.5">
                    <CheckCircle className="w-5 h-5 text-green-600 dark:text-green-400 shrink-0 mt-0.5" aria-hidden />
                    <div className="min-w-0 text-sm">
                      <div className="font-medium text-green-800 dark:text-green-200">
                        Matched and saved: {stripeMatchSaved.name || stripeMatchSaved.email || 'Stripe customer'}
                        {stripeMatchSaved.name && stripeMatchSaved.email ? ` (${stripeMatchSaved.email})` : ''}
                      </div>
                      <div className="mt-1 flex flex-wrap items-center gap-1.5 text-xs font-mono text-green-700 dark:text-green-300">
                        <code className="px-1.5 py-0.5 rounded bg-white dark:bg-gray-800 border border-green-200 dark:border-green-800">{stripeMatchSaved.customerId}</code>
                        {stripeMatchSaved.subscriptionId && (
                          <code className="px-1.5 py-0.5 rounded bg-white dark:bg-gray-800 border border-green-200 dark:border-green-800">{stripeMatchSaved.subscriptionId}</code>
                        )}
                      </div>
                      <div className="mt-1 text-xs text-green-700 dark:text-green-300">
                        Linked to this CRM client. Click <span className="font-medium">Save &amp; sync billing</span> to pull invoices and the billing period from Stripe.
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => setStripeMatchSaved(null)}
                      className="ml-auto p-1 rounded text-green-700 dark:text-green-300 hover:text-green-900 dark:hover:text-green-100"
                      aria-label="Dismiss"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </div>
                )}
              </div>

              {/* Match to Stripe customer modal */}
              {showStripeMatchModal && (
                <div
                  className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 p-4 overflow-y-auto"
                  onClick={() => setShowStripeMatchModal(false)}
                >
                  <div
                    className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl w-full max-w-2xl my-12"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                      <div className="flex items-center gap-2">
                        <Search className="w-5 h-5 text-indigo-600 dark:text-indigo-400" aria-hidden />
                        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Match to a Stripe customer</h3>
                      </div>
                      <button
                        type="button"
                        onClick={() => setShowStripeMatchModal(false)}
                        className="p-1 rounded text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
                        aria-label="Close"
                      >
                        <X className="w-5 h-5" />
                      </button>
                    </div>

                    <div className="p-5">
                      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                        Search Stripe by the customer's name or email (they may have paid under a different
                        email). Pick the right record to link it to <span className="font-medium">{account.company || 'this client'}</span>.
                      </p>
                      <form
                        onSubmit={(e) => { e.preventDefault(); runStripeCustomerSearch(); }}
                        className="flex gap-2 mb-4"
                      >
                        <input
                          type="text"
                          autoFocus
                          value={stripeMatchQuery}
                          onChange={(e) => setStripeMatchQuery(e.target.value)}
                          placeholder="Name or email…"
                          className="flex-1 px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-white"
                        />
                        <button
                          type="submit"
                          disabled={stripeMatchLoading}
                          className="px-4 py-2 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50"
                        >
                          {stripeMatchLoading ? 'Searching…' : 'Search'}
                        </button>
                      </form>

                      {stripeMatchError && (
                        <div className="mb-3 text-sm text-red-600 dark:text-red-400">{stripeMatchError}</div>
                      )}

                      <div className="max-h-96 overflow-y-auto -mx-1 px-1 space-y-2">
                        {!stripeMatchLoading && stripeMatchSearched && stripeMatchResults.length === 0 && !stripeMatchError && (
                          <div className="text-sm text-gray-500 dark:text-gray-400 py-6 text-center">
                            No Stripe customers matched “{stripeMatchQuery.trim()}”. Try a different name or email.
                          </div>
                        )}
                        {stripeMatchResults.map((c) => {
                          const alreadyLinkedElsewhere = c.linkedCompanyId && c.linkedCompanyId !== clientId;
                          const isThisClient = c.linkedCompanyId === clientId;
                          return (
                            <div
                              key={c.id}
                              className="rounded-lg border border-gray-200 dark:border-gray-700 p-3 hover:border-indigo-400 dark:hover:border-indigo-500"
                            >
                              <div className="flex items-start justify-between gap-3">
                                <div className="min-w-0">
                                  <div className="font-medium text-gray-900 dark:text-white truncate">
                                    {c.name || '(no name)'}
                                  </div>
                                  <div className="text-sm text-gray-600 dark:text-gray-400 truncate">{c.email || '(no email)'}</div>
                                  <div className="mt-1 flex flex-wrap items-center gap-1.5 text-xs">
                                    <code className="px-1.5 py-0.5 rounded bg-gray-100 dark:bg-gray-900 text-gray-700 dark:text-gray-300">{c.id}</code>
                                    {isThisClient && (
                                      <span className="px-1.5 py-0.5 rounded bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300">Already this client</span>
                                    )}
                                    {alreadyLinkedElsewhere && (
                                      <span className="px-1.5 py-0.5 rounded bg-amber-100 dark:bg-amber-900 text-amber-700 dark:text-amber-300">Linked to another CRM id</span>
                                    )}
                                    {c.delinquent && (
                                      <span className="px-1.5 py-0.5 rounded bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300">Delinquent</span>
                                    )}
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  onClick={() => selectStripeCustomerMatch(c)}
                                  className="shrink-0 px-3 py-1.5 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700"
                                >
                                  Use this
                                </button>
                              </div>
                              {Array.isArray(c.subscriptions) && c.subscriptions.length > 0 && (
                                <div className="mt-2 pt-2 border-t border-gray-100 dark:border-gray-700 space-y-1">
                                  {c.subscriptions.map((s) => (
                                    <div key={s.id} className="flex items-center justify-between gap-2 text-xs">
                                      <span className="text-gray-600 dark:text-gray-400 truncate">
                                        <code className="text-gray-500 dark:text-gray-500">{s.id}</code>
                                        {' · '}
                                        <span className={s.status === 'active' || s.status === 'trialing' ? 'text-green-600 dark:text-green-400' : 'text-gray-500'}>{s.status}</span>
                                        {typeof s.amount === 'number' && (
                                          <span> · ${s.amount.toFixed(2)}{s.interval ? `/${s.interval}` : ''}</span>
                                        )}
                                      </span>
                                      <button
                                        type="button"
                                        onClick={() => selectStripeCustomerMatch(c, s.id)}
                                        className="shrink-0 text-indigo-600 dark:text-indigo-400 hover:underline"
                                      >
                                        Use this sub
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>

                      <p className="mt-4 text-xs text-gray-500 dark:text-gray-400">
                        Selecting a customer saves the link to this client right away. Afterwards, click
                        <span className="font-medium"> Save &amp; sync billing</span> to pull invoices and the billing period from Stripe.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Status Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                {/* Portal Status Card */}
                <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 dark:from-indigo-900 dark:to-indigo-800 rounded-xl p-6 border-2 border-indigo-200 dark:border-indigo-700">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-xl bg-indigo-500 flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                      </svg>
                    </div>
                    <h3 className="text-lg font-bold text-indigo-900 dark:text-indigo-100 mb-2">Portal Status</h3>
                    <span className={`px-4 py-2 text-sm font-medium rounded-full ${
                      account.program?.portalAccess || account.substatus === 'Portal Signup Completed' || hasPortalAccount
                        ? 'bg-green-200 dark:bg-green-700 text-green-800 dark:text-green-200'
                        : 'bg-yellow-200 dark:bg-yellow-700 text-yellow-800 dark:text-yellow-200'
                    }`}>
                      {account.program?.portalAccess || account.substatus === 'Portal Signup Completed' || hasPortalAccount
                        ? 'Active'
                        : 'Pending'
                      }
                    </span>
                  </div>
                </div>

                {/* Signup Date Card */}
                <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 dark:from-emerald-900 dark:to-emerald-800 rounded-xl p-6 border-2 border-emerald-200 dark:border-emerald-700">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-xl bg-emerald-500 flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <h3 className="text-lg font-bold text-emerald-900 dark:text-emerald-100 mb-2">Portal Signup</h3>
                    <p className="text-emerald-700 dark:text-emerald-300 text-sm">
                      {account.portalSignupDate ? new Date(account.portalSignupDate).toLocaleDateString() : 
                       account.substatus === 'Portal Signup Completed' ? 'Completed' : 'Not Signed Up'}
                    </p>
                  </div>
                </div>

                {/* Lock Status Card */}
                <div 
                  className="bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-900 dark:to-purple-800 rounded-xl p-6 border-2 border-purple-200 dark:border-purple-700 cursor-pointer hover:shadow-lg transition-shadow duration-200"
                  onClick={() => setShowLockModal(true)}
                >
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-xl bg-purple-500 flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                      </svg>
                    </div>
                    <h3 className="text-lg font-bold text-purple-900 dark:text-purple-100 mb-2">Lock Status</h3>
                    <span className={`px-4 py-2 text-sm font-medium rounded-full ${
                      account.lockStatus === 'locked'
                        ? 'bg-red-200 dark:bg-red-700 text-red-800 dark:text-red-200'
                        : 'bg-green-200 dark:bg-green-700 text-green-800 dark:text-green-200'
                    }`}>
                      {account.lockStatus === 'locked' ? 'Locked' : 'Unlocked'}
                    </span>
                  </div>
                </div>

                {/* Community Card */}
                <div className="bg-gradient-to-br from-teal-50 to-teal-100 dark:from-teal-900 dark:to-teal-800 rounded-xl p-6 border-2 border-teal-200 dark:border-teal-700">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-xl bg-teal-500 flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                    </div>
                    <h3 className="text-lg font-bold text-teal-900 dark:text-teal-100 mb-2">Community</h3>
                    <button
                      onClick={handleCommunityToggle}
                      className={`px-4 py-2 text-sm font-medium rounded-full transition-colors duration-200 ${
                        communityStatus === 'Active'
                          ? 'bg-green-200 dark:bg-green-700 text-green-800 dark:text-green-200 hover:bg-green-300 dark:hover:bg-green-600'
                          : 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600'
                      }`}
                    >
                      {communityStatus}
                    </button>
                  </div>
                </div>

                {/* JobTread Integration Card */}
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900 dark:to-blue-800 rounded-xl p-6 border-2 border-blue-200 dark:border-blue-700">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-xl bg-blue-500 flex items-center justify-center mx-auto mb-4 overflow-hidden">
                      <img src="/jtreadlogo.png" alt="JobTread" className="w-10 h-10 object-contain" />
                    </div>
                    <h3 className="text-lg font-bold text-blue-900 dark:text-blue-100 mb-2">JobTread</h3>
                    <p className="text-xs text-blue-700 dark:text-blue-300 mb-3">Connected from My Profile</p>
                    {clientIntegrationsLoading ? (
                      <div className="flex justify-center">
                        <svg className="animate-spin h-5 w-5 text-blue-600 dark:text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                      </div>
                    ) : (
                      <span className={`px-4 py-2 text-sm font-medium rounded-full inline-block ${
                        clientIntegrations.jobtread
                          ? 'bg-green-200 dark:bg-green-700 text-green-800 dark:text-green-200'
                          : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300'
                      }`}>
                        {clientIntegrations.jobtread ? 'Connected' : 'Not connected'}
                      </span>
                    )}
                  </div>
                </div>

                {/* QuickBooks Integration Card */}
                <div className="bg-gradient-to-br from-amber-50 to-amber-100 dark:from-amber-900 dark:to-amber-800 rounded-xl p-6 border-2 border-amber-200 dark:border-amber-700">
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-xl bg-amber-500 flex items-center justify-center mx-auto mb-4 overflow-hidden">
                      <img src="/qbo.png" alt="QuickBooks" className="w-10 h-10 object-contain" />
                    </div>
                    <h3 className="text-lg font-bold text-amber-900 dark:text-amber-100 mb-2">QuickBooks</h3>
                    <p className="text-xs text-amber-700 dark:text-amber-300 mb-3">Connected from My Profile</p>
                    {clientIntegrationsLoading ? (
                      <div className="flex justify-center">
                        <svg className="animate-spin h-5 w-5 text-amber-600 dark:text-amber-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                        </svg>
                      </div>
                    ) : (
                      <span className={`px-4 py-2 text-sm font-medium rounded-full inline-block ${
                        clientIntegrations.quickbooks
                          ? 'bg-green-200 dark:bg-green-700 text-green-800 dark:text-green-200'
                          : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300'
                      }`}>
                        {clientIntegrations.quickbooks ? 'Connected' : 'Not connected'}
                      </span>
                    )}
                  </div>
                </div>

                {/* Stripe Billing Card */}
                <div
                  className="bg-gradient-to-br from-violet-50 to-violet-100 dark:from-violet-900 dark:to-violet-800 rounded-xl p-6 border-2 border-violet-200 dark:border-violet-700 cursor-pointer hover:shadow-lg transition-shadow duration-200"
                  onClick={() => (account.stripeCustomerId ? setActiveTab('billing') : openStripeMatchModal())}
                  title={account.stripeCustomerId ? 'Open the Billing tab' : 'Match this client to a Stripe customer'}
                >
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-xl bg-[#635bff] flex items-center justify-center mx-auto mb-4 overflow-hidden">
                      <img src="/stripe-logo.svg" alt="Stripe" className="w-16 h-16 object-contain" />
                    </div>
                    <h3 className="text-lg font-bold text-violet-900 dark:text-violet-100 mb-2">Stripe</h3>
                    <span className={`px-4 py-2 text-sm font-medium rounded-full inline-block ${
                      account.stripeCustomerId
                        ? 'bg-green-200 dark:bg-green-700 text-green-800 dark:text-green-200'
                        : 'bg-red-200 dark:bg-red-700 text-red-800 dark:text-red-200'
                    }`}>
                      {account.stripeCustomerId ? 'Synced' : 'Not synced'}
                    </span>
                    {account.stripeCustomerId && (
                      <p className="mt-3 text-xs font-mono text-violet-700 dark:text-violet-300 truncate">
                        {account.stripeCustomerId}
                      </p>
                    )}
                  </div>
                </div>

                {/* Lead History Card — the lead-era record, on its own page */}
                <Link
                  to={`/crm/client/${clientId}/lead-history`}
                  className="block bg-gradient-to-br from-rose-50 to-rose-100 dark:from-rose-900 dark:to-rose-800 rounded-xl p-6 border-2 border-rose-200 dark:border-rose-700 hover:shadow-lg hover:border-rose-400 dark:hover:border-rose-500 transition-all"
                >
                  <div className="text-center">
                    <div className="w-16 h-16 rounded-xl bg-rose-500 flex items-center justify-center mx-auto mb-4">
                      <History className="w-8 h-8 text-white" aria-hidden />
                    </div>
                    <h3 className="text-lg font-bold text-rose-900 dark:text-rose-100 mb-2">Lead History</h3>
                    <span className={`px-4 py-2 text-sm font-medium rounded-full inline-block ${
                      hasLeadHistory(account)
                        ? 'bg-green-200 dark:bg-green-700 text-green-800 dark:text-green-200'
                        : 'bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200'
                    }`}>
                      {hasLeadHistory(account) ? 'View record' : 'No lead data'}
                    </span>
                    {account.convertedToClientAt || account.leadSnapshot?.convertedAt ? (
                      <p className="mt-3 text-xs text-rose-700 dark:text-rose-300">
                        Converted {new Date(account.convertedToClientAt || account.leadSnapshot.convertedAt).toLocaleDateString()}
                      </p>
                    ) : null}
                  </div>
                </Link>
              </div>

              {/* Portal Invite Section - Show only if client hasn't signed up for portal */}
              {!(account.program?.portalAccess || account.substatus === 'Portal Signup Completed' || hasPortalAccount) && (
                <div className="mb-8">
                  <div className="bg-gradient-to-br from-orange-50 to-orange-100 dark:from-orange-900 dark:to-orange-800 rounded-xl p-6 border-2 border-orange-200 dark:border-orange-700">
                    <div className="text-center">
                      <div className="w-16 h-16 rounded-xl bg-orange-500 flex items-center justify-center mx-auto mb-4">
                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                        </svg>
                      </div>
                      <h3 className="text-lg font-bold text-orange-900 dark:text-orange-100 mb-2">Portal Access Required</h3>
                      <p className="text-orange-700 dark:text-orange-300 text-sm mb-4">
                        This client hasn't signed up for the portal yet. Generate an invite link to send them.
                      </p>
                      <button
                        onClick={handleInviteToPortal}
                        disabled={isInvitingToPortal}
                        className={`px-6 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center space-x-2 mx-auto ${
                          isInvitingToPortal
                            ? 'bg-gray-400 text-gray-200 cursor-not-allowed'
                            : 'bg-orange-600 hover:bg-orange-700 text-white'
                        }`}
                      >
                        {isInvitingToPortal ? (
                          <>
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            <span>Generating Invite...</span>
                          </>
                        ) : (
                          <>
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                            </svg>
                            <span>Generate Portal Invite Link</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              )}

                {/* Portal Page Access toggles - only show when client has portal access */}
                {(account.program?.portalAccess || account.substatus === 'Portal Signup Completed' || hasPortalAccount) && (
                  <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-600">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 text-center">Portal Page Access</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 text-center mb-4">
                      Control which portal pages this client can see. Toggle each page on or off.
                    </p>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
                      {PORTAL_PAGE_TOGGLE_KEYS.map((accessKey) => {
                        const route = Object.entries(PORTAL_PAGE_MAPPING).find(([, key]) => key === accessKey)?.[0] || accessKey;
                        const label = accessKey.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
                        const enabled = (account.portalAccess || {})[accessKey] === true;
                        return (
                          <div
                            key={accessKey}
                            className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/50 rounded-lg border border-gray-200 dark:border-gray-600"
                          >
                            <span className="text-sm font-medium text-gray-900 dark:text-white truncate" title={route}>
                              {label}
                            </span>
                            <button
                              type="button"
                              role="switch"
                              aria-checked={enabled}
                              onClick={() => handlePortalPageAccessToggle(accessKey)}
                              className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 ${
                                enabled ? 'bg-indigo-600' : 'bg-gray-200 dark:bg-gray-600'
                              }`}
                            >
                              <span
                                className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
                                  enabled ? 'translate-x-5' : 'translate-x-1'
                                }`}
                                aria-hidden="true"
                              />
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Team Members - only show when client has portal access */}
                {(account.program?.portalAccess || account.substatus === 'Portal Signup Completed' || hasPortalAccount) && (
                  <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-600">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 text-center">Team Members</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 text-center mb-4">
                      Add team members who need their own portal account with access to the same company data (e.g., co-owners, key employees).
                    </p>
                    <div className="space-y-3">
                      {additionalTeamMembersForAccess.map((member) => {
                        const displayUrl = teamMemberDisplayPhotoUrl(member);
                        const initial = (member.name || member.email || '?').charAt(0).toUpperCase();
                        const hasCrmPhoto = !!account?.crmTeamMemberPhotos?.[member.id];
                        return (
                          <div
                            key={member.id}
                            className="flex items-center justify-between p-3 bg-white dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600"
                          >
                            <div className="flex items-center gap-3 min-w-0">
                              <div className="group relative h-10 w-10 shrink-0">
                                <div
                                  className={`relative h-full w-full rounded-full bg-indigo-100 dark:bg-indigo-900 flex items-center justify-center overflow-hidden ring-1 ring-gray-200 dark:ring-gray-600 transition-all ${
                                    isEditMode && photoDropHighlightKey === `access:${member.id}`
                                      ? 'ring-4 ring-blue-500 ring-offset-2 scale-105'
                                      : ''
                                  } ${isEditMode ? 'cursor-pointer' : ''}`}
                                  onDragOver={isEditMode ? handleAccessTeamPhotoDragOver(member.id) : undefined}
                                  onDragLeave={isEditMode ? handleAccessTeamPhotoDragLeave(member.id) : undefined}
                                  onDrop={isEditMode ? handleAccessTeamPhotoDrop(member.id) : undefined}
                                >
                                  {uploadingTeamMemberPhotoId === member.id ? (
                                    <div className="flex flex-col items-center justify-center w-full h-full bg-white/80 dark:bg-gray-800/80">
                                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-indigo-600" />
                                    </div>
                                  ) : isEditMode && photoDropHighlightKey === `access:${member.id}` ? (
                                    <div className="flex flex-col items-center justify-center p-0.5">
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                      </svg>
                                      <span className="text-[8px] text-blue-600 font-medium leading-none mt-0.5">Drop</span>
                                    </div>
                                  ) : displayUrl ? (
                                    <img
                                      src={displayUrl}
                                      alt=""
                                      className="w-full h-full object-cover"
                                      onError={(e) => {
                                        e.target.style.display = 'none';
                                        const el = e.target.nextSibling;
                                        if (el) el.style.display = 'flex';
                                      }}
                                    />
                                  ) : null}
                                  <span
                                    className={`text-sm font-medium text-indigo-600 dark:text-indigo-400 items-center justify-center w-full h-full absolute inset-0 ${
                                      displayUrl || (isEditMode && photoDropHighlightKey === `access:${member.id}`) || uploadingTeamMemberPhotoId === member.id
                                        ? 'hidden'
                                        : 'flex'
                                    }`}
                                  >
                                    {initial}
                                  </span>
                                </div>
                                {isEditMode && (
                                  <div className="pointer-events-none absolute inset-0 flex items-center justify-center rounded-full bg-black/50 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity">
                                    <div className="pointer-events-auto flex gap-0.5">
                                      <label className="cursor-pointer rounded-full bg-white p-1 shadow dark:bg-gray-700 dark:hover:bg-gray-600">
                                        <input
                                          type="file"
                                          accept="image/*"
                                          className="hidden"
                                          onChange={(ev) => handleTeamMemberPhotoUpload(member.id, ev)}
                                          disabled={uploadingTeamMemberPhotoId === member.id}
                                        />
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-gray-600 dark:text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                                        </svg>
                                      </label>
                                      {hasCrmPhoto && (
                                        <button
                                          type="button"
                                          onClick={() => handleRemoveTeamMemberCrmPhoto(member.id)}
                                          disabled={uploadingTeamMemberPhotoId === member.id}
                                          className="rounded-full bg-white p-1 shadow dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50"
                                          title="Remove CRM-only photo (portal profile unchanged)"
                                          aria-label="Remove CRM-only team member photo"
                                        >
                                          <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 text-red-600" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                          </svg>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="min-w-0">
                                <p className="font-medium text-gray-900 dark:text-white truncate">{member.name}</p>
                                <p className="text-sm text-gray-500 dark:text-gray-400 truncate">{member.email}</p>
                              </div>
                            </div>
                            {member.isPendingInvite ? (
                              <div className="shrink-0 flex items-center gap-2">
                                <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-100 dark:bg-amber-900/40 px-2.5 py-1 text-xs font-medium text-amber-700 dark:text-amber-300">
                                  <span className="h-1.5 w-1.5 rounded-full bg-amber-500" aria-hidden="true" />
                                  Pending
                                </span>
                                <button
                                  type="button"
                                  onClick={() => handleCopyMemberInviteLink(member)}
                                  className="rounded-full p-1.5 text-gray-400 hover:bg-indigo-50 hover:text-indigo-600 dark:hover:bg-indigo-900/30 dark:hover:text-indigo-400 transition-colors"
                                  title="Copy invitation link"
                                  aria-label={`Copy invitation link for ${member.name || member.email}`}
                                >
                                  {copiedInviteMemberId === member.id ? (
                                    <CheckCircle className="h-4 w-4 text-green-600 dark:text-green-400" />
                                  ) : (
                                    <Copy className="h-4 w-4" />
                                  )}
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDeletePendingInvite(member)}
                                  disabled={deletingInviteId === member.id}
                                  className="rounded-full p-1.5 text-gray-400 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/30 dark:hover:text-red-400 disabled:opacity-50 transition-colors"
                                  title="Delete pending invitation"
                                  aria-label={`Delete pending invitation for ${member.name || member.email}`}
                                >
                                  {deletingInviteId === member.id ? (
                                    <BBALoader size={16} className="block" />
                                  ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                      <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                    </svg>
                                  )}
                                </button>
                              </div>
                            ) : (
                              <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-green-100 dark:bg-green-900/40 px-2.5 py-1 text-xs font-medium text-green-700 dark:text-green-300">
                                <span className="h-1.5 w-1.5 rounded-full bg-green-500" aria-hidden="true" />
                                Active
                              </span>
                            )}
                          </div>
                        );
                      })}
                      <button
                        onClick={handleAddTeamMember}
                        className="w-full flex items-center justify-center gap-2 py-3 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg text-gray-600 dark:text-gray-400 hover:border-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                      >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                        </svg>
                        Add Team Member
                      </button>
                    </div>
                  </div>
                )}

                {/* Team Engagement — per-member email, meeting and portal stats from our integrations */}
                {!teamMembersLoading && (
                  <MemberEngagementPanel
                    account={account}
                    members={teamMembers}
                    internalUsers={internalUsers}
                    portalActivityRows={portalActivityRows}
                  />
                )}

                {/* Portal Activity — logins and page views for the client and their team members */}
                {(account.program?.portalAccess || account.substatus === 'Portal Signup Completed' || hasPortalAccount) && (
                  <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-600">
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2 text-center">Portal Activity</h3>
                    <p className="text-sm text-gray-600 dark:text-gray-400 text-center mb-4">
                      Logins and page views across the client and their team members, newest first. Locations are approximate, from IP address.
                    </p>
                    {portalActivityLoading ? (
                      <div className="flex justify-center py-6">
                        <BBALoader size={24} />
                      </div>
                    ) : portalActivityRows.length === 0 ? (
                      <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-4">
                        No portal activity recorded yet.
                      </p>
                    ) : (
                      <>
                        <div className="divide-y divide-gray-100 dark:divide-gray-600 rounded-lg border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 overflow-hidden">
                          {portalActivityRows.slice(0, portalActivityVisibleCount).map((row) => (
                            <div key={row.id} className="flex items-center gap-3 px-4 py-2.5">
                              <span
                                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${
                                  row.type === 'login'
                                    ? 'bg-green-100 text-green-600 dark:bg-green-900/40 dark:text-green-400'
                                    : 'bg-indigo-100 text-indigo-600 dark:bg-indigo-900/40 dark:text-indigo-400'
                                }`}
                              >
                                {row.type === 'login' ? <LogIn className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
                              </span>
                              <div className="min-w-0 flex-1">
                                <p className="text-sm text-gray-900 dark:text-white truncate">
                                  <span className="font-medium">{row.memberName}</span>
                                  <span className="text-gray-600 dark:text-gray-300"> — {row.label}</span>
                                </p>
                              </div>
                              {formatIpLocation(row.location) ? (
                                <span
                                  className="flex w-56 shrink-0 items-center gap-1 text-xs text-gray-600 dark:text-gray-300"
                                  title={[row.location.ip && `IP ${row.location.ip}`, row.location.org].filter(Boolean).join(' · ')}
                                >
                                  <MapPin className="h-3 w-3 shrink-0 text-gray-400" />
                                  <span className="truncate">{formatIpLocation(row.location)}</span>
                                </span>
                              ) : (
                                <span className="flex w-56 shrink-0 items-center gap-1 text-xs text-gray-400 dark:text-gray-500">
                                  <MapPin className="h-3 w-3 shrink-0" />
                                  Not recorded
                                </span>
                              )}
                              <span className="shrink-0 text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap" title={row.at.toLocaleString()}>
                                {row.at.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })}
                                {' · '}
                                {row.at.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}
                              </span>
                            </div>
                          ))}
                        </div>
                        {portalActivityRows.length > portalActivityVisibleCount && (
                          <button
                            type="button"
                            onClick={() => setPortalActivityVisibleCount((c) => c + 25)}
                            className="mt-3 w-full text-center text-sm font-medium text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300 transition-colors"
                          >
                            Show more ({portalActivityRows.length - portalActivityVisibleCount} more)
                          </button>
                        )}
                      </>
                    )}
                  </div>
                )}
              </div>
            )
          ) : null}
        </div>

        {/* Right sidebar */}
        <div className="w-96 space-y-6">
          {/* Contact Information — person fields; pin / switch when multiple team contacts */}
          <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6 relative">
            <div className="grid grid-cols-[minmax(2.25rem,auto)_1fr_minmax(2.25rem,auto)] gap-2 items-center mb-2">
              <div className="flex justify-start">
                {orderedSidebarContacts.length > 1 ? (
                  <button
                    type="button"
                    onClick={cycleSidebarLeadContact}
                    className="p-2 rounded-lg text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                    aria-label="Switch contact"
                    title="Switch contact"
                  >
                    <ArrowLeftRight className="w-5 h-5" />
                  </button>
                ) : (
                  <span className="w-9" aria-hidden="true" />
                )}
              </div>
              <h2 className="text-xl font-semibold text-center text-gray-900 dark:text-white">Contact Information</h2>
              <div className="flex justify-end">
                {orderedSidebarContacts.length > 1 ? (
                  <button
                    type="button"
                    onClick={togglePinnedSidebarContact}
                    className={`p-2 rounded-lg transition-colors ${
                      pinnedSidebarContactKey === leadSidebarContact?.key
                        ? 'text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/40'
                        : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    aria-label={
                      pinnedSidebarContactKey === leadSidebarContact?.key
                        ? 'Unpin main contact'
                        : 'Pin as main contact'
                    }
                    title={
                      pinnedSidebarContactKey === leadSidebarContact?.key
                        ? 'Main contact (click to unpin)'
                        : 'Pin as main contact'
                    }
                  >
                    <Pin className={`w-5 h-5 ${pinnedSidebarContactKey === leadSidebarContact?.key ? 'fill-current' : ''}`} />
                  </button>
                ) : (
                  <span className="w-9" aria-hidden="true" />
                )}
              </div>
            </div>
            <div className="space-y-4">
              <div className="flex justify-center mb-6">
                <div
                  className={`relative group ${canEditSidebarContactPhoto ? 'cursor-pointer' : ''}`}
                  onDragOver={handleSidebarPhotoDragOver}
                  onDragLeave={handleSidebarPhotoDragLeave}
                  onDrop={handleSidebarPhotoDrop}
                >
                  <div
                    className={`w-32 h-32 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center overflow-hidden ring-2 ring-offset-2 ring-offset-white dark:ring-offset-gray-800 transition-all ${
                      photoDropHighlightKey && sidebarPhotoDropZoneKey && photoDropHighlightKey === sidebarPhotoDropZoneKey
                        ? 'ring-blue-500 scale-105 ring-4'
                        : 'ring-indigo-100 dark:ring-indigo-900'
                    }`}
                  >
                    {(uploadingImage && isAccountPrimaryLead) ||
                    (uploadingTeamMemberPhotoId &&
                      leadSidebarContact?.source === 'portal' &&
                      uploadingTeamMemberPhotoId === leadSidebarContact.key) ? (
                      <div className="flex flex-col items-center justify-center">
                        <BBALoader size={32} />
                        <span className="text-xs text-gray-500 mt-2">Uploading...</span>
                      </div>
                    ) : photoDropHighlightKey &&
                      sidebarPhotoDropZoneKey &&
                      photoDropHighlightKey === sidebarPhotoDropZoneKey ? (
                      <div className="flex flex-col items-center justify-center px-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                        </svg>
                        <span className="text-xs text-blue-500 mt-2 font-medium text-center">Drop image here</span>
                      </div>
                    ) : leadSidebarContact?.photoURL ? (
                      <img
                        src={leadSidebarContact.photoURL}
                        alt={`${leadSidebarContact.firstName || ''} ${leadSidebarContact.lastName || ''}`.trim() || 'Contact'}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <span className="text-4xl text-gray-400 dark:text-gray-500">
                        {leadSidebarContact?.firstName?.[0]}
                        {leadSidebarContact?.lastName?.[0]}
                      </span>
                    )}
                  </div>
                  {canEditSidebarContactPhoto && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-full opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity pointer-events-none">
                      <div className="flex space-x-2 pointer-events-auto">
                        <label className="cursor-pointer bg-white dark:bg-gray-700 rounded-full p-2 hover:bg-gray-50 dark:hover:bg-gray-600">
                          <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={
                              isAccountPrimaryLead
                                ? handleImageUpload
                                : (ev) => handleTeamMemberPhotoUpload(leadSidebarContact.key, ev)
                            }
                            disabled={
                              (isAccountPrimaryLead && uploadingImage) ||
                              (!isAccountPrimaryLead &&
                                uploadingTeamMemberPhotoId === leadSidebarContact?.key)
                            }
                          />
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600 dark:text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                          </svg>
                        </label>
                        {isAccountPrimaryLead && account.contact?.crmPhotoURL ? (
                          <button
                            type="button"
                            onClick={async () => {
                              try {
                                setUploadingImage(true);

                                const oldImageRef = ref(storage, account.contact.crmPhotoURL);
                                await deleteObject(oldImageRef);

                                const updatedAccount = {
                                  ...account,
                                  contact: {
                                    ...account.contact,
                                    crmPhotoURL: ''
                                  }
                                };

                                await updateAccount(clientId, updatedAccount);
                                setAccount(updatedAccount);
                              } catch (error) {
                                console.error('Error deleting CRM contact photo:', error);
                                alert('Failed to delete image. Please try again.');
                              } finally {
                                setUploadingImage(false);
                              }
                            }}
                            disabled={uploadingImage}
                            className="bg-white dark:bg-gray-700 rounded-full p-2 hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50"
                            title="Remove CRM-only photo (portal profile photo is unchanged)"
                            aria-label="Remove CRM-only contact photo"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-600" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                          </button>
                        ) : null}
                        {!isAccountPrimaryLead && leadSidebarContact?.source === 'portal' && account?.crmTeamMemberPhotos?.[leadSidebarContact.key] ? (
                          <button
                            type="button"
                            onClick={() => handleRemoveTeamMemberCrmPhoto(leadSidebarContact.key)}
                            disabled={!!uploadingTeamMemberPhotoId}
                            className="bg-white dark:bg-gray-700 rounded-full p-2 hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50"
                            title="Remove CRM-only photo (portal profile unchanged)"
                            aria-label="Remove CRM-only team member photo"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-600" viewBox="0 0 20 20" fill="currentColor">
                              <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                            </svg>
                          </button>
                        ) : null}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* Contact Details */}
              <div className="space-y-3">
                <div className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl">
                  <User className="w-5 h-5 text-gray-400 mt-1" />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-500 dark:text-gray-400">Name</div>
                    {isEditMode && isAccountPrimaryLead ? (
                      <div className="flex items-center space-x-2 mt-1">
                        <input
                          type="text"
                          value={account.contact?.firstName || ''}
                          onChange={(e) => {
                            const updatedData = { ...account };
                            if (updatedData.contact) {
                              updatedData.contact.firstName = e.target.value;
                            }
                            setAccount(updatedData);
                          }}
                          className="flex-1 p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                          placeholder="First Name"
                        />
                        <input
                          type="text"
                          value={account.contact?.lastName || ''}
                          onChange={(e) => {
                            const updatedData = { ...account };
                            if (updatedData.contact) {
                              updatedData.contact.lastName = e.target.value;
                            }
                            setAccount(updatedData);
                          }}
                          className="flex-1 p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                          placeholder="Last Name"
                        />
                      </div>
                    ) : (
                      <div
                        className="text-sm text-gray-900 dark:text-white cursor-pointer hover:opacity-70 transition-opacity flex items-center justify-between gap-2"
                        onClick={() => {
                          const name = `${leadSidebarContact?.firstName || ''} ${leadSidebarContact?.lastName || ''}`.trim();
                          if (name && name !== 'Not set') {
                            copyToClipboard(name);
                          }
                        }}
                      >
                        <span className="flex-1">{`${leadSidebarContact?.firstName || ''} ${leadSidebarContact?.lastName || ''}`.trim() || 'Not set'}</span>
                        {`${leadSidebarContact?.firstName || ''} ${leadSidebarContact?.lastName || ''}`.trim() &&
                          `${leadSidebarContact?.firstName || ''} ${leadSidebarContact?.lastName || ''}`.trim() !== 'Not set' && (
                            <Copy className="w-4 h-4 text-red-500 flex-shrink-0" />
                          )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl">
                  <Mail className="w-5 h-5 text-gray-400 mt-1" />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-500 dark:text-gray-400">Email</div>
                    {isEditMode && isAccountPrimaryLead ? (
                      <div className="mt-1">
                        <input
                          type="email"
                          value={account.contact?.email || ''}
                          onChange={(e) => {
                            const updatedData = { ...account };
                            if (updatedData.contact) {
                              updatedData.contact.email = e.target.value;
                            }
                            setAccount(updatedData);
                          }}
                          className="w-full p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                          placeholder="Email Address"
                        />
                      </div>
                    ) : (
                      <div
                        className="text-sm text-gray-900 dark:text-white cursor-pointer hover:opacity-70 transition-opacity flex items-center justify-between gap-2"
                        onClick={() => {
                          const em = leadSidebarContact?.email || '';
                          if (em && em !== 'Not set') {
                            copyToClipboard(em);
                          }
                        }}
                      >
                        <span className="flex-1">{leadSidebarContact?.email || 'Not set'}</span>
                        {leadSidebarContact?.email && leadSidebarContact.email !== 'Not set' && (
                          <Copy className="w-4 h-4 text-red-500 flex-shrink-0" />
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {leadSidebarContact && (
                  <ContactEmailAliases
                    account={account}
                    accountId={clientId}
                    contactKey={leadSidebarContact.key}
                    contactName={`${leadSidebarContact.firstName || ''} ${leadSidebarContact.lastName || ''}`.trim()}
                    primaryEmail={leadSidebarContact.email}
                    liveContactKeys={sidebarContacts.map((c) => c.key)}
                    onSaved={(fields) => setAccount((prev) => (prev ? { ...prev, ...fields } : prev))}
                    onCopy={copyToClipboard}
                  />
                )}
                <div className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl">
                  <Phone className="w-5 h-5 text-gray-400 mt-1" />
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-500 dark:text-gray-400">Phone</div>
                    {isEditMode && isAccountPrimaryLead ? (
                      <div className="mt-1">
                        <input
                          type="tel"
                          value={account.contact?.phone || ''}
                          onChange={(e) => {
                            const updatedData = { ...account };
                            if (updatedData.contact) {
                              updatedData.contact.phone = e.target.value;
                            }
                            setAccount(updatedData);
                          }}
                          className="w-full p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                          placeholder="Phone Number"
                        />
                      </div>
                    ) : isEditMode && leadSidebarContact?.source === 'portal' ? (
                      <div className="mt-1">
                        <input
                          type="tel"
                          value={
                            account?.crmTeamMemberPhones?.[leadSidebarContact.key] !== undefined &&
                            account?.crmTeamMemberPhones?.[leadSidebarContact.key] !== null
                              ? account.crmTeamMemberPhones[leadSidebarContact.key]
                              : teamMembers.find((tm) => tm.id === leadSidebarContact.key)?.phone || ''
                          }
                          onChange={(e) => {
                            const uid = leadSidebarContact.key;
                            const v = e.target.value;
                            setAccount({
                              ...account,
                              crmTeamMemberPhones: {
                                ...(account.crmTeamMemberPhones || {}),
                                [uid]: v
                              }
                            });
                          }}
                          className="w-full p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                          placeholder="Phone Number"
                        />
                      </div>
                    ) : (
                      <div
                        className="text-sm text-gray-900 dark:text-white cursor-pointer hover:opacity-70 transition-opacity flex items-center justify-between gap-2"
                        onClick={() => {
                          const ph = leadSidebarContact?.phone || '';
                          if (ph && ph !== 'Not set') {
                            copyToClipboard(ph);
                          }
                        }}
                      >
                        <span className="flex-1">{leadSidebarContact?.phone || 'Not set'}</span>
                        {leadSidebarContact?.phone && leadSidebarContact.phone !== 'Not set' && (
                          <Copy className="w-4 h-4 text-red-500 flex-shrink-0" />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Company Information — account-level; does not change when switching contacts */}
          <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6">
            <div className="relative mb-4">
              <h2 className="text-xl font-semibold text-center text-gray-900 dark:text-white">Company Information</h2>
              {!isEditMode && (
                <button
                  type="button"
                  onClick={() => {
                    setOriginalEmail(account?.contact?.email || null);
                    setIsEditMode(true);
                  }}
                  className="absolute right-0 top-0 flex items-center justify-center w-9 h-9 rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
                  title="Edit"
                  aria-label="Edit"
                >
                  <Edit2 className="w-4 h-4" />
                </button>
              )}
            </div>
            <div className="flex justify-center mb-5">
              <div
                className="relative group w-full max-w-[240px]"
                {...(isEditMode && !uploadingCompanyLogo
                  ? {
                      onDragEnter: onCompanyLogoDragEnter,
                      onDragLeave: onCompanyLogoDragLeave,
                      onDragOver: onCompanyLogoDragOver,
                      onDrop: onCompanyLogoDrop,
                    }
                  : {})}
              >
                <div
                  className={`w-full h-28 rounded-lg bg-gray-100 dark:bg-gray-700 flex items-center justify-center overflow-hidden border border-gray-200 dark:border-gray-600 transition-[box-shadow,border-color] ${
                    companyLogoDragOver && isEditMode ? 'ring-2 ring-red-500 ring-inset border-red-400 dark:border-red-500' : ''
                  }`}
                >
                  {uploadingCompanyLogo ? (
                    <div className="flex flex-col items-center justify-center py-4">
                      <BBALoader size={32} />
                      <span className="text-xs text-gray-500 dark:text-gray-400 mt-2">Uploading…</span>
                    </div>
                  ) : getCrmCompanyLogoDisplayUrl(account) ? (
                    <img
                      src={getCrmCompanyLogoDisplayUrl(account)}
                      alt={`${account.company || 'Company'} logo`}
                      className="max-h-full max-w-full object-contain p-3"
                    />
                  ) : (
                    <Building2 className="w-12 h-12 text-gray-400 dark:text-gray-500" aria-hidden />
                  )}
                </div>
                {isEditMode && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                    <div className="flex space-x-2">
                      <label className="cursor-pointer bg-white dark:bg-gray-700 rounded-full p-2 hover:bg-gray-50 dark:hover:bg-gray-600 pointer-events-auto">
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={handleCompanyLogoUpload}
                          disabled={uploadingCompanyLogo}
                        />
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-600 dark:text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                        </svg>
                      </label>
                      {account.crmCompanyLogo && (
                        <button
                          type="button"
                          onClick={async () => {
                            try {
                              setUploadingCompanyLogo(true);
                              const oldImageRef = ref(storage, account.crmCompanyLogo);
                              await deleteObject(oldImageRef);
                              const updatedAccount = {
                                ...account,
                                crmCompanyLogo: ''
                              };
                              await updateAccount(clientId, updatedAccount);
                              setAccount(updatedAccount);
                            } catch (error) {
                              console.error('Error deleting CRM company logo:', error);
                              alert('Failed to delete logo. Please try again.');
                            } finally {
                              setUploadingCompanyLogo(false);
                            }
                          }}
                          disabled={uploadingCompanyLogo}
                          className="bg-white dark:bg-gray-700 rounded-full p-2 hover:bg-gray-50 dark:hover:bg-gray-600 disabled:opacity-50 pointer-events-auto"
                          title="Remove CRM-only logo (client portal logo is unchanged)"
                          aria-label="Remove CRM-only company logo"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-600" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl">
                <Building2 className="w-5 h-5 text-gray-400 mt-1" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-gray-500 dark:text-gray-400">Company</div>
                  {isEditMode ? (
                    <div className="mt-1">
                      <input
                        type="text"
                        value={account.company || ''}
                        onChange={(e) => {
                          const updatedData = { ...account };
                          updatedData.company = e.target.value;
                          setAccount(updatedData);
                        }}
                        className="w-full p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                        placeholder="Company Name"
                      />
                    </div>
                  ) : (
                    <div
                      className="text-sm text-gray-900 dark:text-white cursor-pointer hover:opacity-70 transition-opacity flex items-center justify-between gap-2"
                      onClick={() => {
                        if (account.company && account.company !== 'Not set') {
                          copyToClipboard(account.company);
                        }
                      }}
                    >
                      <span className="flex-1">{account.company || 'Not set'}</span>
                      {account.company && account.company !== 'Not set' && (
                        <Copy className="w-4 h-4 text-red-500 flex-shrink-0" />
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl">
                <MapPin className="w-5 h-5 text-gray-400 mt-1" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-gray-500 dark:text-gray-400">Address</div>
                  {isEditMode ? (
                    <div className="mt-1 space-y-2">
                      <input
                        type="text"
                        value={account.address || ''}
                        onChange={(e) => {
                          const updatedData = { ...account };
                          updatedData.address = e.target.value;
                          setAccount(updatedData);
                        }}
                        className="w-full p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                        placeholder="Street Address"
                      />
                      <div className="flex space-x-2">
                        <input
                          type="text"
                          value={account.city || ''}
                          onChange={(e) => {
                            const updatedData = { ...account };
                            updatedData.city = e.target.value;
                            setAccount(updatedData);
                          }}
                          className="flex-1 p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                          placeholder="City"
                        />
                        <input
                          type="text"
                          value={account.state || ''}
                          onChange={(e) => {
                            const updatedData = { ...account };
                            updatedData.state = e.target.value;
                            setAccount(updatedData);
                          }}
                          className="flex-1 p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                          placeholder="State"
                        />
                        <input
                          type="text"
                          value={account.zipCode || ''}
                          onChange={(e) => {
                            const updatedData = { ...account };
                            updatedData.zipCode = e.target.value;
                            setAccount(updatedData);
                          }}
                          className="flex-1 p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                          placeholder="ZIP"
                        />
                      </div>
                      <input
                        type="text"
                        value={account.country || ''}
                        onChange={(e) => {
                          const updatedData = { ...account };
                          updatedData.country = e.target.value;
                          setAccount(updatedData);
                        }}
                        className="w-full p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                        placeholder="Country"
                      />
                    </div>
                  ) : (
                    <div
                      className="text-sm text-gray-900 dark:text-white cursor-pointer hover:opacity-70 transition-opacity flex items-center justify-between gap-2"
                      onClick={() => {
                        const address = `${account.address || ''}, ${account.city || ''}, ${account.state || ''} ${account.zipCode || ''}, ${account.country || ''}`.replace(/,\s*,/g, ',').replace(/^,\s*|,\s*$/g, '');
                        if (address && address !== 'Not set') {
                          copyToClipboard(address);
                        }
                      }}
                    >
                      <span className="flex-1">{`${account.address || ''}, ${account.city || ''}, ${account.state || ''} ${account.zipCode || ''}, ${account.country || ''}`.replace(/,\s*,/g, ',').replace(/^,\s*|,\s*$/g, '') || 'Not set'}</span>
                      {(() => {
                        const address = `${account.address || ''}, ${account.city || ''}, ${account.state || ''} ${account.zipCode || ''}, ${account.country || ''}`.replace(/,\s*,/g, ',').replace(/^,\s*|,\s*$/g, '');
                        return address && address !== 'Not set' && (
                          <Copy className="w-4 h-4 text-red-500 flex-shrink-0" />
                        );
                      })()}
                    </div>
                  )}
                </div>
              </div>
              <div className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl">
                <Globe className="w-5 h-5 text-gray-400 mt-1" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-gray-500 dark:text-gray-400">Website</div>
                  {isEditMode ? (
                    <div className="mt-1">
                      <input
                        type="url"
                        value={account.website || ''}
                        onChange={(e) => {
                          const updatedData = { ...account };
                          updatedData.website = e.target.value;
                          setAccount(updatedData);
                        }}
                        onBlur={async () => {
                          try {
                            await updateAccount(clientId, { website: account.website });
                          } catch (error) {
                            console.error('Error saving website:', error);
                          }
                        }}
                        onKeyDown={async (e) => {
                          if (e.key === 'Enter') {
                            try {
                              await updateAccount(clientId, { website: account.website });
                              e.target.blur();
                            } catch (error) {
                              console.error('Error saving website:', error);
                            }
                          }
                        }}
                        className="w-full p-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white min-w-0"
                        placeholder="Website URL"
                      />
                    </div>
                  ) : (
                    <div className="text-sm text-gray-900 dark:text-white">
                      {account.website ? (
                        <a
                          href={account.website.startsWith('http') ? account.website : `https://${account.website}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline cursor-pointer flex items-center justify-between gap-2"
                          title="Click to open website in new tab"
                        >
                          <span className="flex-1">{account.website}</span>
                        </a>
                      ) : (
                        <span className="cursor-pointer hover:opacity-70 transition-opacity">Not set</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Success Manager */}
          <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 shadow-sm p-6 relative">
            <div className="flex items-center space-x-3 mb-4">
              <User className="w-5 h-5 text-blue-600 dark:text-blue-400" />
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Success Manager</h3>
            </div>
            {(() => {
              const selectedUser = account.successManagerId 
                ? internalUsers.find(u => u.id === account.successManagerId)
                : null;
              const displayName = selectedUser 
                ? selectedUser.name 
                : (account.successManager || null);

              if (isEditMode) {
                return (
                  <div className="mt-2">
                    <button
                      type="button"
                      onClick={() => setShowSuccessManagerPopup(true)}
                      className="w-full p-2 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-800 text-gray-900 dark:text-white cursor-pointer flex items-center justify-between hover:border-blue-500 dark:hover:border-blue-400 transition-colors text-left"
                    >
                      <div className="flex items-center space-x-2 flex-1 min-w-0">
                        {selectedUser ? (
                          <>
                            <div className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-sm font-medium text-gray-600 dark:text-gray-300 overflow-hidden flex-shrink-0 relative">
                              {selectedUser.profileImage ? (
                                <img 
                                  src={selectedUser.profileImage} 
                                  alt={selectedUser.name || 'User'} 
                                  className="w-full h-full object-cover absolute inset-0 z-10"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                              ) : null}
                              <span className="w-full h-full flex items-center justify-center">
                                {selectedUser.initials}
                              </span>
                            </div>
                            <span className="truncate">{selectedUser.name}</span>
                          </>
                        ) : (
                          <span className="text-gray-500 dark:text-gray-400">Select success manager...</span>
                        )}
                      </div>
                      <ChevronDown className="w-4 h-4 text-gray-500 dark:text-gray-400 flex-shrink-0" />
                    </button>
                    {showSuccessManagerPopup && typeof document !== 'undefined' && ReactDOM.createPortal(
                      <div 
                        className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 p-4"
                        onClick={(e) => { if (e.target === e.currentTarget) setShowSuccessManagerPopup(false); }}
                      >
                        <div 
                          className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl max-w-md w-full max-h-[80vh] flex flex-col"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Select Success Manager</h3>
                            <button
                              type="button"
                              onClick={() => setShowSuccessManagerPopup(false)}
                              className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-500 dark:text-gray-400"
                              aria-label="Close"
                            >
                              <X className="w-5 h-5" />
                            </button>
                          </div>
                          <div className="overflow-y-auto flex-1 p-2">
                            {internalUsers.length === 0 ? (
                              <div className="p-4 text-center text-sm text-gray-500 dark:text-gray-400">
                                No internal users found
                              </div>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  onClick={async () => {
                                    const updatedAccount = { 
                                      ...account, 
                                      successManagerId: null, 
                                      successManager: null,
                                      successManagerEmail: null,
                                      successManagerPhone: null,
                                      successManagerProfileImage: null
                                    };
                                    setAccount(updatedAccount);
                                    setShowSuccessManagerPopup(false);
                                    try {
                                      await updateAccount(clientId, { 
                                        successManagerId: null, 
                                        successManager: null,
                                        successManagerEmail: null,
                                        successManagerPhone: null,
                                        successManagerProfileImage: null
                                      });
                                    } catch (error) {
                                      console.error('Error updating success manager:', error);
                                    }
                                  }}
                                  className="w-full flex items-center p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer text-left"
                                >
                                  <span className="text-sm text-gray-500 dark:text-gray-400">Clear selection</span>
                                </button>
                                {internalUsers.map(user => (
                                  <button
                                    key={user.id}
                                    type="button"
                                    onClick={async () => {
                                      const updatedAccount = { 
                                        ...account, 
                                        successManagerId: user.id, 
                                        successManager: user.name,
                                        successManagerEmail: user.email || null,
                                        successManagerPhone: user.phone || null,
                                        successManagerProfileImage: user.profileImage || null
                                      };
                                      setAccount(updatedAccount);
                                      setShowSuccessManagerPopup(false);
                                      try {
                                        await updateAccount(clientId, { 
                                          successManagerId: user.id, 
                                          successManager: user.name,
                                          successManagerEmail: user.email || null,
                                          successManagerPhone: user.phone || null,
                                          successManagerProfileImage: user.profileImage || null
                                        });
                                      } catch (error) {
                                        console.error('Error updating success manager:', error);
                                      }
                                    }}
                                    className={`w-full flex items-center p-3 rounded-lg cursor-pointer text-left ${
                                      selectedUser?.id === user.id 
                                        ? 'bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/30' 
                                        : 'hover:bg-gray-50 dark:hover:bg-gray-700'
                                    }`}
                                  >
                                    <div className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-sm font-medium text-gray-600 dark:text-gray-300 mr-3 overflow-hidden flex-shrink-0 relative">
                                      {user.profileImage ? (
                                        <img 
                                          src={user.profileImage} 
                                          alt={user.name || 'User'} 
                                          className="w-full h-full object-cover absolute inset-0 z-10"
                                          onError={(e) => {
                                            e.target.style.display = 'none';
                                          }}
                                        />
                                      ) : null}
                                      <span className="w-full h-full flex items-center justify-center">
                                        {user.initials}
                                      </span>
                                    </div>
                                    <span className="text-gray-900 dark:text-white font-medium">{user.name}</span>
                                  </button>
                                ))}
                              </>
                            )}
                          </div>
                        </div>
                      </div>,
                      document.body
                    )}
                  </div>
                );
              } else {
                return (
                  <div className="text-gray-900 dark:text-white">
                    {selectedUser ? (
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-sm font-medium text-gray-600 dark:text-gray-300 overflow-hidden flex-shrink-0 relative">
                          {selectedUser.profileImage ? (
                            <img 
                              src={selectedUser.profileImage} 
                              alt={selectedUser.name || 'User'} 
                              className="w-full h-full object-cover absolute inset-0 z-10"
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : null}
                          <span className="w-full h-full flex items-center justify-center">
                            {selectedUser.initials}
                          </span>
                        </div>
                        <p className="text-base font-medium">{selectedUser.name}</p>
                      </div>
                    ) : displayName ? (
                      <p className="text-base font-medium">{displayName}</p>
                    ) : (
                      <p className="text-sm text-gray-500 dark:text-gray-400 italic">No success manager assigned</p>
                    )}
                  </div>
                );
              }
            })()}
          </div>


                  </div>
                      </div>

      {/* Meeting Summary Modal */}
      <MeetingSummaryModal
        open={showMeetingSummaryModal}
        event={selectedEventForSummary}
        summary={meetingSummary}
        loading={meetingSummaryLoading}
        onClose={() => {
          setShowMeetingSummaryModal(false);
          setSelectedEventForSummary(null);
          setMeetingSummary(null);
        }}
      />

      {/* ACH Modal */}
      {showACHModal && account.achInfo && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <div className="flex-1"></div>
              <h3 className="text-2xl font-semibold text-gray-900 dark:text-white text-center flex-1">
                ACH Bank Information
              </h3>
              <div className="flex-1 flex justify-end">
                <button
                  onClick={() => setShowSensitiveData(!showSensitiveData)}
                  className="mr-4 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                  title={showSensitiveData ? 'Hide sensitive data' : 'Show sensitive data'}
                >
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {showSensitiveData ? (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                    ) : (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    )}
                  </svg>
                </button>
                <button
                  onClick={() => {
                    setShowACHModal(false);
                    setShowSensitiveData(false);
                  }}
                  className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="space-y-4">
              {account.achInfo.accountType && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Account Type</label>
                  <div className="relative p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl text-gray-900 dark:text-white">
                    <span>{account.achInfo.accountType}</span>
                    <button
                      onClick={() => copyToClipboard(account.achInfo.accountType)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                      title="Copy to clipboard"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                  </div>
                </div>
              )}
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Bank Name</label>
                <div className="relative p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl text-gray-900 dark:text-white">
                  <span>{account.achInfo.bankName || 'Not provided'}</span>
                  {account.achInfo.bankName && (
                    <button
                      onClick={() => copyToClipboard(account.achInfo.bankName)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                      title="Copy to clipboard"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Routing Number</label>
                <div className="relative p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl text-gray-900 dark:text-white">
                  <span className="font-mono">{maskSensitiveData(account.achInfo.routingNumber, 4)}</span>
                  {account.achInfo.routingNumber && (
                    <button
                      onClick={() => copyToClipboard(account.achInfo.routingNumber)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                      title="Copy to clipboard"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Account Number</label>
                <div className="relative p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl text-gray-900 dark:text-white">
                  <span className="font-mono">{maskSensitiveData(account.achInfo.accountNumber, 4)}</span>
                  {account.achInfo.accountNumber && (
                    <button
                      onClick={() => copyToClipboard(account.achInfo.accountNumber)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                      title="Copy to clipboard"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Bank Address</label>
                <div className="relative p-3 bg-gray-50 dark:bg-gray-800/60 rounded-xl text-gray-900 dark:text-white">
                  <span>{account.achInfo.bankAddress || 'Not provided'}</span>
                  {account.achInfo.bankAddress && (
                    <button
                      onClick={() => copyToClipboard(account.achInfo.bankAddress)}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                      title="Copy to clipboard"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                    </button>
                  )}
                </div>
              </div>
            </div>
            
            <div className="mt-6 flex justify-end">
              <button
                onClick={() => {
                  setShowACHModal(false);
                  setShowSensitiveData(false);
                }}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Invite Link Modal */}
      {showInviteLinkModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-lg w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <div className="flex-1"></div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white text-center flex-1">
                Portal Invitation Generated
              </h3>
              <div className="flex-1 flex justify-end">
                <button
                  onClick={() => { setShowInviteLinkModal(false); setInviteModalRecipient(null); }}
                  className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="text-center">
                <div className="w-16 h-16 bg-purple-100 dark:bg-purple-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-purple-600 dark:text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  Invitation Link Generated
                </h4>
                <p className="text-gray-600 dark:text-gray-300 mb-4">
                  A secure invitation link has been generated for {inviteModalRecipient
                    ? `${inviteModalRecipient.firstName} ${inviteModalRecipient.lastName}`.trim() || inviteModalRecipient.email
                    : `${account.contact?.firstName} ${account.contact?.lastName}`.trim() || account.contact?.email} at {account.company}.
                </p>
                
                <div className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 mb-4">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Invitation Link:
                  </label>
                  <div className="flex">
                    <input
                      type="text"
                      value={generatedInviteLink}
                      readOnly
                      className="flex-1 p-2 border border-gray-300 dark:border-gray-600 rounded-l bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm"
                    />
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(generatedInviteLink);
                        alert('Link copied to clipboard!');
                      }}
                      className="px-3 py-2 bg-purple-600 text-white rounded-r hover:bg-purple-700 text-sm font-medium"
                    >
                      Copy
                    </button>
                  </div>
                </div>
                
                <div className="bg-blue-50 dark:bg-blue-900 border border-blue-200 dark:border-blue-700 rounded-lg p-4">
                  <div className="flex items-start">
                    <svg className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <h5 className="text-sm font-medium text-blue-800 dark:text-blue-200">Next Steps:</h5>
                      <ul className="text-sm text-blue-700 dark:text-blue-300 mt-1 space-y-1">
                        <li>• Send this link to the client via email</li>
                        <li>• Client will use this link to create their portal account</li>
                        <li>• Link expires in 10 days</li>
                        <li>• Client will be automatically linked to this CRM record</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-6 flex justify-end space-x-3">
              <button
                onClick={() => { setShowInviteLinkModal(false); setInviteModalRecipient(null); }}
                className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
              >
                Close
              </button>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(generatedInviteLink);
                  alert('Link copied to clipboard!');
                }}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
              >
                Copy Link
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Team Member Modal */}
      {showAddTeamMemberModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-md w-full mx-4">
            <div className="relative mb-4 flex items-center justify-center">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white text-center">
                Add Team Member
              </h3>
              <button
                onClick={() => setShowAddTeamMemberModal(false)}
                className="absolute right-0 top-1 text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Add a team member who will have their own portal account with access to the same company data.
            </p>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">First Name</label>
                <input
                  type="text"
                  value={newTeamMemberForm.firstName}
                  onChange={(e) => setNewTeamMemberForm(prev => ({ ...prev, firstName: e.target.value }))}
                  placeholder="First name"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Last Name</label>
                <input
                  type="text"
                  value={newTeamMemberForm.lastName}
                  onChange={(e) => setNewTeamMemberForm(prev => ({ ...prev, lastName: e.target.value }))}
                  placeholder="Last name"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Email <span className="text-red-500">*</span></label>
                <input
                  type="email"
                  value={newTeamMemberForm.email}
                  onChange={(e) => setNewTeamMemberForm(prev => ({ ...prev, email: e.target.value }))}
                  placeholder="email@example.com"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-3">
              <button
                onClick={() => setShowAddTeamMemberModal(false)}
                className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitAddTeamMember}
                disabled={isAddingTeamMember}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isAddingTeamMember ? 'Generating...' : 'Generate Invite Link'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Promote to Portal Modal */}
      {showPromoteModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-lg w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <div className="flex-1"></div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white text-center flex-1">
                Promote to Portal
              </h3>
              <div className="flex-1 flex justify-end">
                <button
                  onClick={() => setShowPromoteModal(false)}
                  className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="text-center">
                <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-orange-600 dark:text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  Promote {account.company} to Portal Access
                </h4>
                <p className="text-gray-600 dark:text-gray-300 mb-4">
                  This will promote the client from the start directory (leads only) to the portal directory (full client access). 
                  They will gain access to the complete client portal with all features and functionality.
                </p>
                <div className="bg-blue-50 dark:bg-blue-900 border border-blue-200 dark:border-blue-700 rounded-lg p-4">
                  <div className="flex items-start">
                    <svg className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <div>
                      <h5 className="text-sm font-medium text-blue-800 dark:text-blue-200">What happens next:</h5>
                      <ul className="text-sm text-blue-700 dark:text-blue-300 mt-1 space-y-1">
                        <li>• Client status will be updated to "Active"</li>
                        <li>• Portal access will be enabled</li>
                        <li>• Client will be moved from start/ to portal/ directory</li>
                        <li>• Full client portal features will be unlocked</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-6 flex justify-end space-x-3">
              <button
                onClick={() => setShowPromoteModal(false)}
                className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handlePromoteToPortal}
                className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700"
              >
                Promote to Portal
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Next Period Changes Modal */}
      {showNextPeriodModal && account && (
        <NextPeriodDeliverablesModal
          clientId={clientId}
          account={account}
          contractData={contractData}
          programItems={programItems}
          availableItems={availableItems}
          isEditMode={isEditMode}
          actorName={deliverableChangeActor}
          onClose={() => setShowNextPeriodModal(false)}
          onAccountFieldsUpdated={(fields) => setAccount((prev) => (prev ? { ...prev, ...fields } : prev))}
        />
      )}

      {/* Deliverable Update Modal */}
      {showDeliverableModal && selectedDeliverable && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-2xl w-full mx-4">
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <div className="flex-1"></div>
              <div className="flex items-center space-x-3">
                <div className="text-3xl">{selectedDeliverable.icon || '📦'}</div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                    {selectedDeliverable.name}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {selectedDeliverable.deliverable?.period || 'One Time'}
                  </p>
                </div>
              </div>
              <div className="flex-1 flex justify-end">
                <button
                  onClick={() => {
                    setShowDeliverableModal(false);
                    setSelectedDeliverable(null);
                    setDeliverableQuantityEditing(false);
                    setDeliverableUpdate({ completed: 0, date: '', period: '', completedWith: '' });
                    setActiveDeliverableTab('update');
                    setDeliverableLogPeriodIndex(0);
                    setShowCompletedWithDropdown(false);
                  }}
                  className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            
            {/* Tabs */}
            <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
              <nav className="-mb-px flex justify-center space-x-8">
                <button
                  onClick={() => setActiveDeliverableTab('update')}
                  className={`py-2 px-1 border-b-2 font-medium text-sm ${
                    activeDeliverableTab === 'update'
                      ? 'border-red-500 text-red-600 dark:text-red-400'
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300'
                  }`}
                >
                  Update
                </button>
                <button
                  onClick={() => setActiveDeliverableTab('logs')}
                  className={`py-2 px-1 border-b-2 font-medium text-sm ${
                    activeDeliverableTab === 'logs'
                      ? 'border-red-500 text-red-600 dark:text-red-400'
                      : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300'
                  }`}
                >
                  Logs
                </button>
              </nav>
            </div>
            
            {/* Calendly sync – only for strategy call deliverables when Calendly is connected */}
            {currentUserCalendlyConnected && isStrategyCallDeliverable(selectedDeliverable) && (
              <div className="flex justify-end mb-3">
                <button
                  type="button"
                  disabled={calendlySyncing}
                  onClick={async () => {
                    setCalendlySyncing(true);
                    try {
                      const result = await syncCalendlyMeetings(clientId);
                      const progress = resolveDeliverableProgress(account, selectedDeliverable.id, selectedDeliverable.deliverableCatalogId);
                      setDeliverableLogs(progress.logs || []);
                      setDeliverableLogPeriodIndex(0);
                      if (result.synced > 0) {
                        alert(`Synced ${result.synced} meeting${result.synced !== 1 ? 's' : ''} from Calendly.`);
                      }
                    } catch (err) {
                      alert(err.message || 'Calendly sync failed. Please try again.');
                    } finally {
                      setCalendlySyncing(false);
                    }
                  }}
                  className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded border border-blue-300 dark:border-blue-600 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {calendlySyncing ? (
                    <svg className="animate-spin h-3.5 w-3.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                    </svg>
                  ) : (
                    <RefreshCw size={13} />
                  )}
                  {calendlySyncing ? 'Syncing...' : 'Sync Calendly'}
                </button>
              </div>
            )}

            {/* Tab Content */}
            {activeDeliverableTab === 'update' ? (
              <div className="space-y-4">
                <div className="text-center mb-4">
                  <p className="text-sm text-blue-600 dark:text-blue-400">
                    Current Period: {getDeliverablePeriodDisplay(selectedDeliverable.deliverable?.period || selectedDeliverable.deliverable?.frequency || 'One Time')}
                  </p>
                </div>
                
                <div className="space-y-4">
                  {(() => {
                    const currentItem = programItems.find(i => i.id === selectedDeliverable?.id) || selectedDeliverable;
                    const quantity = Number(currentItem.programQuantity) || parseInt(currentItem.deliverable?.quantity, 10) || 1;
                    const displayQty = deliverableQuantityEditing ? deliverableEditQuantity : quantity;
                    const currentCompleted = currentItem.completed ?? 0;
                    const remaining = Math.max(0, displayQty - currentCompleted);
                    // Compute booked vs completed breakdown for status-aware visuals
                    const _itemPeriod = selectedDeliverable?.deliverable?.period || selectedDeliverable?.deliverable?.frequency || 'One Time';
                    const _billingPeriod = isMonthlyDeliverablePeriod(_itemPeriod) ? getAccountStrategyCallPeriod(account, contractData) : null;
                    const _periodLogs = _billingPeriod
                      ? deliverableLogs.filter(log => {
                          const ld = parseFlexibleAccountDate(log.scheduledStart) || parseFlexibleAccountDate(log.date) || parseFlexibleAccountDate(log.timestamp);
                          return ld && ld >= _billingPeriod.periodStart && ld < _billingPeriod.periodEnd;
                        })
                      : [];
                    const _now = new Date();
                    const _isLogBooked = (l) => {
                      if (l.meetingStatus === 'booked' || l.meetingStatus === 'scheduled') return true;
                      if (l.meetingStatus) return false;
                      const ldt = l.scheduledStart ? new Date(l.scheduledStart) : l.date ? new Date(l.date + 'T23:59:59') : null;
                      return ldt ? ldt > _now : false;
                    };
                    const _bookedCount = _periodLogs.filter(_isLogBooked).reduce((s, l) => s + (l.quantity || 1), 0);
                    const _actualCompleted = _periodLogs.filter(l => !_isLogBooked(l) && l.meetingStatus !== 'canceled' && l.meetingStatus !== 'rescheduled').reduce((s, l) => s + (l.quantity || 1), 0);
                    const _hasStatusBreakdown = _periodLogs.some(_isLogBooked);
                    return (
                  <>
                  <div className="space-y-2">
                    <div className="text-sm font-medium text-gray-700 dark:text-gray-300 flex flex-wrap items-center gap-2">
                      {_hasStatusBreakdown ? (
                        <>
                          <span>{_actualCompleted} completed</span>
                          {_bookedCount > 0 && <span className="text-blue-500 dark:text-blue-400">{_bookedCount} booked</span>}
                          <span>/</span>
                        </>
                      ) : (
                        <span>Progress: {currentCompleted} /</span>
                      )}
                      {canEditDeliverables && deliverableQuantityEditing ? (
                        <input
                          type="number"
                          min={0}
                          value={deliverableEditQuantity}
                          onChange={(e) => setDeliverableEditQuantity(Math.max(0, parseInt(e.target.value, 10) || 0))}
                          className="w-14 text-center text-sm rounded border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                        />
                      ) : (
                        <span>{quantity}</span>
                      )}
                      <span className="text-xs text-gray-500 dark:text-gray-400">(quantity)</span>
                    </div>
                    <div className="flex justify-center gap-1 flex-wrap">
                      {Array.from({ length: Math.max(1, displayQty) }, (_, i) => i + 1).map((n) => (
                        <DeliverableProgressCircle
                          key={n}
                          n={n}
                          completed={_hasStatusBreakdown ? _actualCompleted : currentCompleted}
                          booked={_hasStatusBreakdown ? _bookedCount : 0}
                          title={_hasStatusBreakdown ? (n <= _actualCompleted ? 'Completed' : n <= _actualCompleted + _bookedCount ? 'Booked' : 'Remaining') : undefined}
                        />
                      ))}
                    </div>
                    {_hasStatusBreakdown && (
                      <div className="flex justify-center gap-4 text-xs mt-1">
                        <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full bg-green-500 inline-block"></span>Completed</span>
                        <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-full bg-blue-400 inline-block"></span>Booked</span>
                      </div>
                    )}
                  </div>
                  {remaining > 0 ? (
                    <div className="space-y-3">
                      {(() => {
                        // Implementation Hours are a pooled hours allowance, so completions can be
                        // logged in half-hour (0.5) steps; everything else stays whole-unit.
                        const _addStep = isStrategyCallDeliverable(selectedDeliverable) || !Number.isInteger(remaining) ? 0.5 : 1;
                        return (
                      <div className="flex items-center gap-3 flex-wrap">
                        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                          {_addStep < 1 ? 'Add hours:' : 'Add completions:'}
                        </label>
                        {_addStep < 1 && (
                          <span className="text-xs text-gray-500 dark:text-gray-400">(30-min increments)</span>
                        )}
                        <div className="flex items-center gap-2 flex-wrap">
                          {(displayQty > 1 || _addStep < 1) && (
                            <>
                              {Array.from({ length: Math.max(0, Math.round(remaining / _addStep)) }, (_, i) => (i + 1) * _addStep).map(n => (
                                <button
                                  key={n}
                                  type="button"
                                  onClick={() => setDeliverableUpdate({ ...deliverableUpdate, completed: n })}
                                  className={`min-w-[2rem] h-8 px-1.5 rounded-full flex items-center justify-center text-sm font-medium border ${
                                    deliverableUpdate.completed === n
                                      ? 'bg-red-600 text-white border-red-600'
                                      : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-red-500'
                                  }`}
                                >
                                  +{formatDeliverableQty(n)}
                                </button>
                              ))}
                            </>
                          )}
                          {displayQty === 1 && _addStep === 1 && (
                            <button
                              type="button"
                              onClick={() => setDeliverableUpdate({ ...deliverableUpdate, completed: 1, date: deliverableUpdate.date || new Date().toISOString().split('T')[0] })}
                              className={`px-3 py-1.5 rounded-lg text-sm font-medium border ${
                                deliverableUpdate.completed === 1
                                  ? 'bg-red-600 text-white border-red-600'
                                  : 'bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:border-red-500'
                              }`}
                            >
                              +1
                            </button>
                          )}
                        </div>
                      </div>
                        );
                      })()}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Date completed</label>
                        <input
                          type="date"
                          value={deliverableUpdate.date || new Date().toISOString().split('T')[0]}
                          onChange={(e) => setDeliverableUpdate({ ...deliverableUpdate, date: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                        />
                      </div>
                      {selectedDeliverable.deliverable?.trackParticipants && (
                        <div className="relative">
                          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Who was it with</label>
                          <button
                            type="button"
                            onClick={() => setShowCompletedWithDropdown(!showCompletedWithDropdown)}
                            className="w-full flex items-center justify-between px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                          >
                            <div className="flex items-center">
                              {deliverableUpdate.completedWith ? (
                                (() => {
                                  const user = internalUsers.find(u => u.id === deliverableUpdate.completedWith);
                                  return user ? (
                                    <>
                                      <div className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-xs font-medium text-gray-600 dark:text-gray-300 mr-2 overflow-hidden flex-shrink-0 relative">
                                        {user.profileImage ? (
                                          <img src={user.profileImage} alt={user.name || 'User'} className="w-full h-full object-cover absolute inset-0 z-10" onError={(e) => { e.target.style.display = 'none'; }} />
                                        ) : null}
                                        <span className="w-full h-full flex items-center justify-center">{user.initials}</span>
                                      </div>
                                      <span>{user.name || 'Unknown'}</span>
                                    </>
                                  ) : (
                                    <span className="text-gray-500 dark:text-gray-400">Select internal user</span>
                                  );
                                })()
                              ) : (
                                <span className="text-gray-500 dark:text-gray-400">Select internal user</span>
                              )}
                            </div>
                            <ChevronDown size={16} className="text-gray-500 dark:text-gray-400 flex-shrink-0" />
                          </button>
                          {showCompletedWithDropdown && (
                            <div className="absolute z-20 w-full mt-1 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                              <div className="p-2">
                                <div
                                  onClick={() => {
                                    setDeliverableUpdate({ ...deliverableUpdate, completedWith: '' });
                                    setShowCompletedWithDropdown(false);
                                  }}
                                  className="flex items-center p-2 hover:bg-gray-50 dark:hover:bg-gray-600 cursor-pointer rounded-md text-gray-500 dark:text-gray-400"
                                >
                                  <span className="text-sm">None</span>
                                </div>
                                {internalUsers.map(user => (
                                  <div
                                    key={user.id}
                                    onClick={() => {
                                      setDeliverableUpdate({ ...deliverableUpdate, completedWith: user.id });
                                      setShowCompletedWithDropdown(false);
                                    }}
                                    className={`flex items-center p-2 hover:bg-gray-50 dark:hover:bg-gray-600 cursor-pointer rounded-md ${deliverableUpdate.completedWith === user.id ? 'bg-red-50 dark:bg-red-900/20' : ''}`}
                                  >
                                    <div className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-600 flex items-center justify-center text-xs font-medium text-gray-600 dark:text-gray-300 mr-2 overflow-hidden flex-shrink-0 relative">
                                      {user.profileImage ? (
                                        <img src={user.profileImage} alt={user.name || 'User'} className="w-full h-full object-cover absolute inset-0 z-10" onError={(e) => { e.target.style.display = 'none'; }} />
                                      ) : null}
                                      <span className="w-full h-full flex items-center justify-center">{user.initials}</span>
                                    </div>
                                    <span className="text-gray-900 dark:text-white">{user.name || 'Unknown'}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="bg-green-50 dark:bg-green-900 border border-green-200 dark:border-green-700 rounded-lg p-4">
                      <div className="flex items-center justify-between">
                        <span className="text-sm font-medium text-green-800 dark:text-green-200">All done for this period</span>
                        <button
                          onClick={() => setDeliverableUpdate({ ...deliverableUpdate, completed: 0 })}
                          className="text-xs text-green-600 dark:text-green-400 hover:text-green-800 dark:hover:text-green-200 underline"
                        >
                          Remove completions
                        </button>
                      </div>
                    </div>
                  )}
                  
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    Total required per {(selectedDeliverable.deliverable?.period || selectedDeliverable.deliverable?.frequency || 'One Time').toLowerCase()}: {displayQty}
                  </div>
                  </>
                    );
                  })()}
                </div>
                
                <div className="mt-6 flex justify-between items-center">
                  <div>
                    {canEditDeliverables && (
                      deliverableQuantityEditing ? (
                        <button
                          type="button"
                          onClick={async () => {
                            const currentItem = programItems.find(i => i.id === selectedDeliverable?.id) || selectedDeliverable;
                            const qty = Number(currentItem.programQuantity) || parseInt(currentItem.deliverable?.quantity, 10) || 1;
                            const newQty = Math.max(0, parseInt(String(deliverableEditQuantity), 10) || 0);
                            if (newQty !== qty) {
                              try {
                                await handleAdjustDeliverableQuantity(currentItem, newQty);
                                setSelectedDeliverable(prev => prev ? { ...prev, programQuantity: newQty } : null);
                              } catch (err) {
                                alert('Failed to save quantity. Please try again.');
                                return;
                              }
                            }
                            setDeliverableQuantityEditing(false);
                          }}
                          className="px-3 py-1.5 text-sm font-medium rounded bg-red-600 text-white hover:bg-red-700"
                        >
                          Save quantity
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            const currentItem = programItems.find(i => i.id === selectedDeliverable?.id) || selectedDeliverable;
                            const qty = Number(currentItem.programQuantity) || parseInt(currentItem.deliverable?.quantity, 10) || 1;
                            setDeliverableEditQuantity(qty);
                            setDeliverableQuantityEditing(true);
                          }}
                          className="px-3 py-1.5 text-sm font-medium rounded border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
                        >
                          Edit quantity
                        </button>
                      )
                    )}
                  </div>
                  <div className="flex space-x-3">
                    <button
                      onClick={() => {
                        setShowDeliverableModal(false);
                        setSelectedDeliverable(null);
                        setDeliverableQuantityEditing(false);
                        setDeliverableUpdate({ completed: 0, date: '', period: '', completedWith: '' });
                        setActiveDeliverableTab('update');
                        setDeliverableLogPeriodIndex(0);
                        setShowCompletedWithDropdown(false);
                      }}
                      className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleDeliverableUpdate}
                      disabled={(() => {
                        const currentItem = programItems.find(i => i.id === selectedDeliverable?.id) || selectedDeliverable;
                        const qty = Number(currentItem.programQuantity) || parseInt(currentItem.deliverable?.quantity, 10) || 1;
                        const curr = currentItem.completed ?? 0;
                        const rem = Math.max(0, qty - curr);
                        return rem > 0 && !deliverableUpdate.completed;
                      })()}
                      className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      Update Progress
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="space-y-4">
                <div className="text-center mb-2">
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    Completion history by period
                  </p>
                </div>

                {deliverableLogs.length > 0 ? (() => {
                  const allPeriods = groupDeliverableLogsByBillingPeriod(deliverableLogs, account, contractData);
                  const totalPeriods = allPeriods.length;
                  const periodData = allPeriods[deliverableLogPeriodIndex];
                  const currentItem = programItems.find(i => i.id === selectedDeliverable?.id) || selectedDeliverable;
                  const quantity = Number(currentItem.programQuantity) || parseInt(currentItem.deliverable?.quantity, 10) || 1;
                  return (
                    <div>
                      {totalPeriods > 1 && (
                        <div className="flex items-center justify-between mb-3 px-1">
                          <button
                            type="button"
                            onClick={() => setDeliverableLogPeriodIndex(i => Math.max(i - 1, 0))}
                            disabled={deliverableLogPeriodIndex <= 0}
                            className="p-1 rounded text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 disabled:opacity-30 disabled:cursor-not-allowed"
                            title="Newer period"
                          >
                            <ChevronLeft size={18} />
                          </button>
                          <span className="text-xs text-gray-500 dark:text-gray-400">
                            Period {totalPeriods - deliverableLogPeriodIndex} of {totalPeriods}
                          </span>
                          <button
                            type="button"
                            onClick={() => setDeliverableLogPeriodIndex(i => Math.min(i + 1, totalPeriods - 1))}
                            disabled={deliverableLogPeriodIndex >= totalPeriods - 1}
                            className="p-1 rounded text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 disabled:opacity-30 disabled:cursor-not-allowed"
                            title="Older period"
                          >
                            <ChevronRight size={18} />
                          </button>
                        </div>
                      )}

                      {periodData ? (
                        <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4">
                          <div className="flex justify-between items-center mb-3">
                            <h4 className="font-medium text-gray-900 dark:text-white text-sm">
                              {periodData.displayLabel}
                            </h4>
                            <div className="text-xs text-gray-500 dark:text-gray-400">
                              {periodData.totalCompleted} / {quantity}
                            </div>
                          </div>
                          <div className="space-y-2">
                            {[...periodData.logs]
                              .sort((a, b) => {
                                const aKey = a.scheduledStart || a.date || a.timestamp || '';
                                const bKey = b.scheduledStart || b.date || b.timestamp || '';
                                return String(bKey).localeCompare(String(aKey));
                              })
                              .map((log, index) => {
                                const ms = log.meetingStatus;
                                const now = new Date();
                                // Infer future/past from scheduled or logged date when meetingStatus absent
                                const logDateTime = log.scheduledStart
                                  ? new Date(log.scheduledStart)
                                  : log.date
                                    ? new Date(log.date + 'T23:59:59')
                                    : null;
                                const inferredFuture = logDateTime ? logDateTime > now : false;
                                const isCanceled = ms === 'canceled';
                                const isRescheduled = ms === 'rescheduled';
                                const isBooked = ms === 'booked' || ms === 'scheduled' || (!ms && inferredFuture);
                                const statusLabel = isCanceled ? 'Canceled'
                                  : isRescheduled ? 'Rescheduled'
                                  : isBooked ? 'Booked For'
                                  : 'Completed';
                                const statusColorClass = isCanceled
                                  ? 'text-red-500 dark:text-red-400'
                                  : isRescheduled
                                    ? 'text-yellow-600 dark:text-yellow-400'
                                    : isBooked
                                      ? 'text-blue-600 dark:text-blue-400'
                                      : 'text-green-600 dark:text-green-500';
                                const dateDisplay = log.scheduledStart
                                  ? new Date(log.scheduledStart).toLocaleDateString()
                                  : formatAccountLogDisplayDate(log.date);
                                const durationText = log.durationMinutes ? ` · ${log.durationMinutes} min` : '';
                                // Half-hour completions (Implementation Hours) — show the fractional amount.
                                const qtyText = log.quantity && !Number.isInteger(Number(log.quantity)) ? ` · ${log.quantity} hr` : '';
                                const userDisplay = selectedDeliverable.deliverable?.trackParticipants && log.completedWith
                                  ? ` with ${internalUsers.find(u => u.id === log.completedWith)?.name || log.completedWith}`
                                  : '';
                                return (
                                  <div key={log.id || index} className={`flex justify-between items-start text-xs group ${isCanceled ? 'opacity-50' : ''}`}>
                                    <div className="flex items-baseline gap-1.5 flex-1 min-w-0">
                                      <span className={`font-semibold flex-shrink-0 ${statusColorClass}`}>
                                        {statusLabel}
                                      </span>
                                      <span className={`text-gray-600 dark:text-gray-400 truncate ${isCanceled ? 'line-through' : ''}`}>
                                        {dateDisplay}{durationText}{qtyText}{userDisplay}
                                      </span>
                                    </div>
                                    <button
                                      onClick={() => {
                                        if (window.confirm('Are you sure you want to delete this log entry?')) {
                                          handleDeleteLog(log.id);
                                        }
                                      }}
                                      className="opacity-0 group-hover:opacity-100 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 transition-opacity duration-200 p-1 flex-shrink-0 ml-1"
                                      title="Delete log entry"
                                    >
                                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                      </svg>
                                    </button>
                                  </div>
                                );
                              })}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  );
                })() : (
                  <div className="text-center py-8 text-gray-500 dark:text-gray-400">
                    No completion history yet
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ACH Upload Modal */}
      {showACHUploadModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <div className="flex-1"></div>
              <h3 className="text-2xl font-semibold text-gray-900 dark:text-white text-center flex-1">
                ACH Bank Information
              </h3>
              <div className="flex-1 flex justify-end">
                <button
                  onClick={() => {
                    setShowACHUploadModal(false);
                    setAchFormData({
                      accountType: '',
                      bankName: '',
                      routingNumber: '',
                      accountNumber: '',
                      nameOnAccount: ''
                    });
                    setAchFormErrors({});
                  }}
                  className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="space-y-6">
              <div className="bg-purple-50 dark:bg-purple-900 border border-purple-200 dark:border-purple-700 rounded-lg p-4">
                <div className="flex items-start">
                  <svg className="w-5 h-5 text-purple-600 dark:text-purple-400 mt-0.5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <h5 className="text-sm font-medium text-purple-800 dark:text-purple-200">Enter ACH Information for {account.company}</h5>
                    <p className="text-sm text-purple-700 dark:text-purple-300 mt-1">
                      Please provide the bank account information for this client. This information will be stored securely.
                    </p>
                  </div>
                </div>
              </div>

              <form onSubmit={(e) => { e.preventDefault(); handleACHFormSubmit(); }} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Account Type *
                  </label>
                  <select
                    value={achFormData.accountType}
                    onChange={(e) => setAchFormData({ ...achFormData, accountType: e.target.value })}
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                      achFormErrors.accountType ? 'border-red-500' : 'border-gray-300'
                    }`}
                  >
                    <option value="">Select Account Type</option>
                    <option value="checking">Checking</option>
                    <option value="savings">Savings</option>
                  </select>
                  {achFormErrors.accountType && <p className="text-red-500 text-sm mt-1">{achFormErrors.accountType}</p>}
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Bank Name *
                  </label>
                  <input
                    type="text"
                    value={achFormData.bankName}
                    onChange={(e) => setAchFormData({ ...achFormData, bankName: e.target.value })}
                    placeholder="Enter bank name"
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                      achFormErrors.bankName ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {achFormErrors.bankName && <p className="text-red-500 text-sm mt-1">{achFormErrors.bankName}</p>}
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Routing Number *
                  </label>
                  <input
                    type="text"
                    value={achFormData.routingNumber}
                    onChange={(e) => {
                      const formatted = formatRoutingNumber(e.target.value);
                      setAchFormData({ ...achFormData, routingNumber: formatted });
                    }}
                    placeholder="Enter routing number"
                    maxLength="9"
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                      achFormErrors.routingNumber ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {achFormErrors.routingNumber && <p className="text-red-500 text-sm mt-1">{achFormErrors.routingNumber}</p>}
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Account Number *
                  </label>
                  <input
                    type="text"
                    value={achFormData.accountNumber}
                    onChange={(e) => {
                      const formatted = formatAccountNumber(e.target.value);
                      setAchFormData({ ...achFormData, accountNumber: formatted });
                    }}
                    placeholder="Enter account number"
                    maxLength="17"
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                      achFormErrors.accountNumber ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {achFormErrors.accountNumber && <p className="text-red-500 text-sm mt-1">{achFormErrors.accountNumber}</p>}
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Name on Account *
                  </label>
                  <input
                    type="text"
                    value={achFormData.nameOnAccount}
                    onChange={(e) => setAchFormData({ ...achFormData, nameOnAccount: e.target.value })}
                    placeholder="Enter name on account"
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white ${
                      achFormErrors.nameOnAccount ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {achFormErrors.nameOnAccount && <p className="text-red-500 text-sm mt-1">{achFormErrors.nameOnAccount}</p>}
                </div>
              </form>
            </div>
            
            <div className="mt-6 flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowACHUploadModal(false);
                  setAchFormData({
                    accountType: '',
                    bankName: '',
                    routingNumber: '',
                    accountNumber: '',
                    nameOnAccount: ''
                  });
                  setAchFormErrors({});
                }}
                className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
              >
                Cancel
              </button>
              <button
                onClick={handleACHFormSubmit}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
              >
                Save ACH Information
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Check In Details Modal */}
      {showCheckInDetailsModal && selectedCheckIn && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <div className="flex-1"></div>
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white text-center flex-1">
                {selectedCheckIn.month || 'Check In'} Details
              </h3>
              <div className="flex-1 flex justify-end">
                <button
                  onClick={() => {
                    setShowCheckInDetailsModal(false);
                    setSelectedCheckIn(null);
                  }}
                  className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
            </div>

            <div className="space-y-6">
              {/* Question */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
                  How satisfied are you with our overall service?
                </label>
                
                {/* Star Rating Display */}
                {(selectedCheckIn.overallSatisfaction ?? selectedCheckIn.rating) || selectedCheckIn.overallStatus ? (
                  <div className="flex space-x-2 justify-center">
                    {[1, 2, 3, 4, 5].map((star) => {
                      let rating = selectedCheckIn.overallSatisfaction ?? selectedCheckIn.rating;
                      if (!rating && selectedCheckIn.overallStatus) {
                        if (selectedCheckIn.overallStatus === 'Good') rating = 5;
                        else if (selectedCheckIn.overallStatus === 'Okay') rating = 3;
                        else if (selectedCheckIn.overallStatus === 'Not Good') rating = 1;
                      }
                      
                      return (
                        <span
                          key={star}
                          className={`text-5xl ${
                            (rating || 0) >= star
                              ? 'text-yellow-400'
                              : 'text-gray-200 dark:text-gray-600'
                          }`}
                        >
                          ★
                        </span>
                      );
                    })}
                  </div>
                ) : (
                  <div className="text-center text-gray-500 dark:text-gray-400 py-4">
                    Awaiting response
                  </div>
                )}
              </div>

              {/* Additional Feedback */}
              {(selectedCheckIn.additionalFeedback || selectedCheckIn.comments) && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Additional Feedback
                  </label>
                  <div className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4 text-gray-900 dark:text-white whitespace-pre-wrap">
                    {selectedCheckIn.additionalFeedback || selectedCheckIn.comments || ''}
                  </div>
                </div>
              )}

              {(selectedCheckIn.wantsSuccessManagerQuestion ||
                selectedCheckIn.requestedCheckInCall) && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Follow-up requests
                  </label>
                  <ul className="text-sm text-gray-900 dark:text-white space-y-1 list-disc list-inside">
                    {selectedCheckIn.wantsSuccessManagerQuestion ? (
                      <li>Client indicated they have a question</li>
                    ) : null}
                    {selectedCheckIn.requestedCheckInCall ? (
                      <li>Client requested to set up a check-in call</li>
                    ) : null}
                  </ul>
                </div>
              )}

              {/* Submitted On */}
              {selectedCheckIn.submittedAt && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                    Submitted On
                  </label>
                  <div className="text-gray-900 dark:text-white">
                    {(selectedCheckIn.submittedAt instanceof Date 
                      ? selectedCheckIn.submittedAt 
                      : new Date(selectedCheckIn.submittedAt)).toLocaleString()}
                  </div>
                </div>
              )}
            </div>

            <div className="mt-6 flex justify-end">
              <button
                type="button"
                onClick={() => {
                  setShowCheckInDetailsModal(false);
                  setSelectedCheckIn(null);
                }}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Lock Status Modal */}
      {showLockModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-lg w-full mx-4">
            <div className="text-center mb-4">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                {account.lockStatus === 'locked' ? 'Unlock Account' : 'Lock Account'}
              </h3>
            </div>
            
            <div className="mb-6">
              <p className="text-gray-600 dark:text-gray-300">
                {account.lockStatus === 'locked'
                  ? 'This will unlock the client portal access.'
                  : 'This will lock the client portal access and turn off all portal page access toggles.'
                }
              </p>
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowLockModal(false)}
                className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                disabled={isLocking}
              >
                Cancel
              </button>
              <button
                onClick={handleLockToggle}
                disabled={isLocking}
                className={`px-4 py-2 rounded-lg ${
                  account.lockStatus === 'locked'
                    ? 'bg-green-600 hover:bg-green-700 text-white'
                    : 'bg-red-600 hover:bg-red-700 text-white'
                } disabled:opacity-50 disabled:cursor-not-allowed`}
              >
                {isLocking ? 'Processing...' : (account.lockStatus === 'locked' ? 'Unlock Account' : 'Lock Account')}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* NDA View Modal */}
      {showNDAModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col">
            <div className="flex justify-between items-center mb-4">
              <div className="flex-1"></div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white text-center flex-1">Signed Non-Disclosure Agreement</h3>
              <div className="flex-1 flex justify-end">
                <button
                  onClick={() => setShowNDAModal(false)}
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>
            
            <div className="flex-1 overflow-y-auto">
              <div className="space-y-6">
                {/* Document Status */}
                {(() => {
                  // Use account.signedNDA if signedNDA state is null but account has it
                  const ndaData = signedNDA || account?.signedNDA;
                  return ndaData?.isFullyExecuted ? (
                  <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg p-4">
                    <div className="flex items-center mb-2">
                      <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400 mr-2" />
                      <h4 className="text-md font-semibold text-green-900 dark:text-green-100">Fully Executed NDA</h4>
                    </div>
                    <p className="text-sm text-green-800 dark:text-green-200">
                      This NDA has been signed by both parties and is fully executed{signedNDA.finalizedAt ? ` as of ${new Date(signedNDA.finalizedAt).toLocaleString()}` : ''}.
                    </p>
                  </div>
                ) : ndaData ? (
                  <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-700 rounded-lg p-4">
                    <div className="flex items-center mb-2">
                      <Clock className="h-5 w-5 text-orange-600 dark:text-orange-400 mr-2" />
                      <h4 className="text-md font-semibold text-orange-900 dark:text-orange-100">Awaiting BBA Signature</h4>
                    </div>
                    <p className="text-sm text-orange-800 dark:text-orange-200">
                      This NDA has been signed by the client but requires BBA signature to be fully executed.
                    </p>
                  </div>
                ) : null;
                })()}

                {/* Document Content */}
                {(() => {
                  // Use account.signedNDA if signedNDA state is null but account has it
                  const ndaData = signedNDA || account?.signedNDA;
                  return ndaData ? (
                  <>
                    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg p-4">
                      <h4 className="text-md font-semibold text-gray-900 dark:text-white mb-3">Document Content</h4>
                      <div className="prose dark:prose-invert max-w-none prose-ul:list-disc prose-ul:ml-4 prose-li:my-1">
                        {ndaData.finalizedDocumentContent ? (
                          <div 
                            className="text-sm text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-700 p-4 rounded border max-h-96 overflow-y-auto [&_ul]:list-disc [&_ul]:ml-4 [&_ul]:my-2 [&_li]:my-1 [&_ul_ul]:ml-4 [&_ul_ul]:mt-1"
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(ndaData.finalizedDocumentContent) }}
                          />
                        ) : (
                          <pre className="whitespace-pre-wrap text-sm text-gray-700 dark:text-gray-300 font-mono bg-gray-50 dark:bg-gray-700 p-4 rounded border">
                            {ndaData.documentContent || 'Document content not available'}
                          </pre>
                        )}
                      </div>
                    </div>

                    {/* Client Signature */}
                    {ndaData.signature && (
                      <div className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4">
                        <h4 className="text-md font-semibold text-gray-900 dark:text-white mb-3">Client Electronic Signature</h4>
                        <div className="text-lg font-semibold text-gray-900 dark:text-white" style={{fontFamily: 'Dancing Script, Brush Script MT, cursive'}}>
                          {ndaData.signature}
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                          Signed by: {ndaData.signerName || 'Unknown'}{ndaData.signerTitle ? ` (${ndaData.signerTitle})` : ''}{ndaData.signedAt ? ` on ${new Date(ndaData.signedAt).toLocaleString()}` : ''}
                        </div>
                      </div>
                    )}

                    {/* BBA Signature (if fully executed) */}
                    {ndaData.isFullyExecuted && ndaData.bbaSignature && (
                      <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
                        <h4 className="text-md font-semibold text-blue-900 dark:text-blue-100 mb-3">BBA Electronic Signature</h4>
                        <div className="text-lg font-semibold text-blue-900 dark:text-blue-100" style={{fontFamily: 'Dancing Script, Brush Script MT, cursive'}}>
                          {(() => {
                            const bbaFormData = ndaData.bbaSignature;
                            const signatureKeys = Object.keys(bbaFormData).filter(key => 
                              key.toLowerCase().includes('signature') && bbaFormData[key] && bbaFormData[key].trim().length > 0
                            );
                            if (signatureKeys.length > 0) {
                              return bbaFormData[signatureKeys[0]];
                            }
                            const nonEmptyValues = Object.values(bbaFormData).filter(value => 
                              value && typeof value === 'string' && value.trim().length > 0
                            );
                            return nonEmptyValues.length > 0 ? nonEmptyValues[0] : 'BBA Signature';
                          })()}
                        </div>
                        <div className="text-sm text-blue-700 dark:text-blue-300 mt-2">
                          {(() => {
                            let signerName = ndaData.bbaSignerName || ndaData.bbaName || 'Unknown';
                            let signDate = ndaData.bbaSignedAt || ndaData.bbaSignatureDate || ndaData.bbaDate || 'Unknown Date';
                            if (signerName === 'Unknown' && ndaData.bbaSignature) {
                              const bbaFormData = ndaData.bbaSignature;
                              const nameKeys = Object.keys(bbaFormData).filter(key => 
                                (key.includes('-bba-Name-') || key.toLowerCase().includes('name')) && 
                                bbaFormData[key] && typeof bbaFormData[key] === 'string' && bbaFormData[key].trim().length > 0
                              );
                              if (nameKeys.length > 0) {
                                signerName = bbaFormData[nameKeys[0]];
                              }
                            }
                            if (signDate === 'Unknown Date' && ndaData.bbaSignature) {
                              const bbaFormData = ndaData.bbaSignature;
                              const dateKeys = Object.keys(bbaFormData).filter(key => 
                                (key.includes('-bba-Date-') || key.toLowerCase().includes('date')) && 
                                bbaFormData[key] && typeof bbaFormData[key] === 'string' && bbaFormData[key].trim().length > 0
                              );
                              if (dateKeys.length > 0) {
                                signDate = bbaFormData[dateKeys[0]];
                              }
                            }
                            if (signDate !== 'Unknown Date' && signDate.includes('T')) {
                              try {
                                signDate = new Date(signDate).toLocaleString();
                              } catch (e) {}
                            }
                            return `Signed by: ${signerName} on ${signDate}`;
                          })()}
                        </div>
                      </div>
                    )}

                    {/* E-SIGN Act Compliance */}
                    {ndaData.eSignCompliance && (
                      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-4">
                        <h4 className="text-md font-semibold text-blue-900 dark:text-blue-100 mb-3">E-SIGN Act Compliance</h4>
                        <div className="space-y-2 text-sm">
                          <div className="flex items-center">
                            <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                            <span className="text-blue-800 dark:text-blue-200">
                              Electronic signature consent: {ndaData.eSignCompliance?.consentToElectronicSignatures ? 'Yes' : 'No'}
                            </span>
                          </div>
                          <div className="flex items-center">
                            <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                            <span className="text-blue-800 dark:text-blue-200">
                              Electronic records consent: {ndaData.eSignCompliance?.consentToElectronicRecords ? 'Yes' : 'No'}
                            </span>
                          </div>
                          {ndaData.eSignCompliance?.auditTrail?.signedDateTime && (
                            <>
                              <div className="flex items-center">
                                <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                                <span className="text-blue-800 dark:text-blue-200">
                                  Signed at: {new Date(ndaData.eSignCompliance.auditTrail.signedDateTime).toLocaleString()}
                                </span>
                              </div>
                              {ndaData.eSignCompliance.auditTrail.ipAddress && (
                                <div className="flex items-center">
                                  <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                                  <span className="text-blue-800 dark:text-blue-200">
                                    IP Address: {ndaData.eSignCompliance.auditTrail.ipAddress}
                                  </span>
                                </div>
                              )}
                              {ndaData.eSignCompliance.auditTrail.browser && (
                                <div className="flex items-center">
                                  <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                                  <span className="text-blue-800 dark:text-blue-200">
                                    Browser: {ndaData.eSignCompliance.auditTrail.browser} on {ndaData.eSignCompliance.auditTrail.device || 'Unknown Device'}
                                  </span>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                ) : null;
                })()}
              </div>
            </div>
            
            <div className="flex justify-end space-x-3 mt-6 pt-4 border-t border-gray-200 dark:border-gray-600">
              <button
                onClick={handleViewNDAPDF}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm"
              >
                View PDF
              </button>
              <button
                onClick={handleDownloadNDAPDF}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm"
              >
                Download PDF
              </button>
              <button
                onClick={() => setShowNDAModal(false)}
                className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Contract View Modal */}
      {showContractModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white dark:bg-gray-900 rounded-2xl p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-hidden flex flex-col">
            <div className="flex justify-between items-center mb-4">
              <div className="flex-1"></div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white text-center flex-1">Signed Contract</h3>
              <div className="flex-1 flex justify-end">
                <button
                  onClick={() => setShowContractModal(false)}
                  className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>
            
            <div className="flex-1 overflow-y-auto">
              <div className="space-y-6">
                {/* Document Status */}
                {(() => {
                  // Use account.signedContract or account.contractData if contractData state is null but account has it
                  const contract = contractData || account?.signedContract || account?.contractData;
                  return contract?.isFullyExecuted ? (
                    <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-700 rounded-lg p-4">
                      <div className="flex items-center mb-2">
                        <CheckCircle className="h-5 w-5 text-green-600 dark:text-green-400 mr-2" />
                        <h4 className="text-md font-semibold text-green-900 dark:text-green-100">Fully Executed Contract</h4>
                      </div>
                      <p className="text-sm text-green-800 dark:text-green-200">
                        This contract has been signed by both parties and is fully executed{contract.finalizedAt ? ` as of ${new Date(contract.finalizedAt).toLocaleString()}` : ''}.
                      </p>
                    </div>
                  ) : contract ? (
                    <div className="bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-700 rounded-lg p-4">
                      <div className="flex items-center mb-2">
                        <Clock className="h-5 w-5 text-orange-600 dark:text-orange-400 mr-2" />
                        <h4 className="text-md font-semibold text-orange-900 dark:text-orange-100">Awaiting BBA Signature</h4>
                      </div>
                      <p className="text-sm text-orange-800 dark:text-orange-200">
                        This contract has been signed by the client but requires BBA signature to be fully executed.
                      </p>
                    </div>
                  ) : null;
                })()}

                {/* Document Content - show contract data OR embedded document when only URL exists (e.g. uploaded PDF) */}
                {(() => {
                  // Use account.signedContract or account.contractData if contractData state is null but account has it
                  const contract = contractData || account?.signedContract || account?.contractData;
                  const documentUrl = contract?.documentUrl || account?.contractUrl;
                  // Check if contract has meaningful content (exclude minimal Checkout data: startDate, contractLength, termsAccepted only)
                  const hasContractContent = contract && (
                    (contract.templateElements && contract.templateElements.length > 0) ||
                    (contract.templateData?.templateElements && contract.templateData.templateElements.length > 0) ||
                    (contract.finalizedDocumentContent && contract.finalizedDocumentContent.trim()) ||
                    (contract.documentContent && contract.documentContent.trim())
                  );
                  return hasContractContent ? (
                  <>
                    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg p-4">
                      <h4 className="text-md font-semibold text-gray-900 dark:text-white mb-3">Document Content</h4>
                      <div className="prose dark:prose-invert max-w-none prose-ul:list-disc prose-ul:ml-4 prose-li:my-1">
                        {(contract.templateElements && contract.templateElements.length > 0) || (contract.templateData?.templateElements && contract.templateData.templateElements.length > 0) ? (
                          <div 
                            className="text-sm text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-700 p-4 rounded border max-h-96 overflow-y-auto [&_ul]:list-disc [&_ul]:ml-4 [&_ul]:my-2 [&_li]:my-1 [&_ul_ul]:ml-4 [&_ul_ul]:mt-1 prose prose-sm dark:prose-invert"
                            dangerouslySetInnerHTML={{ 
                              __html: sanitizeHtml(renderContractElements(contract.templateElements || contract.templateData?.templateElements || [], contract))
                            }}
                          />
                        ) : contract.finalizedDocumentContent ? (
                          <div 
                            className="text-sm text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-700 p-4 rounded border max-h-96 overflow-y-auto [&_ul]:list-disc [&_ul]:ml-4 [&_ul]:my-2 [&_li]:my-1 [&_ul_ul]:ml-4 [&_ul_ul]:mt-1"
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(renderContractContentWithVariables(contract.finalizedDocumentContent, contract)) }}
                          />
                        ) : contract.documentContent ? (
                          <div 
                            className="text-sm text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-700 p-4 rounded border max-h-96 overflow-y-auto [&_ul]:list-disc [&_ul]:ml-4 [&_ul]:my-2 [&_li]:my-1 [&_ul_ul]:ml-4 [&_ul_ul]:mt-1"
                            dangerouslySetInnerHTML={{ __html: sanitizeHtml(renderContractContentWithVariables(contract.documentContent, contract)) }}
                          />
                        ) : (
                          <pre className="whitespace-pre-wrap text-sm text-gray-700 dark:text-gray-300 font-mono bg-gray-50 dark:bg-gray-700 p-4 rounded border">
                            {renderContractContentWithVariables('Document content not available', contract)}
                          </pre>
                        )}
                      </div>
                    </div>

                    {/* Client Signature */}
                    {contract.signature && (
                      <div className="bg-gray-50 dark:bg-gray-800/60 rounded-xl p-4">
                        <h4 className="text-md font-semibold text-gray-900 dark:text-white mb-3">Client Electronic Signature</h4>
                        <div className="text-lg font-semibold text-gray-900 dark:text-white" style={{fontFamily: 'Dancing Script, Brush Script MT, cursive'}}>
                          {contract.signature}
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                          Signed by: {contract.signerName || 'Unknown'}{contract.signerTitle ? ` (${contract.signerTitle})` : ''}{contract.signedAt ? ` on ${new Date(contract.signedAt).toLocaleString()}` : ''}
                        </div>
                      </div>
                    )}

                    {/* BBA Signature (if fully executed) */}
                    {contract.isFullyExecuted && contract.bbaSignature && (
                      <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4">
                        <h4 className="text-md font-semibold text-blue-900 dark:text-blue-100 mb-3">BBA Electronic Signature</h4>
                        <div className="text-lg font-semibold text-blue-900 dark:text-blue-100" style={{fontFamily: 'Dancing Script, Brush Script MT, cursive'}}>
                          {(() => {
                            const bbaFormData = contract.bbaSignature;
                            const signatureKeys = Object.keys(bbaFormData).filter(key => 
                              key.toLowerCase().includes('signature') && bbaFormData[key] && bbaFormData[key].trim().length > 0
                            );
                            if (signatureKeys.length > 0) {
                              return bbaFormData[signatureKeys[0]];
                            }
                            const nonEmptyValues = Object.values(bbaFormData).filter(value => 
                              value && typeof value === 'string' && value.trim().length > 0
                            );
                            return nonEmptyValues.length > 0 ? nonEmptyValues[0] : 'BBA Signature';
                          })()}
                        </div>
                        <div className="text-sm text-blue-700 dark:text-blue-300 mt-2">
                          {(() => {
                            let signerName = contract.bbaSignerName || contract.bbaName || 'Unknown';
                            let signDate = contract.bbaSignedAt || contract.bbaSignatureDate || contract.bbaDate || 'Unknown Date';
                            if (signerName === 'Unknown' && contract.bbaSignature) {
                              const bbaFormData = contract.bbaSignature;
                              const nameKeys = Object.keys(bbaFormData).filter(key => 
                                (key.includes('-bba-Name-') || key.toLowerCase().includes('name')) && 
                                bbaFormData[key] && typeof bbaFormData[key] === 'string' && bbaFormData[key].trim().length > 0
                              );
                              if (nameKeys.length > 0) {
                                signerName = bbaFormData[nameKeys[0]];
                              }
                            }
                            if (signDate === 'Unknown Date' && contract.bbaSignature) {
                              const bbaFormData = contract.bbaSignature;
                              const dateKeys = Object.keys(bbaFormData).filter(key => 
                                (key.includes('-bba-Date-') || key.toLowerCase().includes('date')) && 
                                bbaFormData[key] && typeof bbaFormData[key] === 'string' && bbaFormData[key].trim().length > 0
                              );
                              if (dateKeys.length > 0) {
                                signDate = bbaFormData[dateKeys[0]];
                              }
                            }
                            if (signDate !== 'Unknown Date' && signDate.includes('T')) {
                              try {
                                signDate = new Date(signDate).toLocaleString();
                              } catch (e) {}
                            }
                            return `Signed by: ${signerName} on ${signDate}`;
                          })()}
                        </div>
                      </div>
                    )}

                    {/* E-SIGN Act Compliance */}
                    {contract.eSignCompliance && (
                      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 rounded-lg p-4">
                        <h4 className="text-md font-semibold text-blue-900 dark:text-blue-100 mb-3">E-SIGN Act Compliance</h4>
                        <div className="space-y-2 text-sm">
                          <div className="flex items-center">
                            <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                            <span className="text-blue-800 dark:text-blue-200">
                              Electronic signature consent: {contract.eSignCompliance?.consentToElectronicSignatures ? 'Yes' : 'No'}
                            </span>
                          </div>
                          <div className="flex items-center">
                            <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                            <span className="text-blue-800 dark:text-blue-200">
                              Electronic records consent: {contract.eSignCompliance?.consentToElectronicRecords ? 'Yes' : 'No'}
                            </span>
                          </div>
                          {contract.eSignCompliance?.auditTrail?.signedDateTime && (
                            <>
                              <div className="flex items-center">
                                <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                                <span className="text-blue-800 dark:text-blue-200">
                                  Signed at: {new Date(contract.eSignCompliance.auditTrail.signedDateTime).toLocaleString()}
                                </span>
                              </div>
                              {contract.eSignCompliance.auditTrail.ipAddress && (
                                <div className="flex items-center">
                                  <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                                  <span className="text-blue-800 dark:text-blue-200">
                                    IP Address: {contract.eSignCompliance.auditTrail.ipAddress}
                                  </span>
                                </div>
                              )}
                              {contract.eSignCompliance.auditTrail.browser && (
                                <div className="flex items-center">
                                  <CheckCircle className="h-4 w-4 text-green-500 mr-2" />
                                  <span className="text-blue-800 dark:text-blue-200">
                                    Browser: {contract.eSignCompliance.auditTrail.browser} on {contract.eSignCompliance.auditTrail.device || 'Unknown Device'}
                                  </span>
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                ) : documentUrl ? (
                  <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg p-4">
                    <h4 className="text-md font-semibold text-gray-900 dark:text-white mb-3">Contract Document</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
                      View the contract document using the button below or the View PDF / Download PDF buttons.
                    </p>
                    <a
                      href={documentUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-4 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition-colors"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                      Open Contract in New Tab
                    </a>
                    <div className="mt-4 border border-gray-200 dark:border-gray-600 rounded-lg overflow-hidden bg-gray-100 dark:bg-gray-700" style={{ minHeight: '300px' }}>
                      <iframe
                        src={documentUrl}
                        title="Contract Document"
                        className="w-full"
                        style={{ height: '450px' }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 rounded-lg p-4">
                    <h4 className="text-md font-semibold text-amber-900 dark:text-amber-100 mb-2">No Contract Document Available</h4>
                    <p className="text-sm text-amber-800 dark:text-amber-200">
                      The contract status is completed but no document could be found. The contract may have been stored in a different format. Try re-uploading the contract if needed.
                    </p>
                  </div>
                );
                })()}
              </div>
            </div>
            
            <div className="flex justify-end space-x-3 mt-6 pt-4 border-t border-gray-200 dark:border-gray-600">
              <button
                onClick={handleViewContractPDF}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm"
              >
                View PDF
              </button>
              <button
                onClick={handleDownloadContractPDF}
                className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm"
              >
                Download PDF
              </button>
              <button
                onClick={() => setShowContractModal(false)}
                className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      </div>
    </div>
  );
};

export default ClientOverview; 
